(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9487],{

/***/ 93150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TeaserFlag_TeaserFlag; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/elements/TeaserFlag/TeaserFlag.module.scss
var TeaserFlag_module = __webpack_require__(33825);
var TeaserFlag_module_default = /*#__PURE__*/__webpack_require__.n(TeaserFlag_module);
;// CONCATENATED MODULE: ./src/components/elements/TeaserFlag/TeaserFlag.tsx


var TeaserFlag = function(param) {
    var text = param.text, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((TeaserFlag_module_default()).root, " ").concat(className),
        children: text
    });
};
/* harmony default export */ var TeaserFlag_TeaserFlag = (TeaserFlag);

;// CONCATENATED MODULE: ./src/components/elements/TeaserFlag/index.ts



/***/ }),

/***/ 80814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelFilterForm_TravelFilterForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterForm/TravelFilterForm.module.scss
var TravelFilterForm_module = __webpack_require__(56157);
var TravelFilterForm_module_default = /*#__PURE__*/__webpack_require__.n(TravelFilterForm_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Badge.js
var Badge = __webpack_require__(27977);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 11 modules
var Form = __webpack_require__(28431);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/features/travelFilter/helpers.ts
var helpers = __webpack_require__(82700);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterInput/FilterInput.module.scss
var FilterInput_module = __webpack_require__(30465);
var FilterInput_module_default = /*#__PURE__*/__webpack_require__.n(FilterInput_module);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterInput/FilterInput.tsx



var FilterInput = function(param) {
    var name = param.name, label = param.label, Selector = param.Selector, setOpen = param.setOpen, isOpen = param.isOpen, _colSize = param.colSize, colSize = _colSize === void 0 ? 4 : _colSize;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                as: Col/* default */.Z,
                lg: colSize,
                "data-name": name,
                className: "form-group filter-input",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((FilterInput_module_default()).fakeSelect, " ").concat(isOpen && (FilterInput_module_default()).active),
                    onClick: setOpen,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FilterInput_module_default()).label,
                        children: label
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                as: Col/* default */.Z,
                xs: "12",
                className: "mb-2 order-lg-last ".concat((FilterInput_module_default()).filterOptionsWrap, " ").concat(isOpen && (FilterInput_module_default()).active),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: Selector
                })
            })
        ]
    });
};
/* harmony default export */ var FilterInput_FilterInput = (FilterInput);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterNav/FilterInput/index.tsx


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/app/providers/AppConfigProvider.tsx
var AppConfigProvider = __webpack_require__(43953);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/integrations/tracking/useTracking.tsx + 4 modules
var useTracking = __webpack_require__(624);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterForm/TravelFilterForm.tsx













var CheckboxFilterSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6908).then(__webpack_require__.bind(__webpack_require__, 96908));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96908)
            ];
        }
    },
    ssr: false
});
var MonthFilterSelector = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 506).then(__webpack_require__.bind(__webpack_require__, 20506));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20506)
            ];
        }
    },
    ssr: false
});
var calcInputColSize = function(appConfig) {
    var inputCount = 0;
    if (appConfig.travelFilter.inputs.destinations.enabled) {
        inputCount++;
    }
    if (appConfig.travelFilter.inputs.months.enabled) {
        inputCount++;
    }
    if (appConfig.travelFilter.inputs.travelTypes.enabled) {
        inputCount++;
    }
    return inputCount ? Math.floor(12 / inputCount) : 12;
};
var TravelFilterForm = function(param) {
    var setUrlQueryString = param.setUrlQueryString, _onChangeFilterSelection = param.onChangeFilterSelection, onChangeFilterSelection = _onChangeFilterSelection === void 0 ? function() {} : _onChangeFilterSelection;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var send = (0,useTracking/* useTracking */.r)().send;
    var appConfig = (0,react.useContext)(AppConfigProvider/* AppConfigContext */.J);
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    var updateUrl = function() {
        setUrlQueryString((0,helpers/* buildTravelFilterUrlQuery */.ye)(filterState.filterSelections, filterState.query));
    };
    /** execute **/ var applyFilter = function() {
        executeFilterQuery();
        setOpenFilter("");
        onChangeFilterSelection((0,helpers/* buildTravelFilterUrlQuery */.ye)(filterState.filterSelections, filterState.query));
    };
    var executeFilterQuery = function() {
        if (filterState.initialized) {
            updateUrl();
            dispatch((0,travelFilter/* executeTravelFilterRequest */.Iv)({}));
            send.genericEvent({
                category: "travel_filter",
                object: "filter",
                action: "execute",
                data: {}
            });
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var debouncedExecuteFilterQuery = (0,react.useCallback)(lodash_debounce_default()(function() {
        executeFilterQuery();
        if (filterState.query) {
            send.genericEvent({
                category: "travel_filter",
                object: "text_search",
                action: "input",
                data: {
                    filter_search_text: filterState.query
                }
            });
        }
    }, 500), [
        filterState.query
    ]);
    (0,react.useEffect)(function() {
        debouncedExecuteFilterQuery();
        // Cancel the debounced function in case it's still waiting to run when the component unmounts
        return debouncedExecuteFilterQuery.cancel;
    }, [
        debouncedExecuteFilterQuery
    ]);
    (0,react.useEffect)(function() {
        updateUrl();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterState.updateUrlTrigger
    ]);
    /** filter query **/ var setFilterQuery = function(event) {
        dispatch((0,travelFilter/* setTravelFilterQuery */.fo)({
            query: event.target.value
        }));
    };
    /** filter inputs **/ var ref = (0,react.useState)(""), openedFilter = ref[0], setOpenFilter = ref[1];
    var toggleFilter = function(name) {
        // execute query if any filter closing
        if (openedFilter) {
            executeFilterQuery();
        }
        // handle open state
        if (openedFilter === name) {
            setOpenFilter("");
            send.genericEvent({
                category: "travel_filter",
                object: "filter_type",
                action: "close",
                data: {
                    filter_type_name: name
                }
            });
        } else {
            setOpenFilter(name);
            send.genericEvent({
                category: "travel_filter",
                object: "filter_type",
                action: "open",
                data: {
                    filter_type_name: name
                }
            });
        }
    };
    var setFilterSelection = function(param) {
        var name = param.name, selection = param.selection;
        dispatch((0,travelFilter/* setTravelFilterSelection */.rL)({
            name: name,
            selection: selection
        }));
        executeFilterQuery();
    };
    var getFilterInputLabel = function(name) {
        var badge = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (filterState.filterSelections) {
            var selection = filterState.filterSelections[name];
            if (selection.length > 0) {
                badge = /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                    pill: true,
                    className: (TravelFilterForm_module_default()).inputSelectedCountBadge,
                    children: selection.length
                });
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                t("travelFilter.inputLabels." + name),
                badge
            ]
        });
    };
    var getFilterFromState = function(name) {
        return filterState.filters.find(function(filter) {
            return filter.name === name;
        });
    };
    var getFilterSelection = function(name) {
        return filterState.filterSelections ? filterState.filterSelections[name] : [];
    };
    var inputColSize = calcInputColSize(appConfig);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                className: (TravelFilterForm_module_default()).root,
                children: [
                    appConfig.travelFilter.inputs.destinations.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput_FilterInput, {
                        name: "destination",
                        label: getFilterInputLabel("destinations"),
                        Selector: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxFilterSelector, {
                            filter: getFilterFromState("destinations"),
                            selection: getFilterSelection("destinations"),
                            setSelection: function(selection) {
                                return setFilterSelection({
                                    name: "destinations",
                                    selection: selection
                                });
                            },
                            applySelection: applyFilter
                        }),
                        setOpen: function() {
                            return toggleFilter("destination");
                        },
                        isOpen: openedFilter === "destination",
                        colSize: inputColSize
                    }),
                    appConfig.travelFilter.inputs.months.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput_FilterInput, {
                        name: "months",
                        label: getFilterInputLabel("months"),
                        Selector: /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthFilterSelector, {
                            filter: getFilterFromState("months"),
                            selection: getFilterSelection("months"),
                            setSelection: function(selection) {
                                return setFilterSelection({
                                    name: "months",
                                    selection: selection
                                });
                            },
                            applySelection: applyFilter
                        }),
                        setOpen: function() {
                            return toggleFilter("months");
                        },
                        isOpen: openedFilter === "months",
                        colSize: inputColSize
                    }),
                    appConfig.travelFilter.inputs.travelTypes.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterInput_FilterInput, {
                        name: "travelTypes",
                        label: getFilterInputLabel("travelTypes"),
                        Selector: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxFilterSelector, {
                            filter: getFilterFromState("travelTypes"),
                            selection: getFilterSelection("travelTypes"),
                            setSelection: function(selection) {
                                return setFilterSelection({
                                    name: "travelTypes",
                                    selection: selection
                                });
                            },
                            applySelection: applyFilter
                        }),
                        setOpen: function() {
                            return toggleFilter("travelType");
                        },
                        isOpen: openedFilter === "travelType",
                        colSize: inputColSize
                    })
                ]
            }),
            appConfig.travelFilter.inputs.query.enabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: (TravelFilterForm_module_default()).root,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                    as: Col/* default */.Z,
                    xs: "12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                        type: "text",
                        name: "query",
                        placeholder: t("travelFilter.inputLabels.query"),
                        className: (TravelFilterForm_module_default()).input,
                        value: filterState.query,
                        onChange: setFilterQuery
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TravelFilterForm_TravelFilterForm = (TravelFilterForm);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterForm/index.ts



/***/ }),

/***/ 14664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelFilterInfoAndReset_TravelFilterInfoAndReset; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/TravelFilterInfoAndReset.module.scss
var TravelFilterInfoAndReset_module = __webpack_require__(989);
var TravelFilterInfoAndReset_module_default = /*#__PURE__*/__webpack_require__.n(TravelFilterInfoAndReset_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/TravelFilterInfoAndReset.tsx






var TravelFilterInfoAndReset = function() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    var resetFilter = function() {
        dispatch((0,travelFilter/* resetTravelFilter */.t)({}));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TravelFilterInfoAndReset_module_default()).resultInfo,
                children: t("travelFilter.resultInfo", {
                    count: filterState.counts.filteredTotal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: "btn-unstyled ".concat((TravelFilterInfoAndReset_module_default()).resetBtn),
                onClick: resetFilter,
                "data-tr-click": "travel_filter:filter_reset:click",
                children: [
                    "\xbb ",
                    t("travelFilter.button.reset")
                ]
            })
        ]
    });
};
/* harmony default export */ var TravelFilterInfoAndReset_TravelFilterInfoAndReset = (TravelFilterInfoAndReset);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterInfoAndReset/index.ts



/***/ }),

/***/ 18455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelFilterResultList_TravelFilterResultList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile/TravelResultItemTile.module.scss
var TravelResultItemTile_module = __webpack_require__(20794);
var TravelResultItemTile_module_default = /*#__PURE__*/__webpack_require__.n(TravelResultItemTile_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(6498);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
// EXTERNAL MODULE: ./src/lib/helpers/travel.ts
var helpers_travel = __webpack_require__(87086);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/components/elements/TeaserFlag/index.ts + 1 modules
var TeaserFlag = __webpack_require__(93150);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile/TravelResultItemTile.tsx









var buildLabel = function(travel, t) {
    if ((0,helpers/* isTodayOrEarlier */.is)(new Date(travel.startDate))) {
        return t("travel.nowOnTour");
    }
    if (travel.label) {
        return travel.label;
    }
    return null;
};
var TravelResultItemTile = function(param) {
    var travel = param.travel, trackingStringPrefix = param.trackingStringPrefix;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var label = buildLabel(travel, t);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/tour/".concat(travel.urlSlug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (TravelResultItemTile_module_default()).wrap,
            "data-tr-click": "".concat(trackingStringPrefix, "_travel_teaser:click"),
            "data-tr-view": "".concat(trackingStringPrefix, "_travel_teaser:view"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                className: (TravelResultItemTile_module_default()).card + " an-up",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "img-ratio-16-9",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: travel.mainImage,
                            className: "card-img",
                            altDefault: travel.name,
                            aspectRatio: 1.777,
                            width: 524,
                            responsive: false,
                            placeholderClassName: "position-absolute"
                        })
                    }),
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(TeaserFlag/* default */.Z, {
                        text: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                        className: (TravelResultItemTile_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                className: (TravelResultItemTile_module_default()).title,
                                children: travel.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                as: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelResultItemTile_module_default()).date,
                                        children: (0,helpers_travel/* buildFilterTravelDatesLabel */.KP)(travel, t)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TravelResultItemTile_module_default()).price,
                                        children: "".concat(t("booking.priceFrom"), " ").concat((0,helpers/* formatPrice */.T4)(travel.minPrice, travel.currency))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TravelResultItemTile_TravelResultItemTile = (TravelResultItemTile);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelResultItemTile/index.tsx


// EXTERNAL MODULE: ./src/app/hooks.ts
var hooks = __webpack_require__(98324);
// EXTERNAL MODULE: ./src/features/travelFilter/index.ts + 1 modules
var travelFilter = __webpack_require__(32322);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
;// CONCATENATED MODULE: ./src/entities/user/graphql.ts
// language=GraphQL
var ALL_USERS_QUERY = "query Query($withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n  users: users {\n    id\n    email\n    firstName\n    lastName\n    role @include(if: $withRole) {\n      id\n      name\n      description\n      permissions @include(if: $withRolePermissions) {\n        id\n        path\n        module\n        name\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_USER_QUERY = "query Query($id: ID!, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n  user: user(id: $id) {\n    id\n    email\n    firstName\n    lastName\n    role @include(if: $withRole) {\n      id\n      name\n      description\n      permissions @include(if: $withRolePermissions) {\n        id\n        path\n        module\n        name\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_USER_MUTATION = "\n  mutation Mutation($input: CreateUserInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n    user: createUser(input: $input) {\n      id\n      email\n      firstName\n      lastName\n      role @include(if: $withRole) {\n        id\n        name\n        description\n        permissions @include(if: $withRolePermissions) {\n          id\n          path\n          module\n          name\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_USER_MUTATION = "\n  mutation Mutation($input: UpdateUserInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n    user: updateUser(input: $input) {\n      id\n      email\n      firstName\n      lastName\n      role @include(if: $withRole) {\n        id\n        name\n        description\n        permissions @include(if: $withRolePermissions) {\n          id\n          path\n          module\n          name\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_USER_MUTATION = "\n  mutation Mutation($input: DeleteUserInput) {\n    deleteUser(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_USER_MUTATION = "\n  mutation Mutation($input: DeleteUserInput) {\n    forceDeleteUser(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/rbacRole/graphql.ts
// language=GraphQL
var ALL_ROLES_QUERY = "query Query($withPermissions: Boolean = false) {\n  roles: rbacRoles {\n    id\n    name\n    description\n    permissions @include(if: $withPermissions) {\n      id\n      path\n      module\n      name\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ROLE_QUERY = "query Query($id: ID!, $withPermissions: Boolean = false) {\n  role: rbacRole(id: $id) {\n    id\n    name\n    description\n    permissions @include(if: $withPermissions) {\n      id\n      path\n      module\n      name\n    }\n  }\n}";
// language=GraphQL
var CREATE_ROLE_MUTATION = "\n  mutation Mutation($input: CreateRbacRoleInput, $withPermissions: Boolean = false) {\n    role: createRbacRole(input: $input) {\n      id\n      name\n      description\n      permissions @include(if: $withPermissions) {\n        id\n        path\n        module\n        name\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ROLE_MUTATION = "\n  mutation Mutation($input: UpdateRbacRoleInput, $withPermissions: Boolean = false) {\n    role: updateRbacRole(input: $input) {\n      id\n      name\n      description\n      permissions @include(if: $withPermissions) {\n        id\n        path\n        module\n        name\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ROLE_MUTATION = "\n  mutation Mutation($input: DeleteRbacRoleInput) {\n    deleteRbacRole(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ROLE_MUTATION = "\n  mutation Mutation($input: DeleteRbacRoleInput) {\n    forceDeleteRbacRole(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ROLE_PERMISSIONS_MUTATION = "\n  mutation Mutation($input: addRbacRolePermissionsInput) {\n    addRbacRolePermissions(input: $input) {\n      id\n      permissionIds\n    }\n  }";
// language=GraphQL
var REMOVE_ROLE_PERMISSIONS_MUTATION = "\n  mutation Mutation($input: removeRbacRolePermissionsInput) {\n    removeRbacRolePermissions(input: $input) {\n      id\n      permissionIds\n    }\n  }";
// language=GraphQL
var CREATE_ROLE_PERMISSIONS_MUTATION = "\n  mutation Mutation($input: createRbacRolePermissionsInput) {\n    createRbacRolePermissions(input: $input) {\n      id\n      permissionIds\n    }\n  }";
// language=GraphQL
var DELETE_ROLE_PERMISSIONS_MUTATION = "\n  mutation Mutation($input: deleteRbacRolePermissionsInput) {\n    deleteRbacRolePermissions(input: $input) {\n      id\n      permissionIds\n    }\n  }";
// language=GraphQL
var ROLES_DEPENDENTS_QUERY = "query Query($id: ID!, $withUsers: Boolean = false, $withApiKeys: Boolean = false) {\n  groupedDependents: rbacRoleDependents(id: $id) {\n    users @include(if: $withUsers) {\n      id\n      email\n      firstName\n      lastName\n    }\n    apiKeys @include(if: $withApiKeys) {\n      id\n      name\n      key\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/rbacPermission/graphql.ts
// language=GraphQL
var ALL_PERMISSIONS_QUERY = "query Query {\n  permissions: rbacPermissions {\n    id\n    path\n    module\n    name\n  }\n}";
// language=GraphQL
var SINGLE_PERMISSION_QUERY = "query Query($id: ID!) {\n  permission: rbacPermission(id: $id) {\n    id\n    path\n    module\n    name\n  }\n}";
// language=GraphQL
var CREATE_PERMISSION_MUTATION = "\n  mutation Mutation($input: CreateRbacPermissionInput) {\n    permission: createRbacPermission(input: $input) {\n      id\n      path\n      module\n      name\n    }\n  }";
// language=GraphQL
var UPDATE_PERMISSION_MUTATION = "\n  mutation Mutation($input: UpdateRbacPermissionInput) {\n    permission: updateRbacPermission(input: $input) {\n      id\n      path\n      module\n      name\n    }\n  }";
// language=GraphQL
var DELETE_PERMISSION_MUTATION = "\n  mutation Mutation($input: DeleteRbacPermissionInput) {\n    deleteRbacPermission(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PERMISSION_MUTATION = "\n  mutation Mutation($input: DeleteRbacPermissionInput) {\n    forceDeleteRbacPermission(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var PERMISSIONS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRbacRoles: Boolean = false) {\n  groupedDependents: rbacPermissionDependents(id: $id) {\n    rbacRoles @include(if: $withRbacRoles) {\n      id\n      name\n      description\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/rbacPermission/model.ts

var rbacPermissionModel = {
    name: "permission",
    namePlural: "permissions",
    uniqueName: "rbacPermission",
    uniqueNamePlural: "rbacPermissions",
    path: "iam/rbac/permission",
    baseUrl: "/iam/rbac/permissions",
    translationPrefix: "entities:rbacPermission.",
    getDisplayName: function(values) {
        return values.path;
    },
    gql: {
        getAll: ALL_PERMISSIONS_QUERY,
        getSingle: SINGLE_PERMISSION_QUERY,
        create: CREATE_PERMISSION_MUTATION,
        update: UPDATE_PERMISSION_MUTATION,
        delete: DELETE_PERMISSION_MUTATION,
        forceDelete: FORCE_DELETE_PERMISSION_MUTATION
    },
    attributes: {
        path: {
            name: "path",
            label: "entities:rbacPermission.attributes.path.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        module: {
            name: "module",
            label: "entities:rbacPermission.attributes.module.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        name: {
            name: "name",
            label: "entities:rbacPermission.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var model = (rbacPermissionModel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/entities/lib.ts
var lib = __webpack_require__(23480);
// EXTERNAL MODULE: ./src/lib/api/graphQLClient.ts
var graphQLClient = __webpack_require__(40112);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/entities/rbacPermission/repository.ts










var hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(model, object);
    });
};
var hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(model, object);
};
var rbacPermissionRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PERMISSION_QUERY, variables).then(function(data) {
                        return hydrateObject(data.permission);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PERMISSIONS_QUERY, includes).then(function(data) {
                    return hydrateObjects(data.permissions);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PERMISSION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : hydrateObject(data.permission),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PERMISSIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : hydrateObjects(data.permissions),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(PERMISSIONS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            PERMISSIONS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PERMISSION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.permission);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PERMISSION_MUTATION, variables).then(function(data) {
                        return hydrateObject(data.permission);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PERMISSION_MUTATION, variables).then(function(data) {
                        return data.deleteRbacPermission;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PERMISSION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRbacPermission;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var repository = (rbacPermissionRepository);

;// CONCATENATED MODULE: ./src/entities/rbacPermission/entity.ts


var rbacPermissionEntity = {
    model: model,
    repository: repository
};
/* harmony default export */ var entity = (rbacPermissionEntity);

;// CONCATENATED MODULE: ./src/entities/rbacRole/model.ts


var rbacRoleModel = {
    name: "role",
    namePlural: "roles",
    uniqueName: "rbacRole",
    uniqueNamePlural: "rbacRoles",
    path: "iam/rbac/role",
    baseUrl: "/iam/roles",
    translationPrefix: "entities:rbacRole.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_ROLES_QUERY,
        getSingle: SINGLE_ROLE_QUERY,
        create: CREATE_ROLE_MUTATION,
        update: UPDATE_ROLE_MUTATION,
        delete: DELETE_ROLE_MUTATION,
        forceDelete: FORCE_DELETE_ROLE_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:rbacRole.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        description: {
            name: "description",
            label: "entities:rbacRole.attributes.description.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        permissions: {
            name: "permissions",
            label: "entities:rbacRole.attributes.permissions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return entity;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var rbacRole_model = (rbacRoleModel);

;// CONCATENATED MODULE: ./src/entities/rbacRole/repository.ts










var repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(rbacRole_model, object);
    });
};
var repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(rbacRole_model, object);
};
var rbacRoleRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ROLE_QUERY, variables).then(function(data) {
                        return repository_hydrateObject(data.role);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ROLES_QUERY, includes).then(function(data) {
                    return repository_hydrateObjects(data.roles);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ROLE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : repository_hydrateObject(data.role),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ROLES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : repository_hydrateObjects(data.roles),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ROLES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ROLES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ROLE_MUTATION, variables).then(function(data) {
                        return repository_hydrateObject(data.role);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ROLE_MUTATION, variables).then(function(data) {
                        return repository_hydrateObject(data.role);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ROLE_MUTATION, variables).then(function(data) {
                        return data.deleteRbacRole;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ROLE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRbacRole;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignPermissions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        permissionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ROLE_PERMISSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignPermissions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        permissionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ROLE_PERMISSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPermissions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        permissions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ROLE_PERMISSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deletePermissions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        permissionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ROLE_PERMISSIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var rbacRole_repository = (rbacRoleRepository);

;// CONCATENATED MODULE: ./src/entities/rbacRole/entity.ts


var rbacRoleEntity = {
    model: rbacRole_model,
    repository: rbacRole_repository
};
/* harmony default export */ var rbacRole_entity = (rbacRoleEntity);

;// CONCATENATED MODULE: ./src/entities/user/model.ts


var userModel = {
    name: "user",
    namePlural: "users",
    uniqueName: "user",
    uniqueNamePlural: "users",
    path: "iam/user",
    baseUrl: "/iam/users",
    translationPrefix: "entities:user.",
    getDisplayName: function(values) {
        return "".concat(values.firstName, " ").concat(values.lastName);
    },
    gql: {
        getAll: ALL_USERS_QUERY,
        getSingle: SINGLE_USER_QUERY,
        create: CREATE_USER_MUTATION,
        update: UPDATE_USER_MUTATION,
        delete: DELETE_USER_MUTATION,
        forceDelete: FORCE_DELETE_USER_MUTATION
    },
    attributes: {
        email: {
            name: "email",
            label: "entities:user.attributes.email.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "email"
                }, 
            ]
        },
        firstName: {
            name: "firstName",
            label: "entities:user.attributes.firstName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        lastName: {
            name: "lastName",
            label: "entities:user.attributes.lastName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        role: {
            name: "role",
            label: "entities:user.attributes.role.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return rbacRole_entity;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var user_model = (userModel);

;// CONCATENATED MODULE: ./src/entities/user/repository.ts









var user_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(user_model, object);
    });
};
var user_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(user_model, object);
};
var userRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_USER_QUERY, variables).then(function(data) {
                        return user_repository_hydrateObject(data.user);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_USERS_QUERY, includes).then(function(data) {
                    return user_repository_hydrateObjects(data.users);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_USER_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : user_repository_hydrateObject(data.user),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_USERS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : user_repository_hydrateObjects(data.users),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_USER_MUTATION, variables).then(function(data) {
                        return user_repository_hydrateObject(data.user);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_USER_MUTATION, variables).then(function(data) {
                        return user_repository_hydrateObject(data.user);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_USER_MUTATION, variables).then(function(data) {
                        return data.deleteUser;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_USER_MUTATION, variables).then(function(data) {
                        return data.forceDeleteUser;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var user_repository = (userRepository);

;// CONCATENATED MODULE: ./src/entities/user/entity.ts


var userEntity = {
    model: user_model,
    repository: user_repository
};
/* harmony default export */ var user_entity = ((/* unused pure expression or super */ null && (userEntity)));

// EXTERNAL MODULE: ./src/entities/tenant/entity.ts + 3 modules
var tenant_entity = __webpack_require__(57850);
;// CONCATENATED MODULE: ./src/entities/language/graphql.ts
// language=GraphQL
var ALL_LANGUAGES_QUERY = "query Query {\n  languages: languages {\n    id\n    name\n    slug\n  }\n}";
// language=GraphQL
var SINGLE_LANGUAGE_QUERY = "query Query($id: ID!) {\n  language: language(id: $id) {\n    id\n    name\n    slug\n  }\n}";
// language=GraphQL
var CREATE_LANGUAGE_MUTATION = "\n  mutation Mutation($input: CreateLanguageInput) {\n    language: createLanguage(input: $input) {\n      id\n      name\n      slug\n    }\n  }";
// language=GraphQL
var UPDATE_LANGUAGE_MUTATION = "\n  mutation Mutation($input: UpdateLanguageInput) {\n    language: updateLanguage(input: $input) {\n      id\n      name\n      slug\n    }\n  }";
// language=GraphQL
var DELETE_LANGUAGE_MUTATION = "\n  mutation Mutation($input: DeleteLanguageInput) {\n    deleteLanguage(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_LANGUAGE_MUTATION = "\n  mutation Mutation($input: DeleteLanguageInput) {\n    forceDeleteLanguage(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/language/model.ts

var languageModel = {
    name: "language",
    namePlural: "languages",
    uniqueName: "language",
    uniqueNamePlural: "languages",
    path: "config/language",
    baseUrl: "/config/languages",
    translationPrefix: "entities:language.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_LANGUAGES_QUERY,
        getSingle: SINGLE_LANGUAGE_QUERY,
        create: CREATE_LANGUAGE_MUTATION,
        update: UPDATE_LANGUAGE_MUTATION,
        delete: DELETE_LANGUAGE_MUTATION,
        forceDelete: FORCE_DELETE_LANGUAGE_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:language.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        slug: {
            name: "slug",
            label: "entities:language.attributes.slug.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var language_model = (languageModel);

;// CONCATENATED MODULE: ./src/entities/language/repository.ts









var language_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(language_model, object);
    });
};
var language_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(language_model, object);
};
var languageRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_LANGUAGE_QUERY, variables).then(function(data) {
                        return language_repository_hydrateObject(data.language);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_LANGUAGES_QUERY, includes).then(function(data) {
                    return language_repository_hydrateObjects(data.languages);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_LANGUAGE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : language_repository_hydrateObject(data.language),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_LANGUAGES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : language_repository_hydrateObjects(data.languages),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_LANGUAGE_MUTATION, variables).then(function(data) {
                        return language_repository_hydrateObject(data.language);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_LANGUAGE_MUTATION, variables).then(function(data) {
                        return language_repository_hydrateObject(data.language);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_LANGUAGE_MUTATION, variables).then(function(data) {
                        return data.deleteLanguage;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_LANGUAGE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteLanguage;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var language_repository = (languageRepository);

;// CONCATENATED MODULE: ./src/entities/language/entity.ts


var languageEntity = {
    model: language_model,
    repository: language_repository
};
/* harmony default export */ var language_entity = ((/* unused pure expression or super */ null && (languageEntity)));

;// CONCATENATED MODULE: ./src/entities/currency/graphql.ts
// language=GraphQL
var ALL_CURRENCIES_QUERY = "query Query {\n  currencies: currencies {\n    id\n    name\n    symbol\n  }\n}";
// language=GraphQL
var SINGLE_CURRENCY_QUERY = "query Query($id: ID!) {\n  currency: currency(id: $id) {\n    id\n    name\n    symbol\n  }\n}";
// language=GraphQL
var CREATE_CURRENCY_MUTATION = "\n  mutation Mutation($input: CreateCurrencyInput) {\n    currency: createCurrency(input: $input) {\n      id\n      name\n      symbol\n    }\n  }";
// language=GraphQL
var UPDATE_CURRENCY_MUTATION = "\n  mutation Mutation($input: UpdateCurrencyInput) {\n    currency: updateCurrency(input: $input) {\n      id\n      name\n      symbol\n    }\n  }";
// language=GraphQL
var DELETE_CURRENCY_MUTATION = "\n  mutation Mutation($input: DeleteCurrencyInput) {\n    deleteCurrency(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CURRENCY_MUTATION = "\n  mutation Mutation($input: DeleteCurrencyInput) {\n    forceDeleteCurrency(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/currency/model.ts

var currencyModel = {
    name: "currency",
    namePlural: "currencies",
    uniqueName: "currency",
    uniqueNamePlural: "currencies",
    path: "config/currency",
    baseUrl: "/config/currencies",
    translationPrefix: "entities:currency.",
    getDisplayName: function(values) {
        return values.name;
    },
    gql: {
        getAll: ALL_CURRENCIES_QUERY,
        getSingle: SINGLE_CURRENCY_QUERY,
        create: CREATE_CURRENCY_MUTATION,
        update: UPDATE_CURRENCY_MUTATION,
        delete: DELETE_CURRENCY_MUTATION,
        forceDelete: FORCE_DELETE_CURRENCY_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:currency.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        symbol: {
            name: "symbol",
            label: "entities:currency.attributes.symbol.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var currency_model = (currencyModel);

;// CONCATENATED MODULE: ./src/entities/currency/repository.ts









var currency_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(currency_model, object);
    });
};
var currency_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(currency_model, object);
};
var currencyRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CURRENCY_QUERY, variables).then(function(data) {
                        return currency_repository_hydrateObject(data.currency);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CURRENCIES_QUERY, includes).then(function(data) {
                    return currency_repository_hydrateObjects(data.currencies);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CURRENCY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : currency_repository_hydrateObject(data.currency),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CURRENCIES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : currency_repository_hydrateObjects(data.currencies),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CURRENCY_MUTATION, variables).then(function(data) {
                        return currency_repository_hydrateObject(data.currency);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CURRENCY_MUTATION, variables).then(function(data) {
                        return currency_repository_hydrateObject(data.currency);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CURRENCY_MUTATION, variables).then(function(data) {
                        return data.deleteCurrency;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CURRENCY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCurrency;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var currency_repository = (currencyRepository);

;// CONCATENATED MODULE: ./src/entities/currency/entity.ts


var currencyEntity = {
    model: currency_model,
    repository: currency_repository
};
/* harmony default export */ var currency_entity = ((/* unused pure expression or super */ null && (currencyEntity)));

// EXTERNAL MODULE: ./src/entities/cmsCategory/entity.ts + 3 modules
var cmsCategory_entity = __webpack_require__(4377);
// EXTERNAL MODULE: ./src/entities/tenantCms/entity.ts + 3 modules
var tenantCms_entity = __webpack_require__(57442);
// EXTERNAL MODULE: ./src/entities/cmsPage/entity.ts + 3 modules
var cmsPage_entity = __webpack_require__(49647);
// EXTERNAL MODULE: ./src/entities/cmsContentBlockAssignment/entity.ts + 3 modules
var cmsContentBlockAssignment_entity = __webpack_require__(94850);
// EXTERNAL MODULE: ./src/entities/cmsTextWithImageBlock/entity.ts + 3 modules
var cmsTextWithImageBlock_entity = __webpack_require__(63409);
;// CONCATENATED MODULE: ./src/entities/cmsTextBlock/graphql.ts
// language=GraphQL
var ALL_TEXT_BLOCKS_QUERY = "query Query {\n  textBlocks: cmsTextBlocks {\n    id\n    text\n  }\n}";
// language=GraphQL
var SINGLE_TEXT_BLOCK_QUERY = "query Query($id: ID!) {\n  textBlock: cmsTextBlock(id: $id) {\n    id\n    text\n  }\n}";
// language=GraphQL
var CREATE_TEXT_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsTextBlockInput) {\n    textBlock: createCmsTextBlock(input: $input) {\n      id\n      text\n    }\n  }";
// language=GraphQL
var UPDATE_TEXT_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsTextBlockInput) {\n    textBlock: updateCmsTextBlock(input: $input) {\n      id\n      text\n    }\n  }";
// language=GraphQL
var DELETE_TEXT_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTextBlockInput) {\n    deleteCmsTextBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TEXT_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTextBlockInput) {\n    forceDeleteCmsTextBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsTextBlock/model.ts

var cmsTextBlockModel = {
    name: "textBlock",
    namePlural: "textBlocks",
    uniqueName: "cmsTextBlock",
    uniqueNamePlural: "cmsTextBlocks",
    path: "cms/blocks/text_block",
    baseUrl: "/cms/blocks/text_blocks",
    translationPrefix: "entities:cmsTextBlock.",
    getDisplayName: function(values) {
        return "Text block";
    },
    gql: {
        getAll: ALL_TEXT_BLOCKS_QUERY,
        getSingle: SINGLE_TEXT_BLOCK_QUERY,
        create: CREATE_TEXT_BLOCK_MUTATION,
        update: UPDATE_TEXT_BLOCK_MUTATION,
        delete: DELETE_TEXT_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_TEXT_BLOCK_MUTATION
    },
    attributes: {
        text: {
            name: "text",
            label: "entities:cmsTextBlock.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var cmsTextBlock_model = (cmsTextBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsTextBlock/repository.ts









var cmsTextBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsTextBlock_model, object);
    });
};
var cmsTextBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsTextBlock_model, object);
};
var cmsTextBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TEXT_BLOCK_QUERY, variables).then(function(data) {
                        return cmsTextBlock_repository_hydrateObject(data.textBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TEXT_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsTextBlock_repository_hydrateObjects(data.textBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TEXT_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsTextBlock_repository_hydrateObject(data.textBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TEXT_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsTextBlock_repository_hydrateObjects(data.textBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TEXT_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTextBlock_repository_hydrateObject(data.textBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TEXT_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTextBlock_repository_hydrateObject(data.textBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TEXT_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsTextBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TEXT_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsTextBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsTextBlock_repository = (cmsTextBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsTextBlock/entity.ts


var cmsTextBlockEntity = {
    model: cmsTextBlock_model,
    repository: cmsTextBlock_repository
};
/* harmony default export */ var cmsTextBlock_entity = ((/* unused pure expression or super */ null && (cmsTextBlockEntity)));

// EXTERNAL MODULE: ./src/entities/mediaFile/entity.ts + 3 modules
var mediaFile_entity = __webpack_require__(24180);
;// CONCATENATED MODULE: ./src/entities/cmsHeadingBlock/graphql.ts
// language=GraphQL
var ALL_HEADING_BLOCKS_QUERY = "query Query {\n  headingBlocks: cmsHeadingBlocks {\n    id\n    importance\n    heading\n    addon\n    decoration\n  }\n}";
// language=GraphQL
var SINGLE_HEADING_BLOCK_QUERY = "query Query($id: ID!) {\n  headingBlock: cmsHeadingBlock(id: $id) {\n    id\n    importance\n    heading\n    addon\n    decoration\n  }\n}";
// language=GraphQL
var CREATE_HEADING_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsHeadingBlockInput) {\n    headingBlock: createCmsHeadingBlock(input: $input) {\n      id\n      importance\n      heading\n      addon\n      decoration\n    }\n  }";
// language=GraphQL
var UPDATE_HEADING_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsHeadingBlockInput) {\n    headingBlock: updateCmsHeadingBlock(input: $input) {\n      id\n      importance\n      heading\n      addon\n      decoration\n    }\n  }";
// language=GraphQL
var DELETE_HEADING_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsHeadingBlockInput) {\n    deleteCmsHeadingBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_HEADING_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsHeadingBlockInput) {\n    forceDeleteCmsHeadingBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsHeadingBlock/model.ts

var cmsHeadingBlockModel = {
    name: "headingBlock",
    namePlural: "headingBlocks",
    uniqueName: "cmsHeadingBlock",
    uniqueNamePlural: "cmsHeadingBlocks",
    path: "cms/blocks/heading_block",
    baseUrl: "/cms/blocks/heading_blocks",
    translationPrefix: "entities:cmsHeadingBlock.",
    getDisplayName: function(values) {
        return values.heading;
    },
    gql: {
        getAll: ALL_HEADING_BLOCKS_QUERY,
        getSingle: SINGLE_HEADING_BLOCK_QUERY,
        create: CREATE_HEADING_BLOCK_MUTATION,
        update: UPDATE_HEADING_BLOCK_MUTATION,
        delete: DELETE_HEADING_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_HEADING_BLOCK_MUTATION
    },
    attributes: {
        importance: {
            name: "importance",
            label: "entities:cmsHeadingBlock.attributes.importance.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsHeadingBlock.attributes.importance.selectOptions.1.label",
                    value: "1"
                },
                {
                    label: "entities:cmsHeadingBlock.attributes.importance.selectOptions.2.label",
                    value: "2"
                },
                {
                    label: "entities:cmsHeadingBlock.attributes.importance.selectOptions.3.label",
                    value: "3"
                },
                {
                    label: "entities:cmsHeadingBlock.attributes.importance.selectOptions.4.label",
                    value: "4"
                },
                {
                    label: "entities:cmsHeadingBlock.attributes.importance.selectOptions.5.label",
                    value: "5"
                },
                {
                    label: "entities:cmsHeadingBlock.attributes.importance.selectOptions.6.label",
                    value: "6"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        heading: {
            name: "heading",
            label: "entities:cmsHeadingBlock.attributes.heading.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        addon: {
            name: "addon",
            label: "entities:cmsHeadingBlock.attributes.addon.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        decoration: {
            name: "decoration",
            label: "entities:cmsHeadingBlock.attributes.decoration.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsHeadingBlock_model = (cmsHeadingBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsHeadingBlock/repository.ts









var cmsHeadingBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsHeadingBlock_model, object);
    });
};
var cmsHeadingBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsHeadingBlock_model, object);
};
var cmsHeadingBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_HEADING_BLOCK_QUERY, variables).then(function(data) {
                        return cmsHeadingBlock_repository_hydrateObject(data.headingBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_HEADING_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsHeadingBlock_repository_hydrateObjects(data.headingBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_HEADING_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsHeadingBlock_repository_hydrateObject(data.headingBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_HEADING_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsHeadingBlock_repository_hydrateObjects(data.headingBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_HEADING_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsHeadingBlock_repository_hydrateObject(data.headingBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_HEADING_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsHeadingBlock_repository_hydrateObject(data.headingBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_HEADING_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsHeadingBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_HEADING_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsHeadingBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsHeadingBlock_repository = (cmsHeadingBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsHeadingBlock/entity.ts


var cmsHeadingBlockEntity = {
    model: cmsHeadingBlock_model,
    repository: cmsHeadingBlock_repository
};
/* harmony default export */ var cmsHeadingBlock_entity = ((/* unused pure expression or super */ null && (cmsHeadingBlockEntity)));

// EXTERNAL MODULE: ./src/entities/cmsTextWithIconBlock/entity.ts + 3 modules
var cmsTextWithIconBlock_entity = __webpack_require__(3572);
;// CONCATENATED MODULE: ./src/entities/cmsWysiwygBlock/graphql.ts
// language=GraphQL
var ALL_WYSIWYG_BLOCKS_QUERY = "query Query {\n  wysiwygBlocks: cmsWysiwygBlocks {\n    id\n    html\n  }\n}";
// language=GraphQL
var SINGLE_WYSIWYG_BLOCK_QUERY = "query Query($id: ID!) {\n  wysiwygBlock: cmsWysiwygBlock(id: $id) {\n    id\n    html\n  }\n}";
// language=GraphQL
var CREATE_WYSIWYG_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsWysiwygBlockInput) {\n    wysiwygBlock: createCmsWysiwygBlock(input: $input) {\n      id\n      html\n    }\n  }";
// language=GraphQL
var UPDATE_WYSIWYG_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsWysiwygBlockInput) {\n    wysiwygBlock: updateCmsWysiwygBlock(input: $input) {\n      id\n      html\n    }\n  }";
// language=GraphQL
var DELETE_WYSIWYG_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsWysiwygBlockInput) {\n    deleteCmsWysiwygBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_WYSIWYG_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsWysiwygBlockInput) {\n    forceDeleteCmsWysiwygBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsWysiwygBlock/model.ts

var cmsWysiwygBlockModel = {
    name: "wysiwygBlock",
    namePlural: "wysiwygBlocks",
    uniqueName: "cmsWysiwygBlock",
    uniqueNamePlural: "cmsWysiwygBlocks",
    path: "cms/blocks/wysiwyg_block",
    baseUrl: "/cms/blocks/wysiwyg_blocks",
    translationPrefix: "entities:cmsWysiwygBlock.",
    getDisplayName: function(values) {
        return "Text Block (WYSIWYG)";
    },
    gql: {
        getAll: ALL_WYSIWYG_BLOCKS_QUERY,
        getSingle: SINGLE_WYSIWYG_BLOCK_QUERY,
        create: CREATE_WYSIWYG_BLOCK_MUTATION,
        update: UPDATE_WYSIWYG_BLOCK_MUTATION,
        delete: DELETE_WYSIWYG_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_WYSIWYG_BLOCK_MUTATION
    },
    attributes: {
        html: {
            name: "html",
            label: "entities:cmsWysiwygBlock.attributes.html.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var cmsWysiwygBlock_model = (cmsWysiwygBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsWysiwygBlock/repository.ts









var cmsWysiwygBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsWysiwygBlock_model, object);
    });
};
var cmsWysiwygBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsWysiwygBlock_model, object);
};
var cmsWysiwygBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_WYSIWYG_BLOCK_QUERY, variables).then(function(data) {
                        return cmsWysiwygBlock_repository_hydrateObject(data.wysiwygBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_WYSIWYG_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsWysiwygBlock_repository_hydrateObjects(data.wysiwygBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_WYSIWYG_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsWysiwygBlock_repository_hydrateObject(data.wysiwygBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_WYSIWYG_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsWysiwygBlock_repository_hydrateObjects(data.wysiwygBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_WYSIWYG_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsWysiwygBlock_repository_hydrateObject(data.wysiwygBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_WYSIWYG_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsWysiwygBlock_repository_hydrateObject(data.wysiwygBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_WYSIWYG_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsWysiwygBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_WYSIWYG_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsWysiwygBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsWysiwygBlock_repository = (cmsWysiwygBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsWysiwygBlock/entity.ts


var cmsWysiwygBlockEntity = {
    model: cmsWysiwygBlock_model,
    repository: cmsWysiwygBlock_repository
};
/* harmony default export */ var cmsWysiwygBlock_entity = ((/* unused pure expression or super */ null && (cmsWysiwygBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsPageHeaderBlock/graphql.ts
// language=GraphQL
var ALL_PAGE_HEADER_BLOCKS_QUERY = "query Query($withImage: Boolean = false) {\n  pageHeaderBlocks: cmsPageHeaderBlocks {\n    id\n    title\n    text\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var SINGLE_PAGE_HEADER_BLOCK_QUERY = "query Query($id: ID!, $withImage: Boolean = false) {\n  pageHeaderBlock: cmsPageHeaderBlock(id: $id) {\n    id\n    title\n    text\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n  }\n}";
// language=GraphQL
var CREATE_PAGE_HEADER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsPageHeaderBlockInput, $withImage: Boolean = false) {\n    pageHeaderBlock: createCmsPageHeaderBlock(input: $input) {\n      id\n      title\n      text\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_PAGE_HEADER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsPageHeaderBlockInput, $withImage: Boolean = false) {\n    pageHeaderBlock: updateCmsPageHeaderBlock(input: $input) {\n      id\n      title\n      text\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }";
// language=GraphQL
var DELETE_PAGE_HEADER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsPageHeaderBlockInput) {\n    deleteCmsPageHeaderBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PAGE_HEADER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsPageHeaderBlockInput) {\n    forceDeleteCmsPageHeaderBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsPageHeaderBlock/model.ts


var cmsPageHeaderBlockModel = {
    name: "pageHeaderBlock",
    namePlural: "pageHeaderBlocks",
    uniqueName: "cmsPageHeaderBlock",
    uniqueNamePlural: "cmsPageHeaderBlocks",
    path: "cms/blocks/page_header_block",
    baseUrl: "/cms/blocks/page_header_blocks",
    translationPrefix: "entities:cmsPageHeaderBlock.",
    getDisplayName: function(values) {
        return "Page Header Block";
    },
    gql: {
        getAll: ALL_PAGE_HEADER_BLOCKS_QUERY,
        getSingle: SINGLE_PAGE_HEADER_BLOCK_QUERY,
        create: CREATE_PAGE_HEADER_BLOCK_MUTATION,
        update: UPDATE_PAGE_HEADER_BLOCK_MUTATION,
        delete: DELETE_PAGE_HEADER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_PAGE_HEADER_BLOCK_MUTATION
    },
    attributes: {
        title: {
            name: "title",
            label: "entities:cmsPageHeaderBlock.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        text: {
            name: "text",
            label: "entities:cmsPageHeaderBlock.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        image: {
            name: "image",
            label: "entities:cmsPageHeaderBlock.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsPageHeaderBlock_model = (cmsPageHeaderBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsPageHeaderBlock/repository.ts









var cmsPageHeaderBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsPageHeaderBlock_model, object);
    });
};
var cmsPageHeaderBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsPageHeaderBlock_model, object);
};
var cmsPageHeaderBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PAGE_HEADER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsPageHeaderBlock_repository_hydrateObject(data.pageHeaderBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PAGE_HEADER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsPageHeaderBlock_repository_hydrateObjects(data.pageHeaderBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PAGE_HEADER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsPageHeaderBlock_repository_hydrateObject(data.pageHeaderBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PAGE_HEADER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsPageHeaderBlock_repository_hydrateObjects(data.pageHeaderBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PAGE_HEADER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsPageHeaderBlock_repository_hydrateObject(data.pageHeaderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PAGE_HEADER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsPageHeaderBlock_repository_hydrateObject(data.pageHeaderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PAGE_HEADER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsPageHeaderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PAGE_HEADER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsPageHeaderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsPageHeaderBlock_repository = (cmsPageHeaderBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsPageHeaderBlock/entity.ts


var cmsPageHeaderBlockEntity = {
    model: cmsPageHeaderBlock_model,
    repository: cmsPageHeaderBlock_repository
};
/* harmony default export */ var cmsPageHeaderBlock_entity = ((/* unused pure expression or super */ null && (cmsPageHeaderBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlock/graphql.ts
// language=GraphQL
var ALL_ACCORDION_BLOCKS_QUERY = "query Query($withItems: Boolean = false) {\n  accordionBlocks: cmsAccordionBlocks {\n    id\n    items @include(if: $withItems) {\n      id\n      title\n      content\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ACCORDION_BLOCK_QUERY = "query Query($id: ID!, $withItems: Boolean = false) {\n  accordionBlock: cmsAccordionBlock(id: $id) {\n    id\n    items @include(if: $withItems) {\n      id\n      title\n      content\n    }\n  }\n}";
// language=GraphQL
var CREATE_ACCORDION_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsAccordionBlockInput, $withItems: Boolean = false) {\n    accordionBlock: createCmsAccordionBlock(input: $input) {\n      id\n      items @include(if: $withItems) {\n        id\n        title\n        content\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ACCORDION_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsAccordionBlockInput, $withItems: Boolean = false) {\n    accordionBlock: updateCmsAccordionBlock(input: $input) {\n      id\n      items @include(if: $withItems) {\n        id\n        title\n        content\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ACCORDION_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsAccordionBlockInput) {\n    deleteCmsAccordionBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCORDION_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsAccordionBlockInput) {\n    forceDeleteCmsAccordionBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ACCORDION_BLOCK_ITEMS_MUTATION = "\n  mutation Mutation($input: addCmsAccordionBlockItemsInput) {\n    addCmsAccordionBlockItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var REMOVE_ACCORDION_BLOCK_ITEMS_MUTATION = "\n  mutation Mutation($input: removeCmsAccordionBlockItemsInput) {\n    removeCmsAccordionBlockItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var CREATE_ACCORDION_BLOCK_ITEMS_MUTATION = "\n  mutation Mutation($input: createCmsAccordionBlockItemsInput) {\n    createCmsAccordionBlockItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var DELETE_ACCORDION_BLOCK_ITEMS_MUTATION = "\n  mutation Mutation($input: deleteCmsAccordionBlockItemsInput) {\n    deleteCmsAccordionBlockItems(input: $input) {\n      id\n      itemIds\n    }\n  }";
// language=GraphQL
var UPDATE_ACCORDION_BLOCK_ITEMS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsAccordionBlockItemsOrderInput) {\n    updateCmsAccordionBlockItemsOrder(input: $input) {\n      id\n      itemIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlockItem/graphql.ts
// language=GraphQL
var ALL_ACCORDION_BLOCK_ITEMS_QUERY = "query Query {\n  accordionBlockItems: cmsAccordionBlockItems {\n    id\n    title\n    content\n  }\n}";
// language=GraphQL
var SINGLE_ACCORDION_BLOCK_ITEM_QUERY = "query Query($id: ID!) {\n  accordionBlockItem: cmsAccordionBlockItem(id: $id) {\n    id\n    title\n    content\n  }\n}";
// language=GraphQL
var CREATE_ACCORDION_BLOCK_ITEM_MUTATION = "\n  mutation Mutation($input: CreateCmsAccordionBlockItemInput) {\n    accordionBlockItem: createCmsAccordionBlockItem(input: $input) {\n      id\n      title\n      content\n    }\n  }";
// language=GraphQL
var UPDATE_ACCORDION_BLOCK_ITEM_MUTATION = "\n  mutation Mutation($input: UpdateCmsAccordionBlockItemInput) {\n    accordionBlockItem: updateCmsAccordionBlockItem(input: $input) {\n      id\n      title\n      content\n    }\n  }";
// language=GraphQL
var DELETE_ACCORDION_BLOCK_ITEM_MUTATION = "\n  mutation Mutation($input: DeleteCmsAccordionBlockItemInput) {\n    deleteCmsAccordionBlockItem(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCORDION_BLOCK_ITEM_MUTATION = "\n  mutation Mutation($input: DeleteCmsAccordionBlockItemInput) {\n    forceDeleteCmsAccordionBlockItem(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ACCORDION_BLOCK_ITEMS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsAccordionBlocks: Boolean = false) {\n  groupedDependents: cmsAccordionBlockItemDependents(id: $id) {\n    cmsAccordionBlocks @include(if: $withCmsAccordionBlocks) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlockItem/model.ts

var cmsAccordionBlockItemModel = {
    name: "accordionBlockItem",
    namePlural: "accordionBlockItems",
    uniqueName: "cmsAccordionBlockItem",
    uniqueNamePlural: "cmsAccordionBlockItems",
    path: "cms/blocks/accordion_block_item",
    baseUrl: "/cms/blocks/accordion_block_items",
    translationPrefix: "entities:cmsAccordionBlockItem.",
    getDisplayName: function(values) {
        return "Accordion Block Item";
    },
    gql: {
        getAll: ALL_ACCORDION_BLOCK_ITEMS_QUERY,
        getSingle: SINGLE_ACCORDION_BLOCK_ITEM_QUERY,
        create: CREATE_ACCORDION_BLOCK_ITEM_MUTATION,
        update: UPDATE_ACCORDION_BLOCK_ITEM_MUTATION,
        delete: DELETE_ACCORDION_BLOCK_ITEM_MUTATION,
        forceDelete: FORCE_DELETE_ACCORDION_BLOCK_ITEM_MUTATION
    },
    attributes: {
        title: {
            name: "title",
            label: "entities:cmsAccordionBlockItem.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        content: {
            name: "content",
            label: "entities:cmsAccordionBlockItem.attributes.content.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "wysiwyg",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var cmsAccordionBlockItem_model = (cmsAccordionBlockItemModel);

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlockItem/repository.ts










var cmsAccordionBlockItem_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsAccordionBlockItem_model, object);
    });
};
var cmsAccordionBlockItem_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsAccordionBlockItem_model, object);
};
var cmsAccordionBlockItemRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCORDION_BLOCK_ITEM_QUERY, variables).then(function(data) {
                        return cmsAccordionBlockItem_repository_hydrateObject(data.accordionBlockItem);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCORDION_BLOCK_ITEMS_QUERY, includes).then(function(data) {
                    return cmsAccordionBlockItem_repository_hydrateObjects(data.accordionBlockItems);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCORDION_BLOCK_ITEM_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsAccordionBlockItem_repository_hydrateObject(data.accordionBlockItem),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCORDION_BLOCK_ITEMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsAccordionBlockItem_repository_hydrateObjects(data.accordionBlockItems),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ACCORDION_BLOCK_ITEMS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ACCORDION_BLOCK_ITEMS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCORDION_BLOCK_ITEM_MUTATION, variables).then(function(data) {
                        return cmsAccordionBlockItem_repository_hydrateObject(data.accordionBlockItem);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCORDION_BLOCK_ITEM_MUTATION, variables).then(function(data) {
                        return cmsAccordionBlockItem_repository_hydrateObject(data.accordionBlockItem);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCORDION_BLOCK_ITEM_MUTATION, variables).then(function(data) {
                        return data.deleteCmsAccordionBlockItem;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCORDION_BLOCK_ITEM_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsAccordionBlockItem;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsAccordionBlockItem_repository = (cmsAccordionBlockItemRepository);

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlockItem/entity.ts


var cmsAccordionBlockItemEntity = {
    model: cmsAccordionBlockItem_model,
    repository: cmsAccordionBlockItem_repository
};
/* harmony default export */ var cmsAccordionBlockItem_entity = (cmsAccordionBlockItemEntity);

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlock/model.ts


var cmsAccordionBlockModel = {
    name: "accordionBlock",
    namePlural: "accordionBlocks",
    uniqueName: "cmsAccordionBlock",
    uniqueNamePlural: "cmsAccordionBlocks",
    path: "cms/blocks/accordion_block",
    baseUrl: "/cms/blocks/accordion_blocks",
    translationPrefix: "entities:cmsAccordionBlock.",
    getDisplayName: function(values) {
        return "Accordion Block";
    },
    gql: {
        getAll: ALL_ACCORDION_BLOCKS_QUERY,
        getSingle: SINGLE_ACCORDION_BLOCK_QUERY,
        create: CREATE_ACCORDION_BLOCK_MUTATION,
        update: UPDATE_ACCORDION_BLOCK_MUTATION,
        delete: DELETE_ACCORDION_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_ACCORDION_BLOCK_MUTATION
    },
    attributes: {
        items: {
            name: "items",
            label: "entities:cmsAccordionBlock.attributes.items.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsAccordionBlockItem_entity;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsAccordionBlock_model = (cmsAccordionBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlock/repository.ts









var cmsAccordionBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsAccordionBlock_model, object);
    });
};
var cmsAccordionBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsAccordionBlock_model, object);
};
var cmsAccordionBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCORDION_BLOCK_QUERY, variables).then(function(data) {
                        return cmsAccordionBlock_repository_hydrateObject(data.accordionBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCORDION_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsAccordionBlock_repository_hydrateObjects(data.accordionBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCORDION_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsAccordionBlock_repository_hydrateObject(data.accordionBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCORDION_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsAccordionBlock_repository_hydrateObjects(data.accordionBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCORDION_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsAccordionBlock_repository_hydrateObject(data.accordionBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCORDION_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsAccordionBlock_repository_hydrateObject(data.accordionBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCORDION_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsAccordionBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCORDION_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsAccordionBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ACCORDION_BLOCK_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ACCORDION_BLOCK_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        items: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCORDION_BLOCK_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteItems: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCORDION_BLOCK_ITEMS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateItemsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        itemIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCORDION_BLOCK_ITEMS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsAccordionBlock_repository = (cmsAccordionBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsAccordionBlock/entity.ts


var cmsAccordionBlockEntity = {
    model: cmsAccordionBlock_model,
    repository: cmsAccordionBlock_repository
};
/* harmony default export */ var cmsAccordionBlock_entity = ((/* unused pure expression or super */ null && (cmsAccordionBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsGridBlock/graphql.ts
// language=GraphQL
var ALL_GRID_BLOCKS_QUERY = "query Query($withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {\n  gridBlocks: cmsGridBlocks {\n    id\n    columns @include(if: $withColumns) {\n      id\n      contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withColumnsContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_GRID_BLOCK_QUERY = "query Query($id: ID!, $withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {\n  gridBlock: cmsGridBlock(id: $id) {\n    id\n    columns @include(if: $withColumns) {\n      id\n      contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withColumnsContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            imageFixedAspectRatio\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n\n          }\n          ... on CmsGridBlock {\n            id\n\n          }\n          ... on CmsImageBlock {\n            id\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n\n          }\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_GRID_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsGridBlockInput, $withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {\n    gridBlock: createCmsGridBlock(input: $input) {\n      id\n      columns @include(if: $withColumns) {\n        id\n        contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withColumnsContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_GRID_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsGridBlockInput, $withColumns: Boolean = false, $withColumnsContentBlockAssignments: Boolean = false, $withColumnsContentBlockAssignmentsBlock: Boolean = false) {\n    gridBlock: updateCmsGridBlock(input: $input) {\n      id\n      columns @include(if: $withColumns) {\n        id\n        contentBlockAssignments @include(if: $withColumnsContentBlockAssignments) {\n          id\n          type\n          block @include(if: $withColumnsContentBlockAssignmentsBlock) {\n            __typename\n            ... on CmsTextBlock {\n              id\n              text\n\n            }\n            ... on CmsTextWithImageBlock {\n              id\n              title\n              subtitle\n              text\n              imagePosition\n              imageFixedAspectRatio\n\n            }\n            ... on CmsPageHeaderBlock {\n              id\n              title\n              text\n\n            }\n            ... on CmsWysiwygBlock {\n              id\n              html\n\n            }\n            ... on CmsHeadingBlock {\n              id\n              importance\n              heading\n              addon\n              decoration\n\n            }\n            ... on CmsTextWithIconBlock {\n              id\n              title\n              text\n              imagePosition\n\n            }\n            ... on CmsAccordionBlock {\n              id\n\n            }\n            ... on CmsGridBlock {\n              id\n\n            }\n            ... on CmsImageBlock {\n              id\n              text\n              fluid\n\n            }\n            ... on CmsEmployeesBlock {\n              id\n\n            }\n            ... on CmsContactBannerBlock {\n              id\n              phone\n              email\n\n            }\n            ... on CmsNewsletterRegisterBlock {\n              id\n              fluid\n\n            }\n            ... on CmsIssuuCatalogBlock {\n              id\n              publicationCode\n              accountName\n\n            }\n            ... on CmsFormBlock {\n              id\n              formName\n\n            }\n            ... on CmsHeaderSliderBlock {\n              id\n\n            }\n            ... on CmsBestsellerSliderBlock {\n              id\n              fluid\n\n            }\n            ... on CmsFilterLeadBlock {\n              id\n              layout\n\n            }\n            ... on CmsTravelTypesBlock {\n              id\n              layout\n\n            }\n            ... on CmsPrefilteredTravelsBlock {\n              id\n              maxResults\n\n            }\n            ... on CmsDividerBlock {\n              id\n              fluid\n\n            }\n            ... on CmsTravelSelectionBlock {\n              id\n\n            }\n            ... on CmsIframeBlock {\n              id\n              url\n              minHeight\n\n            }\n            ... on CmsSliderBlock {\n              id\n              fluid\n              size\n              showDots\n              showArrows\n              showLightbox\n              autoplay\n\n            }\n            ... on CmsDestinationsBlock {\n              id\n\n            }\n            ... on CmsTravelGuidesBlock {\n              id\n\n            }\n            ... on CmsBusfinderBlock {\n              id\n              title\n\n            }\n            ... on CmsBackgroundBlock {\n              id\n              backgroundVariant\n\n            }\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_GRID_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsGridBlockInput) {\n    deleteCmsGridBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_GRID_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsGridBlockInput) {\n    forceDeleteCmsGridBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_GRID_BLOCK_COLUMNS_MUTATION = "\n  mutation Mutation($input: addCmsGridBlockColumnsInput) {\n    addCmsGridBlockColumns(input: $input) {\n      id\n      columnIds\n    }\n  }";
// language=GraphQL
var REMOVE_GRID_BLOCK_COLUMNS_MUTATION = "\n  mutation Mutation($input: removeCmsGridBlockColumnsInput) {\n    removeCmsGridBlockColumns(input: $input) {\n      id\n      columnIds\n    }\n  }";
// language=GraphQL
var CREATE_GRID_BLOCK_COLUMNS_MUTATION = "\n  mutation Mutation($input: createCmsGridBlockColumnsInput) {\n    createCmsGridBlockColumns(input: $input) {\n      id\n      columnIds\n    }\n  }";
// language=GraphQL
var DELETE_GRID_BLOCK_COLUMNS_MUTATION = "\n  mutation Mutation($input: deleteCmsGridBlockColumnsInput) {\n    deleteCmsGridBlockColumns(input: $input) {\n      id\n      columnIds\n    }\n  }";
// language=GraphQL
var UPDATE_GRID_BLOCK_COLUMNS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsGridBlockColumnsOrderInput) {\n    updateCmsGridBlockColumnsOrder(input: $input) {\n      id\n      columnIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsGridBlockColumn/graphql.ts
// language=GraphQL
var ALL_GRID_BLOCK_COLUMNS_QUERY = "query Query($withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n  gridBlockColumns: cmsGridBlockColumns {\n    id\n    contentBlockAssignments @include(if: $withContentBlockAssignments) {\n      id\n      type\n      block @include(if: $withContentBlockAssignmentsBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          link @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            text\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            description\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            type\n          }\n\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_GRID_BLOCK_COLUMN_QUERY = "query Query($id: ID!, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n  gridBlockColumn: cmsGridBlockColumn(id: $id) {\n    id\n    contentBlockAssignments @include(if: $withContentBlockAssignments) {\n      id\n      type\n      block @include(if: $withContentBlockAssignmentsBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          link @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            text\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            description\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            type\n          }\n\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_GRID_BLOCK_COLUMN_MUTATION = "\n  mutation Mutation($input: CreateCmsGridBlockColumnInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n    gridBlockColumn: createCmsGridBlockColumn(input: $input) {\n      id\n      contentBlockAssignments @include(if: $withContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imageFixedAspectRatio\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            link @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n            items @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              content\n            }\n\n          }\n          ... on CmsGridBlock {\n            id\n            columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n\n          }\n          ... on CmsImageBlock {\n            id\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n            employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n            slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              text\n            }\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              description\n            }\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              description\n            }\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              type\n            }\n\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_GRID_BLOCK_COLUMN_MUTATION = "\n  mutation Mutation($input: UpdateCmsGridBlockColumnInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n    gridBlockColumn: updateCmsGridBlockColumn(input: $input) {\n      id\n      contentBlockAssignments @include(if: $withContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imageFixedAspectRatio\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            link @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n            items @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              content\n            }\n\n          }\n          ... on CmsGridBlock {\n            id\n            columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n\n          }\n          ... on CmsImageBlock {\n            id\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n            employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n            slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              text\n            }\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              description\n            }\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              description\n            }\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              type\n            }\n\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_GRID_BLOCK_COLUMN_MUTATION = "\n  mutation Mutation($input: DeleteCmsGridBlockColumnInput) {\n    deleteCmsGridBlockColumn(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_GRID_BLOCK_COLUMN_MUTATION = "\n  mutation Mutation($input: DeleteCmsGridBlockColumnInput) {\n    forceDeleteCmsGridBlockColumn(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: addCmsGridBlockColumnContentBlockAssignmentsInput) {\n    addCmsGridBlockColumnContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var REMOVE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: removeCmsGridBlockColumnContentBlockAssignmentsInput) {\n    removeCmsGridBlockColumnContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var CREATE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: createCmsGridBlockColumnContentBlockAssignmentsInput) {\n    createCmsGridBlockColumnContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var DELETE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: deleteCmsGridBlockColumnContentBlockAssignmentsInput) {\n    deleteCmsGridBlockColumnContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var UPDATE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsGridBlockColumnContentBlockAssignmentsOrderInput) {\n    updateCmsGridBlockColumnContentBlockAssignmentsOrder(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var GRID_BLOCK_COLUMNS_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsGridBlocks: Boolean = false) {\n  groupedDependents: cmsGridBlockColumnDependents(id: $id) {\n    cmsGridBlocks @include(if: $withCmsGridBlocks) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/cmsGridBlockColumn/model.ts


var cmsGridBlockColumnModel = {
    name: "gridBlockColumn",
    namePlural: "gridBlockColumns",
    uniqueName: "cmsGridBlockColumn",
    uniqueNamePlural: "cmsGridBlockColumns",
    path: "cms/blocks/grid_block_column",
    baseUrl: "/cms/blocks/grid_block_columns",
    translationPrefix: "entities:cmsGridBlockColumn.",
    getDisplayName: function(values) {
        return "Grid Column";
    },
    gql: {
        getAll: ALL_GRID_BLOCK_COLUMNS_QUERY,
        getSingle: SINGLE_GRID_BLOCK_COLUMN_QUERY,
        create: CREATE_GRID_BLOCK_COLUMN_MUTATION,
        update: UPDATE_GRID_BLOCK_COLUMN_MUTATION,
        delete: DELETE_GRID_BLOCK_COLUMN_MUTATION,
        forceDelete: FORCE_DELETE_GRID_BLOCK_COLUMN_MUTATION
    },
    attributes: {
        contentBlockAssignments: {
            name: "contentBlockAssignments",
            label: "entities:cmsGridBlockColumn.attributes.contentBlockAssignments.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsContentBlockAssignment_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsGridBlockColumn_model = (cmsGridBlockColumnModel);

;// CONCATENATED MODULE: ./src/entities/cmsGridBlockColumn/repository.ts










var cmsGridBlockColumn_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsGridBlockColumn_model, object);
    });
};
var cmsGridBlockColumn_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsGridBlockColumn_model, object);
};
var cmsGridBlockColumnRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_GRID_BLOCK_COLUMN_QUERY, variables).then(function(data) {
                        return cmsGridBlockColumn_repository_hydrateObject(data.gridBlockColumn);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_GRID_BLOCK_COLUMNS_QUERY, includes).then(function(data) {
                    return cmsGridBlockColumn_repository_hydrateObjects(data.gridBlockColumns);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_GRID_BLOCK_COLUMN_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsGridBlockColumn_repository_hydrateObject(data.gridBlockColumn),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_GRID_BLOCK_COLUMNS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsGridBlockColumn_repository_hydrateObjects(data.gridBlockColumns),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(GRID_BLOCK_COLUMNS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            GRID_BLOCK_COLUMNS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_GRID_BLOCK_COLUMN_MUTATION, variables).then(function(data) {
                        return cmsGridBlockColumn_repository_hydrateObject(data.gridBlockColumn);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_GRID_BLOCK_COLUMN_MUTATION, variables).then(function(data) {
                        return cmsGridBlockColumn_repository_hydrateObject(data.gridBlockColumn);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_GRID_BLOCK_COLUMN_MUTATION, variables).then(function(data) {
                        return data.deleteCmsGridBlockColumn;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_GRID_BLOCK_COLUMN_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsGridBlockColumn;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignments: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateContentBlockAssignmentsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_GRID_BLOCK_COLUMN_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsGridBlockColumn_repository = (cmsGridBlockColumnRepository);

;// CONCATENATED MODULE: ./src/entities/cmsGridBlockColumn/entity.ts


var cmsGridBlockColumnEntity = {
    model: cmsGridBlockColumn_model,
    repository: cmsGridBlockColumn_repository
};
/* harmony default export */ var cmsGridBlockColumn_entity = (cmsGridBlockColumnEntity);

;// CONCATENATED MODULE: ./src/entities/cmsGridBlock/model.ts


var cmsGridBlockModel = {
    name: "gridBlock",
    namePlural: "gridBlocks",
    uniqueName: "cmsGridBlock",
    uniqueNamePlural: "cmsGridBlocks",
    path: "cms/blocks/grid_block",
    baseUrl: "/cms/blocks/grid_blocks",
    translationPrefix: "entities:cmsGridBlock.",
    getDisplayName: function(values) {
        return "Grid Block";
    },
    gql: {
        getAll: ALL_GRID_BLOCKS_QUERY,
        getSingle: SINGLE_GRID_BLOCK_QUERY,
        create: CREATE_GRID_BLOCK_MUTATION,
        update: UPDATE_GRID_BLOCK_MUTATION,
        delete: DELETE_GRID_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_GRID_BLOCK_MUTATION
    },
    attributes: {
        columns: {
            name: "columns",
            label: "entities:cmsGridBlock.attributes.columns.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsGridBlockColumn_entity;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsGridBlock_model = (cmsGridBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsGridBlock/repository.ts









var cmsGridBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsGridBlock_model, object);
    });
};
var cmsGridBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsGridBlock_model, object);
};
var cmsGridBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_GRID_BLOCK_QUERY, variables).then(function(data) {
                        return cmsGridBlock_repository_hydrateObject(data.gridBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_GRID_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsGridBlock_repository_hydrateObjects(data.gridBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_GRID_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsGridBlock_repository_hydrateObject(data.gridBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_GRID_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsGridBlock_repository_hydrateObjects(data.gridBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_GRID_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsGridBlock_repository_hydrateObject(data.gridBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_GRID_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsGridBlock_repository_hydrateObject(data.gridBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_GRID_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsGridBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_GRID_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsGridBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignColumns: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        columnIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_GRID_BLOCK_COLUMNS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignColumns: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        columnIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_GRID_BLOCK_COLUMNS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createColumns: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        columns: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_GRID_BLOCK_COLUMNS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteColumns: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        columnIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_GRID_BLOCK_COLUMNS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateColumnsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        columnIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_GRID_BLOCK_COLUMNS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsGridBlock_repository = (cmsGridBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsGridBlock/entity.ts


var cmsGridBlockEntity = {
    model: cmsGridBlock_model,
    repository: cmsGridBlock_repository
};
/* harmony default export */ var cmsGridBlock_entity = ((/* unused pure expression or super */ null && (cmsGridBlockEntity)));

// EXTERNAL MODULE: ./src/entities/elementSeoSettings/entity.ts + 3 modules
var elementSeoSettings_entity = __webpack_require__(64750);
// EXTERNAL MODULE: ./src/entities/travelDestination/entity.ts + 3 modules
var travelDestination_entity = __webpack_require__(22546);
// EXTERNAL MODULE: ./src/entities/accommodation/entity.ts + 3 modules
var accommodation_entity = __webpack_require__(92043);
// EXTERNAL MODULE: ./src/entities/accommodationRoomType/entity.ts + 3 modules
var accommodationRoomType_entity = __webpack_require__(94529);
// EXTERNAL MODULE: ./src/entities/accommodationAvailableAddon/entity.ts + 3 modules
var accommodationAvailableAddon_entity = __webpack_require__(97806);
// EXTERNAL MODULE: ./src/entities/imageGallery/entity.ts + 3 modules
var imageGallery_entity = __webpack_require__(41);
// EXTERNAL MODULE: ./src/entities/travelLabel/entity.ts + 3 modules
var travelLabel_entity = __webpack_require__(46714);
// EXTERNAL MODULE: ./src/entities/travelPartner/entity.ts + 3 modules
var travelPartner_entity = __webpack_require__(52889);
// EXTERNAL MODULE: ./src/entities/travelGuide/entity.ts + 3 modules
var travelGuide_entity = __webpack_require__(36687);
// EXTERNAL MODULE: ./src/entities/employee/entity.ts + 3 modules
var employee_entity = __webpack_require__(4383);
// EXTERNAL MODULE: ./src/entities/travelAvailabilityStatus/entity.ts + 3 modules
var travelAvailabilityStatus_entity = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/entities/travelHighlight/entity.ts + 3 modules
var travelHighlight_entity = __webpack_require__(60328);
// EXTERNAL MODULE: ./src/entities/travelTeam/entity.ts + 3 modules
var travelTeam_entity = __webpack_require__(541);
// EXTERNAL MODULE: ./src/entities/travel/entity.ts + 3 modules
var travel_entity = __webpack_require__(82327);
// EXTERNAL MODULE: ./src/entities/travelExtension/entity.ts + 3 modules
var travelExtension_entity = __webpack_require__(14585);
// EXTERNAL MODULE: ./src/entities/itinerary/entity.ts + 3 modules
var itinerary_entity = __webpack_require__(80231);
// EXTERNAL MODULE: ./src/entities/itineraryItem/entity.ts + 3 modules
var itineraryItem_entity = __webpack_require__(12540);
// EXTERNAL MODULE: ./src/entities/itineraryMapMarker/entity.ts + 3 modules
var itineraryMapMarker_entity = __webpack_require__(89232);
// EXTERNAL MODULE: ./src/entities/travelPricing/entity.ts + 3 modules
var travelPricing_entity = __webpack_require__(60090);
// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroupSettings/entity.ts + 3 modules
var travelPricingAgeGroupSettings_entity = __webpack_require__(26189);
// EXTERNAL MODULE: ./src/entities/ratioTravel/entity.ts + 3 modules
var ratioTravel_entity = __webpack_require__(81065);
// EXTERNAL MODULE: ./src/entities/ratioTravelDate/entity.ts + 3 modules
var ratioTravelDate_entity = __webpack_require__(48086);
// EXTERNAL MODULE: ./src/entities/ratioDatePackageSettings/entity.ts + 3 modules
var ratioDatePackageSettings_entity = __webpack_require__(81882);
// EXTERNAL MODULE: ./src/entities/travelPricingAgeGroup/entity.ts + 3 modules
var travelPricingAgeGroup_entity = __webpack_require__(65966);
// EXTERNAL MODULE: ./src/entities/ratioAccommodation/entity.ts + 3 modules
var ratioAccommodation_entity = __webpack_require__(53656);
// EXTERNAL MODULE: ./src/entities/ratioFamilyPackage/entity.ts + 3 modules
var ratioFamilyPackage_entity = __webpack_require__(79028);
// EXTERNAL MODULE: ./src/entities/accommodationCapacitySettings/entity.ts + 3 modules
var accommodationCapacitySettings_entity = __webpack_require__(11844);
// EXTERNAL MODULE: ./src/entities/accommodationAgeGroupedTotalCapacity/entity.ts + 3 modules
var accommodationAgeGroupedTotalCapacity_entity = __webpack_require__(97896);
// EXTERNAL MODULE: ./src/entities/accommodationAgeGroupCapacity/entity.ts + 3 modules
var accommodationAgeGroupCapacity_entity = __webpack_require__(76276);
// EXTERNAL MODULE: ./src/entities/ratioPersonalAddon/entity.ts + 3 modules
var ratioPersonalAddon_entity = __webpack_require__(34722);
// EXTERNAL MODULE: ./src/entities/travelPricingServiceCalculationSettings/entity.ts + 3 modules
var travelPricingServiceCalculationSettings_entity = __webpack_require__(49005);
// EXTERNAL MODULE: ./src/entities/travelPricingMandatorySettings/entity.ts + 3 modules
var travelPricingMandatorySettings_entity = __webpack_require__(28967);
// EXTERNAL MODULE: ./src/entities/travelPricingRules/entity.ts + 3 modules
var travelPricingRules_entity = __webpack_require__(39704);
// EXTERNAL MODULE: ./src/entities/ratioAccommodationAddon/entity.ts + 3 modules
var ratioAccommodationAddon_entity = __webpack_require__(88646);
// EXTERNAL MODULE: ./src/entities/travelPricingAgeFilter/entity.ts + 3 modules
var travelPricingAgeFilter_entity = __webpack_require__(86791);
// EXTERNAL MODULE: ./src/entities/ratioBookingAddon/entity.ts + 3 modules
var ratioBookingAddon_entity = __webpack_require__(30250);
// EXTERNAL MODULE: ./src/entities/ratioCollectiveAddon/entity.ts + 3 modules
var ratioCollectiveAddon_entity = __webpack_require__(60826);
// EXTERNAL MODULE: ./src/entities/ratioAgeGroupService/entity.ts + 3 modules
var ratioAgeGroupService_entity = __webpack_require__(21996);
// EXTERNAL MODULE: ./src/entities/ratioTravelExtension/entity.ts + 3 modules
var ratioTravelExtension_entity = __webpack_require__(6607);
;// CONCATENATED MODULE: ./src/entities/ratioAccommodationService/graphql.ts
// language=GraphQL
var ALL_ACCOMMODATION_SERVICES_QUERY = "query Query($withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {\n  accommodationServices: ratioAccommodationServices {\n    id\n    ratioServiceNo\n    accommodation @include(if: $withAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ACCOMMODATION_SERVICE_QUERY = "query Query($id: ID!, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {\n  accommodationService: ratioAccommodationService(id: $id) {\n    id\n    ratioServiceNo\n    accommodation @include(if: $withAccommodation) {\n      id\n      ratioPackageNo\n      name\n      label\n      info\n      isFamilyPackageAccommodation\n      isBabyPackage\n      capacitySettings @include(if: $withAccommodationCapacitySettings) {\n        id\n        totalCapacity\n        rangesAllowed\n        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n          id\n          minCapacity\n          maxCapacity\n        }\n        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n          id\n          capacity\n        }\n        partialOccupancyAllowed\n        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n      }\n      addons @include(if: $withAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_ACCOMMODATION_SERVICE_MUTATION = "\n  mutation Mutation($input: CreateRatioAccommodationServiceInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {\n    accommodationService: createRatioAccommodationService(input: $input) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ACCOMMODATION_SERVICE_MUTATION = "\n  mutation Mutation($input: UpdateRatioAccommodationServiceInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {\n    accommodationService: updateRatioAccommodationService(input: $input) {\n      id\n      ratioServiceNo\n      accommodation @include(if: $withAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {\n            id\n            minCapacity\n            maxCapacity\n          }\n          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {\n            id\n            capacity\n          }\n          partialOccupancyAllowed\n          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n        }\n        addons @include(if: $withAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ACCOMMODATION_SERVICE_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationServiceInput) {\n    deleteRatioAccommodationService(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ACCOMMODATION_SERVICE_MUTATION = "\n  mutation Mutation($input: DeleteRatioAccommodationServiceInput) {\n    forceDeleteRatioAccommodationService(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationService/model.ts


var ratioAccommodationServiceModel = {
    name: "accommodationService",
    namePlural: "accommodationServices",
    uniqueName: "ratioAccommodationService",
    uniqueNamePlural: "ratioAccommodationServices",
    path: "travel/pricing/adaptors/ratio/accommodation_service",
    baseUrl: "/travel/pricing/adaptors/ratio/accommodation_services",
    translationPrefix: "entities:ratioAccommodationService.",
    getDisplayName: function(values) {
        return "Ratio Accommodation Service";
    },
    gql: {
        getAll: ALL_ACCOMMODATION_SERVICES_QUERY,
        getSingle: SINGLE_ACCOMMODATION_SERVICE_QUERY,
        create: CREATE_ACCOMMODATION_SERVICE_MUTATION,
        update: UPDATE_ACCOMMODATION_SERVICE_MUTATION,
        delete: DELETE_ACCOMMODATION_SERVICE_MUTATION,
        forceDelete: FORCE_DELETE_ACCOMMODATION_SERVICE_MUTATION
    },
    attributes: {
        ratioServiceNo: {
            name: "ratioServiceNo",
            label: "entities:ratioAccommodationService.attributes.ratioServiceNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        accommodation: {
            name: "accommodation",
            label: "entities:ratioAccommodationService.attributes.accommodation.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioAccommodation_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var ratioAccommodationService_model = (ratioAccommodationServiceModel);

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationService/repository.ts









var ratioAccommodationService_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(ratioAccommodationService_model, object);
    });
};
var ratioAccommodationService_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(ratioAccommodationService_model, object);
};
var ratioAccommodationServiceRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ACCOMMODATION_SERVICE_QUERY, variables).then(function(data) {
                        return ratioAccommodationService_repository_hydrateObject(data.accommodationService);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ACCOMMODATION_SERVICES_QUERY, includes).then(function(data) {
                    return ratioAccommodationService_repository_hydrateObjects(data.accommodationServices);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ACCOMMODATION_SERVICE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : ratioAccommodationService_repository_hydrateObject(data.accommodationService),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ACCOMMODATION_SERVICES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : ratioAccommodationService_repository_hydrateObjects(data.accommodationServices),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ACCOMMODATION_SERVICE_MUTATION, variables).then(function(data) {
                        return ratioAccommodationService_repository_hydrateObject(data.accommodationService);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ACCOMMODATION_SERVICE_MUTATION, variables).then(function(data) {
                        return ratioAccommodationService_repository_hydrateObject(data.accommodationService);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ACCOMMODATION_SERVICE_MUTATION, variables).then(function(data) {
                        return data.deleteRatioAccommodationService;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ACCOMMODATION_SERVICE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioAccommodationService;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var ratioAccommodationService_repository = (ratioAccommodationServiceRepository);

;// CONCATENATED MODULE: ./src/entities/ratioAccommodationService/entity.ts


var ratioAccommodationServiceEntity = {
    model: ratioAccommodationService_model,
    repository: ratioAccommodationService_repository
};
/* harmony default export */ var ratioAccommodationService_entity = ((/* unused pure expression or super */ null && (ratioAccommodationServiceEntity)));

// EXTERNAL MODULE: ./src/entities/ratioCatalogBundle/entity.ts + 3 modules
var ratioCatalogBundle_entity = __webpack_require__(54371);
;// CONCATENATED MODULE: ./src/entities/booking/graphql.ts
// language=GraphQL
var ALL_BOOKINGS_QUERY = "query Query($withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  bookings: bookings {\n    id\n    referenceNo\n    travel @include(if: $withTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelTenantSettings) {\n        id\n        tenant @include(if: $withTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelTeams) {\n        id\n        name\n        members @include(if: $withTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelTestimonials) {\n        id\n        contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelGallery) {\n        id\n        images @include(if: $withTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelItinerary) {\n        id\n        items @include(if: $withTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n    pricingTravel @include(if: $withPricingTravel) {\n      id\n      ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withPricingTravelDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withPricingTravelDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withPricingTravelDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withPricingTravelDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n      accommodations @include(if: $withPricingTravelAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withPricingTravelFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      personalAddons @include(if: $withPricingTravelPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withPricingTravelBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {\n          id\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withPricingTravelExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      importDateTime\n      importStatus\n    }\n    travelDate @include(if: $withTravelDate) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withTravelDateExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withTravelDateExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDateExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withTravelDatePackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withTravelDateExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n      ageGroup @include(if: $withTravellersAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      accommodation @include(if: $withTravellersAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravellersAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      familyPackage @include(if: $withTravellersFamilyPackage) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withTravellersFamilyPackageAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravellersFamilyPackageAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      accommodationAddons @include(if: $withTravellersAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      personalAddons @include(if: $withTravellersPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withTravellersBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withTravellersExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravellersExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      passportData @include(if: $withTravellersPassportData) {\n        id\n        type\n        number\n        birthPlace\n        issuePlace\n        issueDate\n        validUntil\n      }\n    }\n    travellerRemarks\n    travellerDataCorrectnessConfirmation\n    localState\n    backofficePayload\n    backofficeResponse\n    transmissionStatus\n    webhookStatus\n    webhookResponse\n    webhookDuration\n    onlinePayments @include(if: $withOnlinePayments) {\n      id\n      transactionId\n      tenant @include(if: $withOnlinePaymentsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withOnlinePaymentsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withOnlinePaymentsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withOnlinePaymentsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withOnlinePaymentsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      transactionStatus\n      submittedToBackoffice\n      statusPayload\n    }\n    confirmationEmailSent\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    isPassportDataRequired\n    passportDataReminderEmailSent\n    passportDataReceived\n  }\n}";
// language=GraphQL
var SINGLE_BOOKING_QUERY = "query Query($id: ID!, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  booking: booking(id: $id) {\n    id\n    referenceNo\n    travel @include(if: $withTravel) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelTenantSettings) {\n        id\n        tenant @include(if: $withTravelTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelTeams) {\n        id\n        name\n        members @include(if: $withTravelTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelTestimonials) {\n        id\n        contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelGallery) {\n        id\n        images @include(if: $withTravelGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelItinerary) {\n        id\n        items @include(if: $withTravelItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n    pricingTravel @include(if: $withPricingTravel) {\n      id\n      ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {\n        id\n        catalogCode\n        travelCode\n        json\n      }\n      catalogCode\n      travelCode\n      destination\n      name\n      transportType\n      transportTypeLabel\n      dates @include(if: $withPricingTravelDates) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withPricingTravelDatesExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withPricingTravelDatesPackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withPricingTravelDatesExtensions) {\n          id\n          label\n          info\n        }\n      }\n      accommodations @include(if: $withPricingTravelAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelAccommodationsAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        extensionAccommodationServiceNo\n      }\n      familyPackages @include(if: $withPricingTravelFamilyPackages) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withPricingTravelFamilyPackagesAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      personalAddons @include(if: $withPricingTravelPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withPricingTravelBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {\n        id\n        label\n        info\n        ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {\n          id\n          ratioServiceNo\n        }\n        calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withPricingTravelExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      importDateTime\n      importStatus\n    }\n    travelDate @include(if: $withTravelDate) {\n      id\n      dateNo\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      includesExtension\n      extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          includesExtension\n          json\n        }\n        extension @include(if: $withTravelDateExtensionBaseDateExtension) {\n          id\n          label\n          info\n        }\n        packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {\n          id\n          label\n          info\n        }\n      }\n      extension @include(if: $withTravelDateExtension) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDateExtensionTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {\n          id\n        }\n      }\n      packageSettings @include(if: $withTravelDatePackageSettings) {\n        id\n        ratioPackageNo\n        price\n        availabilityStatus\n      }\n      json\n      extensions @include(if: $withTravelDateExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n    }\n    travellers @include(if: $withTravellers) {\n      id\n      salutation\n      firstName\n      lastName\n      birthday\n      nationality\n      email\n      phone\n      address\n      addressNumber\n      addressAddition\n      zip\n      city\n      country\n      ageGroup @include(if: $withTravellersAgeGroup) {\n        id\n        name\n        type\n        icon\n        minAge\n        maxAge\n      }\n      accommodation @include(if: $withTravellersAccommodation) {\n        id\n        ratioPackageNo\n        name\n        label\n        info\n        isFamilyPackageAccommodation\n        isBabyPackage\n        capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravellersAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      familyPackage @include(if: $withTravellersFamilyPackage) {\n        id\n        ratioServiceNo\n        accommodation @include(if: $withTravellersFamilyPackageAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n        }\n        name\n        label\n        info\n        capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {\n          id\n          totalCapacity\n          rangesAllowed\n          partialOccupancyAllowed\n        }\n        addons @include(if: $withTravellersFamilyPackageAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n        }\n      }\n      accommodationAddons @include(if: $withTravellersAccommodationAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      personalAddons @include(if: $withTravellersPersonalAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      bookingAddons @include(if: $withTravellersBookingAddons) {\n        id\n        ratioServiceNo\n        name\n        label\n        info\n        calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {\n          id\n          type\n          considerHotelNights\n        }\n        mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {\n          id\n          isMandatory\n          useRules\n        }\n      }\n      extensions @include(if: $withTravellersExtensions) {\n        id\n        label\n        info\n        travelExtension @include(if: $withTravellersExtensionsTravelExtension) {\n          id\n          duration\n          name\n          description\n        }\n        accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {\n          id\n        }\n      }\n      passportData @include(if: $withTravellersPassportData) {\n        id\n        type\n        number\n        birthPlace\n        issuePlace\n        issueDate\n        validUntil\n      }\n    }\n    travellerRemarks\n    travellerDataCorrectnessConfirmation\n    localState\n    backofficePayload\n    backofficeResponse\n    transmissionStatus\n    webhookStatus\n    webhookResponse\n    webhookDuration\n    onlinePayments @include(if: $withOnlinePayments) {\n      id\n      transactionId\n      tenant @include(if: $withOnlinePaymentsTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withOnlinePaymentsTenantCms) {\n          id\n        }\n        travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {\n          id\n          name\n          description\n        }\n        employees @include(if: $withOnlinePaymentsTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {\n          id\n          provider\n        }\n        redirects @include(if: $withOnlinePaymentsTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          toType\n          toUrl\n        }\n        onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withOnlinePaymentsTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {\n          id\n          filterCrossLinking\n        }\n      }\n      transactionStatus\n      submittedToBackoffice\n      statusPayload\n    }\n    confirmationEmailSent\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    isPassportDataRequired\n    passportDataReminderEmailSent\n    passportDataReceived\n  }\n}";
// language=GraphQL
var CREATE_BOOKING_MUTATION = "\n  mutation Mutation($input: CreateBookingInput, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    booking: createBooking(input: $input) {\n      id\n      referenceNo\n      travel @include(if: $withTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelTenantSettings) {\n          id\n          tenant @include(if: $withTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelTeams) {\n          id\n          name\n          members @include(if: $withTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelTestimonials) {\n          id\n          contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelGallery) {\n          id\n          images @include(if: $withTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelItinerary) {\n          id\n          items @include(if: $withTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      pricingTravel @include(if: $withPricingTravel) {\n        id\n        ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withPricingTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withPricingTravelDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withPricingTravelDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withPricingTravelDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n        accommodations @include(if: $withPricingTravelAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withPricingTravelFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        personalAddons @include(if: $withPricingTravelPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withPricingTravelBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {\n          id\n          label\n          info\n          ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {\n            id\n            ratioServiceNo\n          }\n          calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withPricingTravelExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        importDateTime\n        importStatus\n      }\n      travelDate @include(if: $withTravelDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withTravelDateExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withTravelDateExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDateExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withTravelDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDateExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n      travellers @include(if: $withTravellers) {\n        id\n        salutation\n        firstName\n        lastName\n        birthday\n        nationality\n        email\n        phone\n        address\n        addressNumber\n        addressAddition\n        zip\n        city\n        country\n        ageGroup @include(if: $withTravellersAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        accommodation @include(if: $withTravellersAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravellersAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        familyPackage @include(if: $withTravellersFamilyPackage) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withTravellersFamilyPackageAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravellersFamilyPackageAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        accommodationAddons @include(if: $withTravellersAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        personalAddons @include(if: $withTravellersPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withTravellersBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withTravellersExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravellersExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        passportData @include(if: $withTravellersPassportData) {\n          id\n          type\n          number\n          birthPlace\n          issuePlace\n          issueDate\n          validUntil\n        }\n      }\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      onlinePayments @include(if: $withOnlinePayments) {\n        id\n        transactionId\n        tenant @include(if: $withOnlinePaymentsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withOnlinePaymentsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withOnlinePaymentsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withOnlinePaymentsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withOnlinePaymentsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        transactionStatus\n        submittedToBackoffice\n        statusPayload\n      }\n      confirmationEmailSent\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived\n    }\n  }";
// language=GraphQL
var UPDATE_BOOKING_MUTATION = "\n  mutation Mutation($input: UpdateBookingInput, $withTravel: Boolean = false, $withTravelAvailabilityStatus: Boolean = false, $withTravelAvailabilityStatusTenantSettings: Boolean = false, $withTravelTravelConsultant: Boolean = false, $withTravelTravelConsultantImage: Boolean = false, $withTravelLabel: Boolean = false, $withTravelSeoSettings: Boolean = false, $withTravelSeoSettingsOgImage: Boolean = false, $withTravelTenantSettings: Boolean = false, $withTravelTenantSettingsTenant: Boolean = false, $withTravelTenantSettingsTravelTypes: Boolean = false, $withTravelHighlights: Boolean = false, $withTravelPartners: Boolean = false, $withTravelPartnersLogo: Boolean = false, $withTravelPartnersGtcPdf: Boolean = false, $withTravelTravelGuides: Boolean = false, $withTravelTravelGuidesImage: Boolean = false, $withTravelTeams: Boolean = false, $withTravelTeamsMembers: Boolean = false, $withTravelAccommodationAssignments: Boolean = false, $withTravelAccommodationAssignmentsAccommodation: Boolean = false, $withTravelAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelAccommodations: Boolean = false, $withTravelAccommodationsRoomTypes: Boolean = false, $withTravelAccommodationsAvailableAddons: Boolean = false, $withTravelAccommodationsGallery: Boolean = false, $withTravelDestinations: Boolean = false, $withTravelTestimonials: Boolean = false, $withTravelTestimonialsContentBlock: Boolean = false, $withTravelMainImage: Boolean = false, $withTravelMainVideo: Boolean = false, $withTravelGallery: Boolean = false, $withTravelGalleryImages: Boolean = false, $withTravelTravelPdf: Boolean = false, $withTravelTravelExtensions: Boolean = false, $withTravelTravelExtensionsHighlights: Boolean = false, $withTravelTravelExtensionsImage: Boolean = false, $withTravelItinerary: Boolean = false, $withTravelItineraryItems: Boolean = false, $withTravelPricing: Boolean = false, $withTravelPricingAgeGroupSettings: Boolean = false, $withTravelPricingCustomDataConfig: Boolean = false, $withTravelPricingTravels: Boolean = false, $withTravelPricingWebhookConfig: Boolean = false, $withTravelPricingBranding: Boolean = false, $withTravelPricingBargainSettings: Boolean = false, $withTravelPricingEsimSettings: Boolean = false, $withTravelPricingPassportConfig: Boolean = false, $withTravelPricingTourOperator: Boolean = false, $withPricingTravel: Boolean = false, $withPricingTravelRatioCatalogBundle: Boolean = false, $withPricingTravelDates: Boolean = false, $withPricingTravelDatesAvailabilityStatus: Boolean = false, $withPricingTravelDatesExtensionBaseDate: Boolean = false, $withPricingTravelDatesExtension: Boolean = false, $withPricingTravelDatesPackageSettings: Boolean = false, $withPricingTravelDatesExtensions: Boolean = false, $withPricingTravelAccommodations: Boolean = false, $withPricingTravelAccommodationsCapacitySettings: Boolean = false, $withPricingTravelAccommodationsAddons: Boolean = false, $withPricingTravelExtensionAccommodations: Boolean = false, $withPricingTravelFamilyPackages: Boolean = false, $withPricingTravelFamilyPackagesAccommodation: Boolean = false, $withPricingTravelFamilyPackagesCapacitySettings: Boolean = false, $withPricingTravelFamilyPackagesAddons: Boolean = false, $withPricingTravelPersonalAddons: Boolean = false, $withPricingTravelPersonalAddonsAllowedAgeGroups: Boolean = false, $withPricingTravelPersonalAddonsCalculationSettings: Boolean = false, $withPricingTravelPersonalAddonsMandatorySettings: Boolean = false, $withPricingTravelAccommodationAddons: Boolean = false, $withPricingTravelAccommodationAddonsCalculationSettings: Boolean = false, $withPricingTravelAccommodationAddonsMandatorySettings: Boolean = false, $withPricingTravelBookingAddons: Boolean = false, $withPricingTravelBookingAddonsCalculationSettings: Boolean = false, $withPricingTravelBookingAddonsMandatorySettings: Boolean = false, $withPricingTravelCollectiveAddons: Boolean = false, $withPricingTravelCollectiveAddonsAgeGroupServices: Boolean = false, $withPricingTravelCollectiveAddonsCalculationSettings: Boolean = false, $withPricingTravelCollectiveAddonsMandatorySettings: Boolean = false, $withPricingTravelExtensions: Boolean = false, $withPricingTravelExtensionsTravelExtension: Boolean = false, $withPricingTravelExtensionsAccommodationMapItems: Boolean = false, $withPricingTravelPersonalDiscounts: Boolean = false, $withPricingTravelPersonalDiscountsMandatorySettings: Boolean = false, $withTravelDate: Boolean = false, $withTravelDateAvailabilityStatus: Boolean = false, $withTravelDateAvailabilityStatusTenantSettings: Boolean = false, $withTravelDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateAvailabilityStatus: Boolean = false, $withTravelDateExtensionBaseDateExtensionBaseDate: Boolean = false, $withTravelDateExtensionBaseDateExtension: Boolean = false, $withTravelDateExtensionBaseDatePackageSettings: Boolean = false, $withTravelDateExtensionBaseDateExtensions: Boolean = false, $withTravelDateExtension: Boolean = false, $withTravelDateExtensionTravelExtension: Boolean = false, $withTravelDateExtensionAccommodationMapItems: Boolean = false, $withTravelDatePackageSettings: Boolean = false, $withTravelDateExtensions: Boolean = false, $withTravelDateExtensionsTravelExtension: Boolean = false, $withTravelDateExtensionsAccommodationMapItems: Boolean = false, $withTravellers: Boolean = false, $withTravellersAgeGroup: Boolean = false, $withTravellersAccommodation: Boolean = false, $withTravellersAccommodationCapacitySettings: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersFamilyPackage: Boolean = false, $withTravellersFamilyPackageAccommodation: Boolean = false, $withTravellersFamilyPackageCapacitySettings: Boolean = false, $withTravellersFamilyPackageAddons: Boolean = false, $withTravellersAccommodationAddons: Boolean = false, $withTravellersAccommodationAddonsCalculationSettings: Boolean = false, $withTravellersAccommodationAddonsMandatorySettings: Boolean = false, $withTravellersPersonalAddons: Boolean = false, $withTravellersPersonalAddonsAllowedAgeGroups: Boolean = false, $withTravellersPersonalAddonsCalculationSettings: Boolean = false, $withTravellersPersonalAddonsMandatorySettings: Boolean = false, $withTravellersBookingAddons: Boolean = false, $withTravellersBookingAddonsCalculationSettings: Boolean = false, $withTravellersBookingAddonsMandatorySettings: Boolean = false, $withTravellersExtensions: Boolean = false, $withTravellersExtensionsTravelExtension: Boolean = false, $withTravellersExtensionsAccommodationMapItems: Boolean = false, $withTravellersPassportData: Boolean = false, $withOnlinePayments: Boolean = false, $withOnlinePaymentsTenant: Boolean = false, $withOnlinePaymentsTenantCms: Boolean = false, $withOnlinePaymentsTenantTravelTypes: Boolean = false, $withOnlinePaymentsTenantEmployees: Boolean = false, $withOnlinePaymentsTenantEmailConfig: Boolean = false, $withOnlinePaymentsTenantNewsletterProvider: Boolean = false, $withOnlinePaymentsTenantRedirects: Boolean = false, $withOnlinePaymentsTenantOnlinePaymentConfig: Boolean = false, $withOnlinePaymentsTenantRatioConfig: Boolean = false, $withOnlinePaymentsTenantContent: Boolean = false, $withOnlinePaymentsTenantPartnerTenants: Boolean = false, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    booking: updateBooking(input: $input) {\n      id\n      referenceNo\n      travel @include(if: $withTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelTenantSettings) {\n          id\n          tenant @include(if: $withTravelTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelTeams) {\n          id\n          name\n          members @include(if: $withTravelTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelTestimonials) {\n          id\n          contentBlock @include(if: $withTravelTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelGallery) {\n          id\n          images @include(if: $withTravelGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelItinerary) {\n          id\n          items @include(if: $withTravelItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      pricingTravel @include(if: $withPricingTravel) {\n        id\n        ratioCatalogBundle @include(if: $withPricingTravelRatioCatalogBundle) {\n          id\n          catalogCode\n          travelCode\n          json\n        }\n        catalogCode\n        travelCode\n        destination\n        name\n        transportType\n        transportTypeLabel\n        dates @include(if: $withPricingTravelDates) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withPricingTravelDatesAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withPricingTravelDatesExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withPricingTravelDatesExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withPricingTravelDatesPackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withPricingTravelDatesExtensions) {\n            id\n            label\n            info\n          }\n        }\n        accommodations @include(if: $withPricingTravelAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withPricingTravelAccommodationsCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelAccommodationsAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        extensionAccommodations @include(if: $withPricingTravelExtensionAccommodations) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          extensionAccommodationServiceNo\n        }\n        familyPackages @include(if: $withPricingTravelFamilyPackages) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withPricingTravelFamilyPackagesAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withPricingTravelFamilyPackagesCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withPricingTravelFamilyPackagesAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        personalAddons @include(if: $withPricingTravelPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withPricingTravelPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withPricingTravelPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        accommodationAddons @include(if: $withPricingTravelAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withPricingTravelBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withPricingTravelBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        collectiveAddons @include(if: $withPricingTravelCollectiveAddons) {\n          id\n          label\n          info\n          ageGroupServices @include(if: $withPricingTravelCollectiveAddonsAgeGroupServices) {\n            id\n            ratioServiceNo\n          }\n          calculationSettings @include(if: $withPricingTravelCollectiveAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withPricingTravelCollectiveAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withPricingTravelExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withPricingTravelExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withPricingTravelExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        personalDiscounts @include(if: $withPricingTravelPersonalDiscounts) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          mandatorySettings @include(if: $withPricingTravelPersonalDiscountsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        importDateTime\n        importStatus\n      }\n      travelDate @include(if: $withTravelDate) {\n        id\n        dateNo\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelDateAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelDateAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        includesExtension\n        extensionBaseDate @include(if: $withTravelDateExtensionBaseDate) {\n          id\n          dateNo\n          startDate\n          endDate\n          availabilityStatus @include(if: $withTravelDateExtensionBaseDateAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          includesExtension\n          extensionBaseDate @include(if: $withTravelDateExtensionBaseDateExtensionBaseDate) {\n            id\n            dateNo\n            startDate\n            endDate\n            includesExtension\n            json\n          }\n          extension @include(if: $withTravelDateExtensionBaseDateExtension) {\n            id\n            label\n            info\n          }\n          packageSettings @include(if: $withTravelDateExtensionBaseDatePackageSettings) {\n            id\n            ratioPackageNo\n            price\n            availabilityStatus\n          }\n          json\n          extensions @include(if: $withTravelDateExtensionBaseDateExtensions) {\n            id\n            label\n            info\n          }\n        }\n        extension @include(if: $withTravelDateExtension) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDateExtensionTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDateExtensionAccommodationMapItems) {\n            id\n          }\n        }\n        packageSettings @include(if: $withTravelDatePackageSettings) {\n          id\n          ratioPackageNo\n          price\n          availabilityStatus\n        }\n        json\n        extensions @include(if: $withTravelDateExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravelDateExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravelDateExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n      }\n      travellers @include(if: $withTravellers) {\n        id\n        salutation\n        firstName\n        lastName\n        birthday\n        nationality\n        email\n        phone\n        address\n        addressNumber\n        addressAddition\n        zip\n        city\n        country\n        ageGroup @include(if: $withTravellersAgeGroup) {\n          id\n          name\n          type\n          icon\n          minAge\n          maxAge\n        }\n        accommodation @include(if: $withTravellersAccommodation) {\n          id\n          ratioPackageNo\n          name\n          label\n          info\n          isFamilyPackageAccommodation\n          isBabyPackage\n          capacitySettings @include(if: $withTravellersAccommodationCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravellersAccommodationAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        familyPackage @include(if: $withTravellersFamilyPackage) {\n          id\n          ratioServiceNo\n          accommodation @include(if: $withTravellersFamilyPackageAccommodation) {\n            id\n            ratioPackageNo\n            name\n            label\n            info\n            isFamilyPackageAccommodation\n            isBabyPackage\n          }\n          name\n          label\n          info\n          capacitySettings @include(if: $withTravellersFamilyPackageCapacitySettings) {\n            id\n            totalCapacity\n            rangesAllowed\n            partialOccupancyAllowed\n          }\n          addons @include(if: $withTravellersFamilyPackageAddons) {\n            id\n            ratioServiceNo\n            name\n            label\n            info\n          }\n        }\n        accommodationAddons @include(if: $withTravellersAccommodationAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravellersAccommodationAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravellersAccommodationAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        personalAddons @include(if: $withTravellersPersonalAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          allowedAgeGroups @include(if: $withTravellersPersonalAddonsAllowedAgeGroups) {\n            id\n            name\n            type\n            icon\n            minAge\n            maxAge\n          }\n          calculationSettings @include(if: $withTravellersPersonalAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravellersPersonalAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        bookingAddons @include(if: $withTravellersBookingAddons) {\n          id\n          ratioServiceNo\n          name\n          label\n          info\n          calculationSettings @include(if: $withTravellersBookingAddonsCalculationSettings) {\n            id\n            type\n            considerHotelNights\n          }\n          mandatorySettings @include(if: $withTravellersBookingAddonsMandatorySettings) {\n            id\n            isMandatory\n            useRules\n          }\n        }\n        extensions @include(if: $withTravellersExtensions) {\n          id\n          label\n          info\n          travelExtension @include(if: $withTravellersExtensionsTravelExtension) {\n            id\n            duration\n            name\n            description\n          }\n          accommodationMapItems @include(if: $withTravellersExtensionsAccommodationMapItems) {\n            id\n          }\n        }\n        passportData @include(if: $withTravellersPassportData) {\n          id\n          type\n          number\n          birthPlace\n          issuePlace\n          issueDate\n          validUntil\n        }\n      }\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      onlinePayments @include(if: $withOnlinePayments) {\n        id\n        transactionId\n        tenant @include(if: $withOnlinePaymentsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n          cms @include(if: $withOnlinePaymentsTenantCms) {\n            id\n          }\n          travelTypes @include(if: $withOnlinePaymentsTenantTravelTypes) {\n            id\n            name\n            description\n          }\n          employees @include(if: $withOnlinePaymentsTenantEmployees) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          emailConfig @include(if: $withOnlinePaymentsTenantEmailConfig) {\n            id\n            defaultInternalRecipientEmail\n            internalBookingRecipientEmails\n            bookingConfirmationTemplateId\n            bookingConfirmationInternalTemplateId\n            bookingRequestConfirmationTemplateId\n            bookingWaitlistConfirmationTemplateId\n            bookingWaitlistContingentCheckConfirmationTemplateId\n            bookingCustomRequestTemplateId\n            bookingPassportDataReminderTemplateId\n            contactFormTemplateId\n            esimInstallationInfoTemplateId\n          }\n          newsletterProvider @include(if: $withOnlinePaymentsTenantNewsletterProvider) {\n            id\n            provider\n          }\n          redirects @include(if: $withOnlinePaymentsTenantRedirects) {\n            id\n            fromType\n            fromUrl\n            toType\n            toUrl\n          }\n          onlinePaymentConfig @include(if: $withOnlinePaymentsTenantOnlinePaymentConfig) {\n            id\n            enabled\n            ratioFibuAccountNo\n            infoText\n            datatransThemeConfig\n          }\n          ratioConfig @include(if: $withOnlinePaymentsTenantRatioConfig) {\n            id\n            adressgruppe\n          }\n          content @include(if: $withOnlinePaymentsTenantContent) {\n            id\n            bookingInsuranceInfo\n          }\n          partnerTenants @include(if: $withOnlinePaymentsTenantPartnerTenants) {\n            id\n            filterCrossLinking\n          }\n        }\n        transactionStatus\n        submittedToBackoffice\n        statusPayload\n      }\n      confirmationEmailSent\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived\n    }\n  }";
// language=GraphQL
var DELETE_BOOKING_MUTATION = "\n  mutation Mutation($input: DeleteBookingInput) {\n    deleteBooking(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BOOKING_MUTATION = "\n  mutation Mutation($input: DeleteBookingInput) {\n    forceDeleteBooking(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_BOOKING_TRAVELLERS_MUTATION = "\n  mutation Mutation($input: addBookingTravellersInput) {\n    addBookingTravellers(input: $input) {\n      id\n      travellerIds\n    }\n  }";
// language=GraphQL
var REMOVE_BOOKING_TRAVELLERS_MUTATION = "\n  mutation Mutation($input: removeBookingTravellersInput) {\n    removeBookingTravellers(input: $input) {\n      id\n      travellerIds\n    }\n  }";
// language=GraphQL
var CREATE_BOOKING_TRAVELLERS_MUTATION = "\n  mutation Mutation($input: createBookingTravellersInput) {\n    createBookingTravellers(input: $input) {\n      id\n      travellerIds\n    }\n  }";
// language=GraphQL
var DELETE_BOOKING_TRAVELLERS_MUTATION = "\n  mutation Mutation($input: deleteBookingTravellersInput) {\n    deleteBookingTravellers(input: $input) {\n      id\n      travellerIds\n    }\n  }";
// language=GraphQL
var UPDATE_BOOKING_TRAVELLERS_ORDER_MUTATION = "\n  mutation Mutation($input: updateBookingTravellersOrderInput) {\n    updateBookingTravellersOrder(input: $input) {\n      id\n      travellerIds\n    }\n  }";
// language=GraphQL
var ADD_BOOKING_ONLINE_PAYMENTS_MUTATION = "\n  mutation Mutation($input: addBookingOnlinePaymentsInput) {\n    addBookingOnlinePayments(input: $input) {\n      id\n      onlinePaymentIds\n    }\n  }";
// language=GraphQL
var REMOVE_BOOKING_ONLINE_PAYMENTS_MUTATION = "\n  mutation Mutation($input: removeBookingOnlinePaymentsInput) {\n    removeBookingOnlinePayments(input: $input) {\n      id\n      onlinePaymentIds\n    }\n  }";
// language=GraphQL
var CREATE_BOOKING_ONLINE_PAYMENTS_MUTATION = "\n  mutation Mutation($input: createBookingOnlinePaymentsInput) {\n    createBookingOnlinePayments(input: $input) {\n      id\n      onlinePaymentIds\n    }\n  }";
// language=GraphQL
var DELETE_BOOKING_ONLINE_PAYMENTS_MUTATION = "\n  mutation Mutation($input: deleteBookingOnlinePaymentsInput) {\n    deleteBookingOnlinePayments(input: $input) {\n      id\n      onlinePaymentIds\n    }\n  }";
// language=GraphQL
var UPDATE_BOOKING_ONLINE_PAYMENTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateBookingOnlinePaymentsOrderInput) {\n    updateBookingOnlinePaymentsOrder(input: $input) {\n      id\n      onlinePaymentIds\n    }\n  }";

// EXTERNAL MODULE: ./src/entities/traveller/entity.ts + 3 modules
var traveller_entity = __webpack_require__(53079);
;// CONCATENATED MODULE: ./src/entities/onlinePayment/graphql.ts
// language=GraphQL
var ALL_ONLINE_PAYMENTS_QUERY = "query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  onlinePayments: onlinePayments {\n    id\n    transactionId\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    transactionStatus\n    submittedToBackoffice\n    statusPayload\n  }\n}";
// language=GraphQL
var SINGLE_ONLINE_PAYMENT_QUERY = "query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  onlinePayment: onlinePayment(id: $id) {\n    id\n    transactionId\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n    transactionStatus\n    submittedToBackoffice\n    statusPayload\n  }\n}";
// language=GraphQL
var CREATE_ONLINE_PAYMENT_MUTATION = "\n  mutation Mutation($input: CreateOnlinePaymentInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    onlinePayment: createOnlinePayment(input: $input) {\n      id\n      transactionId\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      transactionStatus\n      submittedToBackoffice\n      statusPayload\n    }\n  }";
// language=GraphQL
var UPDATE_ONLINE_PAYMENT_MUTATION = "\n  mutation Mutation($input: UpdateOnlinePaymentInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    onlinePayment: updateOnlinePayment(input: $input) {\n      id\n      transactionId\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n      transactionStatus\n      submittedToBackoffice\n      statusPayload\n    }\n  }";
// language=GraphQL
var DELETE_ONLINE_PAYMENT_MUTATION = "\n  mutation Mutation($input: DeleteOnlinePaymentInput) {\n    deleteOnlinePayment(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ONLINE_PAYMENT_MUTATION = "\n  mutation Mutation($input: DeleteOnlinePaymentInput) {\n    forceDeleteOnlinePayment(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ONLINE_PAYMENTS_DEPENDENTS_QUERY = "query Query($id: ID!, $withBookings: Boolean = false) {\n  groupedDependents: onlinePaymentDependents(id: $id) {\n    bookings @include(if: $withBookings) {\n      id\n      referenceNo\n      travellerRemarks\n      travellerDataCorrectnessConfirmation\n      localState\n      backofficePayload\n      backofficeResponse\n      transmissionStatus\n      webhookStatus\n      webhookResponse\n      webhookDuration\n      confirmationEmailSent\n      isPassportDataRequired\n      passportDataReminderEmailSent\n      passportDataReceived    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/onlinePayment/model.ts


var onlinePaymentModel = {
    name: "onlinePayment",
    namePlural: "onlinePayments",
    uniqueName: "onlinePayment",
    uniqueNamePlural: "onlinePayments",
    path: "payment/online_payment",
    baseUrl: "/payment/online_payments",
    translationPrefix: "entities:onlinePayment.",
    getDisplayName: function(values) {
        return "ONLINE PAYMENT";
    },
    gql: {
        getAll: ALL_ONLINE_PAYMENTS_QUERY,
        getSingle: SINGLE_ONLINE_PAYMENT_QUERY,
        create: CREATE_ONLINE_PAYMENT_MUTATION,
        update: UPDATE_ONLINE_PAYMENT_MUTATION,
        delete: DELETE_ONLINE_PAYMENT_MUTATION,
        forceDelete: FORCE_DELETE_ONLINE_PAYMENT_MUTATION
    },
    attributes: {
        transactionId: {
            name: "transactionId",
            label: "entities:onlinePayment.attributes.transactionId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        tenant: {
            name: "tenant",
            label: "entities:onlinePayment.attributes.tenant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenant_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        transactionStatus: {
            name: "transactionStatus",
            label: "entities:onlinePayment.attributes.transactionStatus.label",
            type: "value",
            dataType: "string",
            defaultValue: "initialized",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        submittedToBackoffice: {
            name: "submittedToBackoffice",
            label: "entities:onlinePayment.attributes.submittedToBackoffice.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "date",
            validationType: "string",
            validations: []
        },
        statusPayload: {
            name: "statusPayload",
            label: "entities:onlinePayment.attributes.statusPayload.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var onlinePayment_model = (onlinePaymentModel);

;// CONCATENATED MODULE: ./src/entities/onlinePayment/repository.ts










var onlinePayment_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(onlinePayment_model, object);
    });
};
var onlinePayment_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(onlinePayment_model, object);
};
var onlinePaymentRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ONLINE_PAYMENT_QUERY, variables).then(function(data) {
                        return onlinePayment_repository_hydrateObject(data.onlinePayment);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ONLINE_PAYMENTS_QUERY, includes).then(function(data) {
                    return onlinePayment_repository_hydrateObjects(data.onlinePayments);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ONLINE_PAYMENT_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : onlinePayment_repository_hydrateObject(data.onlinePayment),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ONLINE_PAYMENTS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : onlinePayment_repository_hydrateObjects(data.onlinePayments),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ONLINE_PAYMENTS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ONLINE_PAYMENTS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ONLINE_PAYMENT_MUTATION, variables).then(function(data) {
                        return onlinePayment_repository_hydrateObject(data.onlinePayment);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ONLINE_PAYMENT_MUTATION, variables).then(function(data) {
                        return onlinePayment_repository_hydrateObject(data.onlinePayment);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ONLINE_PAYMENT_MUTATION, variables).then(function(data) {
                        return data.deleteOnlinePayment;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ONLINE_PAYMENT_MUTATION, variables).then(function(data) {
                        return data.forceDeleteOnlinePayment;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var onlinePayment_repository = (onlinePaymentRepository);

;// CONCATENATED MODULE: ./src/entities/onlinePayment/entity.ts


var onlinePaymentEntity = {
    model: onlinePayment_model,
    repository: onlinePayment_repository
};
/* harmony default export */ var onlinePayment_entity = (onlinePaymentEntity);

;// CONCATENATED MODULE: ./src/entities/booking/model.ts







var bookingModel = {
    name: "booking",
    namePlural: "bookings",
    uniqueName: "booking",
    uniqueNamePlural: "bookings",
    path: "travel/booking/booking",
    baseUrl: "/travel/booking/bookings",
    translationPrefix: "entities:booking.",
    getDisplayName: function(values) {
        return "Booking";
    },
    gql: {
        getAll: ALL_BOOKINGS_QUERY,
        getSingle: SINGLE_BOOKING_QUERY,
        create: CREATE_BOOKING_MUTATION,
        update: UPDATE_BOOKING_MUTATION,
        delete: DELETE_BOOKING_MUTATION,
        forceDelete: FORCE_DELETE_BOOKING_MUTATION
    },
    attributes: {
        referenceNo: {
            name: "referenceNo",
            label: "entities:booking.attributes.referenceNo.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        travel: {
            name: "travel",
            label: "entities:booking.attributes.travel.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        pricingTravel: {
            name: "pricingTravel",
            label: "entities:booking.attributes.pricingTravel.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioTravel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        travelDate: {
            name: "travelDate",
            label: "entities:booking.attributes.travelDate.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioTravelDate_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        travellers: {
            name: "travellers",
            label: "entities:booking.attributes.travellers.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return traveller_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        travellerRemarks: {
            name: "travellerRemarks",
            label: "entities:booking.attributes.travellerRemarks.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        travellerDataCorrectnessConfirmation: {
            name: "travellerDataCorrectnessConfirmation",
            label: "entities:booking.attributes.travellerDataCorrectnessConfirmation.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "checkbox",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        localState: {
            name: "localState",
            label: "entities:booking.attributes.localState.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        backofficePayload: {
            name: "backofficePayload",
            label: "entities:booking.attributes.backofficePayload.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        backofficeResponse: {
            name: "backofficeResponse",
            label: "entities:booking.attributes.backofficeResponse.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        transmissionStatus: {
            name: "transmissionStatus",
            label: "entities:booking.attributes.transmissionStatus.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:booking.attributes.transmissionStatus.selectOptions.PENDING.label",
                    value: "PENDING"
                },
                {
                    label: "entities:booking.attributes.transmissionStatus.selectOptions.SUCCESS.label",
                    value: "SUCCESS"
                },
                {
                    label: "entities:booking.attributes.transmissionStatus.selectOptions.ERROR.label",
                    value: "ERROR"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        webhookStatus: {
            name: "webhookStatus",
            label: "entities:booking.attributes.webhookStatus.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        webhookResponse: {
            name: "webhookResponse",
            label: "entities:booking.attributes.webhookResponse.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "textarea",
            validationType: "string",
            validations: []
        },
        webhookDuration: {
            name: "webhookDuration",
            label: "entities:booking.attributes.webhookDuration.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        onlinePayments: {
            name: "onlinePayments",
            label: "entities:booking.attributes.onlinePayments.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return onlinePayment_entity;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        confirmationEmailSent: {
            name: "confirmationEmailSent",
            label: "entities:booking.attributes.confirmationEmailSent.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "datetime",
            validationType: "string",
            validations: []
        },
        tenant: {
            name: "tenant",
            label: "entities:booking.attributes.tenant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenant_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        isPassportDataRequired: {
            name: "isPassportDataRequired",
            label: "entities:booking.attributes.isPassportDataRequired.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        passportDataReminderEmailSent: {
            name: "passportDataReminderEmailSent",
            label: "entities:booking.attributes.passportDataReminderEmailSent.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "datetime",
            validationType: "string",
            validations: []
        },
        passportDataReceived: {
            name: "passportDataReceived",
            label: "entities:booking.attributes.passportDataReceived.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "datetime",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var booking_model = (bookingModel);

;// CONCATENATED MODULE: ./src/entities/booking/repository.ts









var booking_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(booking_model, object);
    });
};
var booking_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(booking_model, object);
};
var bookingRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BOOKING_QUERY, variables).then(function(data) {
                        return booking_repository_hydrateObject(data.booking);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BOOKINGS_QUERY, includes).then(function(data) {
                    return booking_repository_hydrateObjects(data.bookings);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BOOKING_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : booking_repository_hydrateObject(data.booking),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BOOKINGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : booking_repository_hydrateObjects(data.bookings),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BOOKING_MUTATION, variables).then(function(data) {
                        return booking_repository_hydrateObject(data.booking);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BOOKING_MUTATION, variables).then(function(data) {
                        return booking_repository_hydrateObject(data.booking);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BOOKING_MUTATION, variables).then(function(data) {
                        return data.deleteBooking;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BOOKING_MUTATION, variables).then(function(data) {
                        return data.forceDeleteBooking;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravellers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travellerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_BOOKING_TRAVELLERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravellers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travellerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_BOOKING_TRAVELLERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravellers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travellers: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BOOKING_TRAVELLERS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravellers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travellerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BOOKING_TRAVELLERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravellersOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travellerIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BOOKING_TRAVELLERS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignOnlinePayments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        onlinePaymentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_BOOKING_ONLINE_PAYMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignOnlinePayments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        onlinePaymentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_BOOKING_ONLINE_PAYMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createOnlinePayments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        onlinePayments: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BOOKING_ONLINE_PAYMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteOnlinePayments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        onlinePaymentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BOOKING_ONLINE_PAYMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateOnlinePaymentsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        onlinePaymentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BOOKING_ONLINE_PAYMENTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var booking_repository = (bookingRepository);

;// CONCATENATED MODULE: ./src/entities/booking/entity.ts


var bookingEntity = {
    model: booking_model,
    repository: booking_repository
};
/* harmony default export */ var booking_entity = ((/* unused pure expression or super */ null && (bookingEntity)));

// EXTERNAL MODULE: ./src/entities/ratioAccommodationExtensionMapItem/entity.ts + 3 modules
var ratioAccommodationExtensionMapItem_entity = __webpack_require__(15561);
// EXTERNAL MODULE: ./src/entities/ratioExtensionAccommodation/entity.ts + 3 modules
var ratioExtensionAccommodation_entity = __webpack_require__(51316);
;// CONCATENATED MODULE: ./src/entities/ratioConfig/graphql.ts
// language=GraphQL
var ALL_RATIO_CONFIGS_QUERY = "query Query($withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {\n  ratioConfigs: ratioConfigs {\n    id\n    travelDocumentationServices @include(if: $withTravelDocumentationServices) {\n      id\n      printServiceNo\n      electronicServiceNo\n    }\n    bargainConfig @include(if: $withBargainConfig) {\n      id\n      active\n      tiers @include(if: $withBargainConfigTiers) {\n        id\n        fromPrice\n        discount\n      }\n      priceCap\n      serviceCodePrefix\n    }\n    esimConfig @include(if: $withEsimConfig) {\n      id\n      enabled\n      regions @include(if: $withEsimConfigRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_RATIO_CONFIG_QUERY = "query Query($id: ID!, $withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {\n  ratioConfig: ratioConfig(id: $id) {\n    id\n    travelDocumentationServices @include(if: $withTravelDocumentationServices) {\n      id\n      printServiceNo\n      electronicServiceNo\n    }\n    bargainConfig @include(if: $withBargainConfig) {\n      id\n      active\n      tiers @include(if: $withBargainConfigTiers) {\n        id\n        fromPrice\n        discount\n      }\n      priceCap\n      serviceCodePrefix\n    }\n    esimConfig @include(if: $withEsimConfig) {\n      id\n      enabled\n      regions @include(if: $withEsimConfigRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateRatioConfigInput, $withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {\n    ratioConfig: createRatioConfig(input: $input) {\n      id\n      travelDocumentationServices @include(if: $withTravelDocumentationServices) {\n        id\n        printServiceNo\n        electronicServiceNo\n      }\n      bargainConfig @include(if: $withBargainConfig) {\n        id\n        active\n        tiers @include(if: $withBargainConfigTiers) {\n          id\n          fromPrice\n          discount\n        }\n        priceCap\n        serviceCodePrefix\n      }\n      esimConfig @include(if: $withEsimConfig) {\n        id\n        enabled\n        regions @include(if: $withEsimConfigRegions) {\n          id\n          name\n          serviceCodePrefix\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateRatioConfigInput, $withTravelDocumentationServices: Boolean = false, $withBargainConfig: Boolean = false, $withBargainConfigTiers: Boolean = false, $withEsimConfig: Boolean = false, $withEsimConfigRegions: Boolean = false) {\n    ratioConfig: updateRatioConfig(input: $input) {\n      id\n      travelDocumentationServices @include(if: $withTravelDocumentationServices) {\n        id\n        printServiceNo\n        electronicServiceNo\n      }\n      bargainConfig @include(if: $withBargainConfig) {\n        id\n        active\n        tiers @include(if: $withBargainConfigTiers) {\n          id\n          fromPrice\n          discount\n        }\n        priceCap\n        serviceCodePrefix\n      }\n      esimConfig @include(if: $withEsimConfig) {\n        id\n        enabled\n        regions @include(if: $withEsimConfigRegions) {\n          id\n          name\n          serviceCodePrefix\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteRatioConfigInput) {\n    deleteRatioConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_RATIO_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteRatioConfigInput) {\n    forceDeleteRatioConfig(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/travelDocumentationServices/graphql.ts
// language=GraphQL
var ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY = "query Query {\n  travelDocumentationServices: allTravelDocumentationServices {\n    id\n    printServiceNo\n    electronicServiceNo\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY = "query Query($id: ID!) {\n  travelDocumentationServices: travelDocumentationServices(id: $id) {\n    id\n    printServiceNo\n    electronicServiceNo\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = "\n  mutation Mutation($input: CreateTravelDocumentationServicesInput) {\n    travelDocumentationServices: createTravelDocumentationServices(input: $input) {\n      id\n      printServiceNo\n      electronicServiceNo\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = "\n  mutation Mutation($input: UpdateTravelDocumentationServicesInput) {\n    travelDocumentationServices: updateTravelDocumentationServices(input: $input) {\n      id\n      printServiceNo\n      electronicServiceNo\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = "\n  mutation Mutation($input: DeleteTravelDocumentationServicesInput) {\n    deleteTravelDocumentationServices(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION = "\n  mutation Mutation($input: DeleteTravelDocumentationServicesInput) {\n    forceDeleteTravelDocumentationServices(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var TRAVEL_DOCUMENTATION_SERVICES_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioConfigs: Boolean = false) {\n  groupedDependents: travelDocumentationServicesDependents(id: $id) {\n    ratioConfigs @include(if: $withRatioConfigs) {\n      id\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/travelDocumentationServices/model.ts

var travelDocumentationServicesModel = {
    name: "travelDocumentationServices",
    namePlural: "travelDocumentationServices",
    uniqueName: "travelDocumentationServices",
    uniqueNamePlural: "travelDocumentationServices",
    path: "config/ratio/travel_documentation_services",
    baseUrl: "/config/ratio/travel_documentation_services",
    translationPrefix: "entities:travelDocumentationServices.",
    getDisplayName: function(values) {
        return "Ratio Travel Documentation Services";
    },
    gql: {
        getAll: ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
        getSingle: SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
        create: CREATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
        update: UPDATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
        delete: DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION
    },
    attributes: {
        printServiceNo: {
            name: "printServiceNo",
            label: "entities:travelDocumentationServices.attributes.printServiceNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        electronicServiceNo: {
            name: "electronicServiceNo",
            label: "entities:travelDocumentationServices.attributes.electronicServiceNo.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var travelDocumentationServices_model = (travelDocumentationServicesModel);

;// CONCATENATED MODULE: ./src/entities/travelDocumentationServices/repository.ts










var travelDocumentationServices_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(travelDocumentationServices_model, object);
    });
};
var travelDocumentationServices_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(travelDocumentationServices_model, object);
};
var travelDocumentationServicesRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY, variables).then(function(data) {
                        return travelDocumentationServices_repository_hydrateObject(data.travelDocumentationServices);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY, includes).then(function(data) {
                    return travelDocumentationServices_repository_hydrateObjects(data.travelDocumentationServices);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : travelDocumentationServices_repository_hydrateObject(data.travelDocumentationServices),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_DOCUMENTATION_SERVICES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : travelDocumentationServices_repository_hydrateObjects(data.travelDocumentationServices),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(TRAVEL_DOCUMENTATION_SERVICES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            TRAVEL_DOCUMENTATION_SERVICES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION, variables).then(function(data) {
                        return travelDocumentationServices_repository_hydrateObject(data.travelDocumentationServices);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION, variables).then(function(data) {
                        return travelDocumentationServices_repository_hydrateObject(data.travelDocumentationServices);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION, variables).then(function(data) {
                        return data.deleteTravelDocumentationServices;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_DOCUMENTATION_SERVICES_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTravelDocumentationServices;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var travelDocumentationServices_repository = (travelDocumentationServicesRepository);

;// CONCATENATED MODULE: ./src/entities/travelDocumentationServices/entity.ts


var travelDocumentationServicesEntity = {
    model: travelDocumentationServices_model,
    repository: travelDocumentationServices_repository
};
/* harmony default export */ var travelDocumentationServices_entity = (travelDocumentationServicesEntity);

;// CONCATENATED MODULE: ./src/entities/ratioBargainConfig/graphql.ts
// language=GraphQL
var ALL_BARGAIN_CONFIGS_QUERY = "query Query($withTiers: Boolean = false) {\n  bargainConfigs: ratioBargainConfigs {\n    id\n    active\n    tiers @include(if: $withTiers) {\n      id\n      fromPrice\n      discount\n    }\n    priceCap\n    serviceCodePrefix\n  }\n}";
// language=GraphQL
var SINGLE_BARGAIN_CONFIG_QUERY = "query Query($id: ID!, $withTiers: Boolean = false) {\n  bargainConfig: ratioBargainConfig(id: $id) {\n    id\n    active\n    tiers @include(if: $withTiers) {\n      id\n      fromPrice\n      discount\n    }\n    priceCap\n    serviceCodePrefix\n  }\n}";
// language=GraphQL
var CREATE_BARGAIN_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateRatioBargainConfigInput, $withTiers: Boolean = false) {\n    bargainConfig: createRatioBargainConfig(input: $input) {\n      id\n      active\n      tiers @include(if: $withTiers) {\n        id\n        fromPrice\n        discount\n      }\n      priceCap\n      serviceCodePrefix\n    }\n  }";
// language=GraphQL
var UPDATE_BARGAIN_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateRatioBargainConfigInput, $withTiers: Boolean = false) {\n    bargainConfig: updateRatioBargainConfig(input: $input) {\n      id\n      active\n      tiers @include(if: $withTiers) {\n        id\n        fromPrice\n        discount\n      }\n      priceCap\n      serviceCodePrefix\n    }\n  }";
// language=GraphQL
var DELETE_BARGAIN_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteRatioBargainConfigInput) {\n    deleteRatioBargainConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BARGAIN_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteRatioBargainConfigInput) {\n    forceDeleteRatioBargainConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_BARGAIN_CONFIG_TIERS_MUTATION = "\n  mutation Mutation($input: addRatioBargainConfigTiersInput) {\n    addRatioBargainConfigTiers(input: $input) {\n      id\n      tierIds\n    }\n  }";
// language=GraphQL
var REMOVE_BARGAIN_CONFIG_TIERS_MUTATION = "\n  mutation Mutation($input: removeRatioBargainConfigTiersInput) {\n    removeRatioBargainConfigTiers(input: $input) {\n      id\n      tierIds\n    }\n  }";
// language=GraphQL
var CREATE_BARGAIN_CONFIG_TIERS_MUTATION = "\n  mutation Mutation($input: createRatioBargainConfigTiersInput) {\n    createRatioBargainConfigTiers(input: $input) {\n      id\n      tierIds\n    }\n  }";
// language=GraphQL
var DELETE_BARGAIN_CONFIG_TIERS_MUTATION = "\n  mutation Mutation($input: deleteRatioBargainConfigTiersInput) {\n    deleteRatioBargainConfigTiers(input: $input) {\n      id\n      tierIds\n    }\n  }";
// language=GraphQL
var UPDATE_BARGAIN_CONFIG_TIERS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioBargainConfigTiersOrderInput) {\n    updateRatioBargainConfigTiersOrder(input: $input) {\n      id\n      tierIds\n    }\n  }";
// language=GraphQL
var BARGAIN_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioConfigs: Boolean = false) {\n  groupedDependents: ratioBargainConfigDependents(id: $id) {\n    ratioConfigs @include(if: $withRatioConfigs) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/bargainTier/entity.ts + 3 modules
var bargainTier_entity = __webpack_require__(90101);
;// CONCATENATED MODULE: ./src/entities/ratioBargainConfig/model.ts


var ratioBargainConfigModel = {
    name: "bargainConfig",
    namePlural: "bargainConfigs",
    uniqueName: "ratioBargainConfig",
    uniqueNamePlural: "ratioBargainConfigs",
    path: "config/ratio/bargain/bargain_config",
    baseUrl: "/config/ratio/bargain/bargain_configs",
    translationPrefix: "entities:ratioBargainConfig.",
    getDisplayName: function(values) {
        return "RATIO BARGAIN CONFIG";
    },
    gql: {
        getAll: ALL_BARGAIN_CONFIGS_QUERY,
        getSingle: SINGLE_BARGAIN_CONFIG_QUERY,
        create: CREATE_BARGAIN_CONFIG_MUTATION,
        update: UPDATE_BARGAIN_CONFIG_MUTATION,
        delete: DELETE_BARGAIN_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_BARGAIN_CONFIG_MUTATION
    },
    attributes: {
        active: {
            name: "active",
            label: "entities:ratioBargainConfig.attributes.active.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        tiers: {
            name: "tiers",
            label: "entities:ratioBargainConfig.attributes.tiers.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return bargainTier_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        priceCap: {
            name: "priceCap",
            label: "entities:ratioBargainConfig.attributes.priceCap.label",
            type: "value",
            dataType: "number",
            defaultInput: false,
            inputType: "number",
            validationType: "string",
            validations: [
                {
                    type: "number"
                }, 
            ]
        },
        serviceCodePrefix: {
            name: "serviceCodePrefix",
            label: "entities:ratioBargainConfig.attributes.serviceCodePrefix.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var ratioBargainConfig_model = (ratioBargainConfigModel);

;// CONCATENATED MODULE: ./src/entities/ratioBargainConfig/repository.ts










var ratioBargainConfig_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(ratioBargainConfig_model, object);
    });
};
var ratioBargainConfig_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(ratioBargainConfig_model, object);
};
var ratioBargainConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BARGAIN_CONFIG_QUERY, variables).then(function(data) {
                        return ratioBargainConfig_repository_hydrateObject(data.bargainConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BARGAIN_CONFIGS_QUERY, includes).then(function(data) {
                    return ratioBargainConfig_repository_hydrateObjects(data.bargainConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BARGAIN_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : ratioBargainConfig_repository_hydrateObject(data.bargainConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BARGAIN_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : ratioBargainConfig_repository_hydrateObjects(data.bargainConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(BARGAIN_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            BARGAIN_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BARGAIN_CONFIG_MUTATION, variables).then(function(data) {
                        return ratioBargainConfig_repository_hydrateObject(data.bargainConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BARGAIN_CONFIG_MUTATION, variables).then(function(data) {
                        return ratioBargainConfig_repository_hydrateObject(data.bargainConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BARGAIN_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteRatioBargainConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BARGAIN_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioBargainConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTiers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tierIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_BARGAIN_CONFIG_TIERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTiers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tierIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_BARGAIN_CONFIG_TIERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTiers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tiers: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BARGAIN_CONFIG_TIERS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTiers: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tierIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BARGAIN_CONFIG_TIERS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTiersOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        tierIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BARGAIN_CONFIG_TIERS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var ratioBargainConfig_repository = (ratioBargainConfigRepository);

;// CONCATENATED MODULE: ./src/entities/ratioBargainConfig/entity.ts


var ratioBargainConfigEntity = {
    model: ratioBargainConfig_model,
    repository: ratioBargainConfig_repository
};
/* harmony default export */ var ratioBargainConfig_entity = (ratioBargainConfigEntity);

;// CONCATENATED MODULE: ./src/entities/ratioEsimConfig/graphql.ts
// language=GraphQL
var ALL_ESIM_CONFIGS_QUERY = "query Query($withRegions: Boolean = false) {\n  esimConfigs: ratioEsimConfigs {\n    id\n    enabled\n    regions @include(if: $withRegions) {\n      id\n      name\n      serviceCodePrefix\n    }\n  }\n}";
// language=GraphQL
var SINGLE_ESIM_CONFIG_QUERY = "query Query($id: ID!, $withRegions: Boolean = false) {\n  esimConfig: ratioEsimConfig(id: $id) {\n    id\n    enabled\n    regions @include(if: $withRegions) {\n      id\n      name\n      serviceCodePrefix\n    }\n  }\n}";
// language=GraphQL
var CREATE_ESIM_CONFIG_MUTATION = "\n  mutation Mutation($input: CreateRatioEsimConfigInput, $withRegions: Boolean = false) {\n    esimConfig: createRatioEsimConfig(input: $input) {\n      id\n      enabled\n      regions @include(if: $withRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_ESIM_CONFIG_MUTATION = "\n  mutation Mutation($input: UpdateRatioEsimConfigInput, $withRegions: Boolean = false) {\n    esimConfig: updateRatioEsimConfig(input: $input) {\n      id\n      enabled\n      regions @include(if: $withRegions) {\n        id\n        name\n        serviceCodePrefix\n      }\n    }\n  }";
// language=GraphQL
var DELETE_ESIM_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteRatioEsimConfigInput) {\n    deleteRatioEsimConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ESIM_CONFIG_MUTATION = "\n  mutation Mutation($input: DeleteRatioEsimConfigInput) {\n    forceDeleteRatioEsimConfig(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_ESIM_CONFIG_REGIONS_MUTATION = "\n  mutation Mutation($input: addRatioEsimConfigRegionsInput) {\n    addRatioEsimConfigRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var REMOVE_ESIM_CONFIG_REGIONS_MUTATION = "\n  mutation Mutation($input: removeRatioEsimConfigRegionsInput) {\n    removeRatioEsimConfigRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var CREATE_ESIM_CONFIG_REGIONS_MUTATION = "\n  mutation Mutation($input: createRatioEsimConfigRegionsInput) {\n    createRatioEsimConfigRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var DELETE_ESIM_CONFIG_REGIONS_MUTATION = "\n  mutation Mutation($input: deleteRatioEsimConfigRegionsInput) {\n    deleteRatioEsimConfigRegions(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var UPDATE_ESIM_CONFIG_REGIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateRatioEsimConfigRegionsOrderInput) {\n    updateRatioEsimConfigRegionsOrder(input: $input) {\n      id\n      regionIds\n    }\n  }";
// language=GraphQL
var ESIM_CONFIGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withRatioConfigs: Boolean = false) {\n  groupedDependents: ratioEsimConfigDependents(id: $id) {\n    ratioConfigs @include(if: $withRatioConfigs) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/ratioEsimRegion/entity.ts + 3 modules
var ratioEsimRegion_entity = __webpack_require__(66819);
;// CONCATENATED MODULE: ./src/entities/ratioEsimConfig/model.ts


var ratioEsimConfigModel = {
    name: "esimConfig",
    namePlural: "esimConfigs",
    uniqueName: "ratioEsimConfig",
    uniqueNamePlural: "ratioEsimConfigs",
    path: "config/ratio/esim/esim_config",
    baseUrl: "/config/ratio/esim/esim_configs",
    translationPrefix: "entities:ratioEsimConfig.",
    getDisplayName: function(values) {
        return "ESIM CONFIG";
    },
    gql: {
        getAll: ALL_ESIM_CONFIGS_QUERY,
        getSingle: SINGLE_ESIM_CONFIG_QUERY,
        create: CREATE_ESIM_CONFIG_MUTATION,
        update: UPDATE_ESIM_CONFIG_MUTATION,
        delete: DELETE_ESIM_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_ESIM_CONFIG_MUTATION
    },
    attributes: {
        enabled: {
            name: "enabled",
            label: "entities:ratioEsimConfig.attributes.enabled.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        regions: {
            name: "regions",
            label: "entities:ratioEsimConfig.attributes.regions.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return ratioEsimRegion_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var ratioEsimConfig_model = (ratioEsimConfigModel);

;// CONCATENATED MODULE: ./src/entities/ratioEsimConfig/repository.ts










var ratioEsimConfig_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(ratioEsimConfig_model, object);
    });
};
var ratioEsimConfig_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(ratioEsimConfig_model, object);
};
var ratioEsimConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ESIM_CONFIG_QUERY, variables).then(function(data) {
                        return ratioEsimConfig_repository_hydrateObject(data.esimConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ESIM_CONFIGS_QUERY, includes).then(function(data) {
                    return ratioEsimConfig_repository_hydrateObjects(data.esimConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ESIM_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : ratioEsimConfig_repository_hydrateObject(data.esimConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ESIM_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : ratioEsimConfig_repository_hydrateObjects(data.esimConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(ESIM_CONFIGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            ESIM_CONFIGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ESIM_CONFIG_MUTATION, variables).then(function(data) {
                        return ratioEsimConfig_repository_hydrateObject(data.esimConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ESIM_CONFIG_MUTATION, variables).then(function(data) {
                        return ratioEsimConfig_repository_hydrateObject(data.esimConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ESIM_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteRatioEsimConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ESIM_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioEsimConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_ESIM_CONFIG_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_ESIM_CONFIG_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regions: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ESIM_CONFIG_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteRegions: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ESIM_CONFIG_REGIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateRegionsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        regionIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ESIM_CONFIG_REGIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var ratioEsimConfig_repository = (ratioEsimConfigRepository);

;// CONCATENATED MODULE: ./src/entities/ratioEsimConfig/entity.ts


var ratioEsimConfigEntity = {
    model: ratioEsimConfig_model,
    repository: ratioEsimConfig_repository
};
/* harmony default export */ var ratioEsimConfig_entity = (ratioEsimConfigEntity);

;// CONCATENATED MODULE: ./src/entities/ratioConfig/model.ts




var ratioConfigModel = {
    name: "ratioConfig",
    namePlural: "ratioConfigs",
    uniqueName: "ratioConfig",
    uniqueNamePlural: "ratioConfigs",
    path: "config/ratio/ratio_config",
    baseUrl: "/config/ratio",
    translationPrefix: "entities:ratioConfig.",
    getDisplayName: function(values) {
        return "Ratio Config";
    },
    gql: {
        getAll: ALL_RATIO_CONFIGS_QUERY,
        getSingle: SINGLE_RATIO_CONFIG_QUERY,
        create: CREATE_RATIO_CONFIG_MUTATION,
        update: UPDATE_RATIO_CONFIG_MUTATION,
        delete: DELETE_RATIO_CONFIG_MUTATION,
        forceDelete: FORCE_DELETE_RATIO_CONFIG_MUTATION
    },
    attributes: {
        travelDocumentationServices: {
            name: "travelDocumentationServices",
            label: "entities:ratioConfig.attributes.travelDocumentationServices.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return travelDocumentationServices_entity;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        bargainConfig: {
            name: "bargainConfig",
            label: "entities:ratioConfig.attributes.bargainConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioBargainConfig_entity;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        esimConfig: {
            name: "esimConfig",
            label: "entities:ratioConfig.attributes.esimConfig.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return ratioEsimConfig_entity;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var ratioConfig_model = (ratioConfigModel);

;// CONCATENATED MODULE: ./src/entities/ratioConfig/repository.ts









var ratioConfig_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(ratioConfig_model, object);
    });
};
var ratioConfig_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(ratioConfig_model, object);
};
var ratioConfigRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_RATIO_CONFIG_QUERY, variables).then(function(data) {
                        return ratioConfig_repository_hydrateObject(data.ratioConfig);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_RATIO_CONFIGS_QUERY, includes).then(function(data) {
                    return ratioConfig_repository_hydrateObjects(data.ratioConfigs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_RATIO_CONFIG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : ratioConfig_repository_hydrateObject(data.ratioConfig),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_RATIO_CONFIGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : ratioConfig_repository_hydrateObjects(data.ratioConfigs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return ratioConfig_repository_hydrateObject(data.ratioConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return ratioConfig_repository_hydrateObject(data.ratioConfig);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return data.deleteRatioConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_RATIO_CONFIG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteRatioConfig;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var ratioConfig_repository = (ratioConfigRepository);

;// CONCATENATED MODULE: ./src/entities/ratioConfig/entity.ts


var ratioConfigEntity = {
    model: ratioConfig_model,
    repository: ratioConfig_repository
};
/* harmony default export */ var ratioConfig_entity = ((/* unused pure expression or super */ null && (ratioConfigEntity)));

// EXTERNAL MODULE: ./src/entities/ratioPersonalDiscount/entity.ts + 3 modules
var ratioPersonalDiscount_entity = __webpack_require__(52374);
// EXTERNAL MODULE: ./src/entities/tenantEmailConfig/entity.ts + 3 modules
var tenantEmailConfig_entity = __webpack_require__(22521);
;// CONCATENATED MODULE: ./src/entities/cmsImageBlock/graphql.ts
// language=GraphQL
var ALL_IMAGE_BLOCKS_QUERY = "query Query($withImage: Boolean = false) {\n  imageBlocks: cmsImageBlocks {\n    id\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    text\n    fluid\n  }\n}";
// language=GraphQL
var SINGLE_IMAGE_BLOCK_QUERY = "query Query($id: ID!, $withImage: Boolean = false) {\n  imageBlock: cmsImageBlock(id: $id) {\n    id\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    text\n    fluid\n  }\n}";
// language=GraphQL
var CREATE_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsImageBlockInput, $withImage: Boolean = false) {\n    imageBlock: createCmsImageBlock(input: $input) {\n      id\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      text\n      fluid\n    }\n  }";
// language=GraphQL
var UPDATE_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsImageBlockInput, $withImage: Boolean = false) {\n    imageBlock: updateCmsImageBlock(input: $input) {\n      id\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      text\n      fluid\n    }\n  }";
// language=GraphQL
var DELETE_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsImageBlockInput) {\n    deleteCmsImageBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_IMAGE_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsImageBlockInput) {\n    forceDeleteCmsImageBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsImageBlock/model.ts


var cmsImageBlockModel = {
    name: "imageBlock",
    namePlural: "imageBlocks",
    uniqueName: "cmsImageBlock",
    uniqueNamePlural: "cmsImageBlocks",
    path: "cms/blocks/image_block",
    baseUrl: "/cms/blocks/image_blocks",
    translationPrefix: "entities:cmsImageBlock.",
    getDisplayName: function(values) {
        return "Image Block";
    },
    gql: {
        getAll: ALL_IMAGE_BLOCKS_QUERY,
        getSingle: SINGLE_IMAGE_BLOCK_QUERY,
        create: CREATE_IMAGE_BLOCK_MUTATION,
        update: UPDATE_IMAGE_BLOCK_MUTATION,
        delete: DELETE_IMAGE_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_IMAGE_BLOCK_MUTATION
    },
    attributes: {
        image: {
            name: "image",
            label: "entities:cmsImageBlock.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        text: {
            name: "text",
            label: "entities:cmsImageBlock.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            maxLength: 255,
            validationType: "string",
            validations: []
        },
        fluid: {
            name: "fluid",
            label: "entities:cmsImageBlock.attributes.fluid.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsImageBlock_model = (cmsImageBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsImageBlock/repository.ts









var cmsImageBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsImageBlock_model, object);
    });
};
var cmsImageBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsImageBlock_model, object);
};
var cmsImageBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_IMAGE_BLOCK_QUERY, variables).then(function(data) {
                        return cmsImageBlock_repository_hydrateObject(data.imageBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_IMAGE_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsImageBlock_repository_hydrateObjects(data.imageBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_IMAGE_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsImageBlock_repository_hydrateObject(data.imageBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_IMAGE_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsImageBlock_repository_hydrateObjects(data.imageBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsImageBlock_repository_hydrateObject(data.imageBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsImageBlock_repository_hydrateObject(data.imageBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsImageBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_IMAGE_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsImageBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsImageBlock_repository = (cmsImageBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsImageBlock/entity.ts


var cmsImageBlockEntity = {
    model: cmsImageBlock_model,
    repository: cmsImageBlock_repository
};
/* harmony default export */ var cmsImageBlock_entity = ((/* unused pure expression or super */ null && (cmsImageBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsEmployeesBlock/graphql.ts
// language=GraphQL
var ALL_EMPLOYEES_BLOCKS_QUERY = "query Query($withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {\n  employeesBlocks: cmsEmployeesBlocks {\n    id\n    employees @include(if: $withEmployees) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withEmployeesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n  }\n}";
// language=GraphQL
var SINGLE_EMPLOYEES_BLOCK_QUERY = "query Query($id: ID!, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {\n  employeesBlock: cmsEmployeesBlock(id: $id) {\n    id\n    employees @include(if: $withEmployees) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withEmployeesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n  }\n}";
// language=GraphQL
var CREATE_EMPLOYEES_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsEmployeesBlockInput, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {\n    employeesBlock: createCmsEmployeesBlock(input: $input) {\n      id\n      employees @include(if: $withEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_EMPLOYEES_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsEmployeesBlockInput, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false) {\n    employeesBlock: updateCmsEmployeesBlock(input: $input) {\n      id\n      employees @include(if: $withEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n    }\n  }";
// language=GraphQL
var DELETE_EMPLOYEES_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsEmployeesBlockInput) {\n    deleteCmsEmployeesBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_EMPLOYEES_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsEmployeesBlockInput) {\n    forceDeleteCmsEmployeesBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: addCmsEmployeesBlockEmployeesInput) {\n    addCmsEmployeesBlockEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var REMOVE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: removeCmsEmployeesBlockEmployeesInput) {\n    removeCmsEmployeesBlockEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var CREATE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: createCmsEmployeesBlockEmployeesInput) {\n    createCmsEmployeesBlockEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var DELETE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION = "\n  mutation Mutation($input: deleteCmsEmployeesBlockEmployeesInput) {\n    deleteCmsEmployeesBlockEmployees(input: $input) {\n      id\n      employeeIds\n    }\n  }";
// language=GraphQL
var UPDATE_EMPLOYEES_BLOCK_EMPLOYEES_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsEmployeesBlockEmployeesOrderInput) {\n    updateCmsEmployeesBlockEmployeesOrder(input: $input) {\n      id\n      employeeIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsEmployeesBlock/model.ts


var cmsEmployeesBlockModel = {
    name: "employeesBlock",
    namePlural: "employeesBlocks",
    uniqueName: "cmsEmployeesBlock",
    uniqueNamePlural: "cmsEmployeesBlocks",
    path: "cms/blocks/employees_block",
    baseUrl: "/cms/blocks/employees_blocks",
    translationPrefix: "entities:cmsEmployeesBlock.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_EMPLOYEES_BLOCKS_QUERY,
        getSingle: SINGLE_EMPLOYEES_BLOCK_QUERY,
        create: CREATE_EMPLOYEES_BLOCK_MUTATION,
        update: UPDATE_EMPLOYEES_BLOCK_MUTATION,
        delete: DELETE_EMPLOYEES_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_EMPLOYEES_BLOCK_MUTATION
    },
    attributes: {
        employees: {
            name: "employees",
            label: "entities:cmsEmployeesBlock.attributes.employees.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return employee_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsEmployeesBlock_model = (cmsEmployeesBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsEmployeesBlock/repository.ts









var cmsEmployeesBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsEmployeesBlock_model, object);
    });
};
var cmsEmployeesBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsEmployeesBlock_model, object);
};
var cmsEmployeesBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_EMPLOYEES_BLOCK_QUERY, variables).then(function(data) {
                        return cmsEmployeesBlock_repository_hydrateObject(data.employeesBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_EMPLOYEES_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsEmployeesBlock_repository_hydrateObjects(data.employeesBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_EMPLOYEES_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsEmployeesBlock_repository_hydrateObject(data.employeesBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_EMPLOYEES_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsEmployeesBlock_repository_hydrateObjects(data.employeesBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EMPLOYEES_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsEmployeesBlock_repository_hydrateObject(data.employeesBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EMPLOYEES_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsEmployeesBlock_repository_hydrateObject(data.employeesBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EMPLOYEES_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsEmployeesBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_EMPLOYEES_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsEmployeesBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employees: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteEmployees: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_EMPLOYEES_BLOCK_EMPLOYEES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateEmployeesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        employeeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_EMPLOYEES_BLOCK_EMPLOYEES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsEmployeesBlock_repository = (cmsEmployeesBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsEmployeesBlock/entity.ts


var cmsEmployeesBlockEntity = {
    model: cmsEmployeesBlock_model,
    repository: cmsEmployeesBlock_repository
};
/* harmony default export */ var cmsEmployeesBlock_entity = ((/* unused pure expression or super */ null && (cmsEmployeesBlockEntity)));

// EXTERNAL MODULE: ./src/entities/cmsConfig/entity.ts + 3 modules
var cmsConfig_entity = __webpack_require__(78069);
// EXTERNAL MODULE: ./src/entities/cmsContactBlockSettings/entity.ts + 3 modules
var cmsContactBlockSettings_entity = __webpack_require__(14214);
;// CONCATENATED MODULE: ./src/entities/cmsContactBannerBlock/graphql.ts
// language=GraphQL
var ALL_CONTACT_BANNER_BLOCKS_QUERY = "query Query($withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {\n  contactBannerBlocks: cmsContactBannerBlocks {\n    id\n    employee @include(if: $withEmployee) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withEmployeeImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n    phone\n    email\n  }\n}";
// language=GraphQL
var SINGLE_CONTACT_BANNER_BLOCK_QUERY = "query Query($id: ID!, $withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {\n  contactBannerBlock: cmsContactBannerBlock(id: $id) {\n    id\n    employee @include(if: $withEmployee) {\n      id\n      firstName\n      lastName\n      jobTitle\n      description\n      email\n      image @include(if: $withEmployeeImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      phone\n    }\n    phone\n    email\n  }\n}";
// language=GraphQL
var CREATE_CONTACT_BANNER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsContactBannerBlockInput, $withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {\n    contactBannerBlock: createCmsContactBannerBlock(input: $input) {\n      id\n      employee @include(if: $withEmployee) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withEmployeeImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      phone\n      email\n    }\n  }";
// language=GraphQL
var UPDATE_CONTACT_BANNER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsContactBannerBlockInput, $withEmployee: Boolean = false, $withEmployeeImage: Boolean = false) {\n    contactBannerBlock: updateCmsContactBannerBlock(input: $input) {\n      id\n      employee @include(if: $withEmployee) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withEmployeeImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      phone\n      email\n    }\n  }";
// language=GraphQL
var DELETE_CONTACT_BANNER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsContactBannerBlockInput) {\n    deleteCmsContactBannerBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CONTACT_BANNER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsContactBannerBlockInput) {\n    forceDeleteCmsContactBannerBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsContactBannerBlock/model.ts


var cmsContactBannerBlockModel = {
    name: "contactBannerBlock",
    namePlural: "contactBannerBlocks",
    uniqueName: "cmsContactBannerBlock",
    uniqueNamePlural: "cmsContactBannerBlocks",
    path: "cms/blocks/contact_banner_block",
    baseUrl: "/cms/blocks/contact_banner_blocks",
    translationPrefix: "entities:cmsContactBannerBlock.",
    getDisplayName: function(values) {
        return "Contact Banner Block";
    },
    gql: {
        getAll: ALL_CONTACT_BANNER_BLOCKS_QUERY,
        getSingle: SINGLE_CONTACT_BANNER_BLOCK_QUERY,
        create: CREATE_CONTACT_BANNER_BLOCK_MUTATION,
        update: UPDATE_CONTACT_BANNER_BLOCK_MUTATION,
        delete: DELETE_CONTACT_BANNER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_CONTACT_BANNER_BLOCK_MUTATION
    },
    attributes: {
        employee: {
            name: "employee",
            label: "entities:cmsContactBannerBlock.attributes.employee.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return employee_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        phone: {
            name: "phone",
            label: "entities:cmsContactBannerBlock.attributes.phone.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        email: {
            name: "email",
            label: "entities:cmsContactBannerBlock.attributes.email.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "email"
                }, 
            ]
        }
    }
};
/* harmony default export */ var cmsContactBannerBlock_model = (cmsContactBannerBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsContactBannerBlock/repository.ts









var cmsContactBannerBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsContactBannerBlock_model, object);
    });
};
var cmsContactBannerBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsContactBannerBlock_model, object);
};
var cmsContactBannerBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CONTACT_BANNER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsContactBannerBlock_repository_hydrateObject(data.contactBannerBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CONTACT_BANNER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsContactBannerBlock_repository_hydrateObjects(data.contactBannerBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CONTACT_BANNER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsContactBannerBlock_repository_hydrateObject(data.contactBannerBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CONTACT_BANNER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsContactBannerBlock_repository_hydrateObjects(data.contactBannerBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CONTACT_BANNER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsContactBannerBlock_repository_hydrateObject(data.contactBannerBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CONTACT_BANNER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsContactBannerBlock_repository_hydrateObject(data.contactBannerBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CONTACT_BANNER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsContactBannerBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CONTACT_BANNER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsContactBannerBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsContactBannerBlock_repository = (cmsContactBannerBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsContactBannerBlock/entity.ts


var cmsContactBannerBlockEntity = {
    model: cmsContactBannerBlock_model,
    repository: cmsContactBannerBlock_repository
};
/* harmony default export */ var cmsContactBannerBlock_entity = ((/* unused pure expression or super */ null && (cmsContactBannerBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsIssuuCatalogBlock/graphql.ts
// language=GraphQL
var ALL_ISSUU_CATALOG_BLOCKS_QUERY = "query Query {\n  issuuCatalogBlocks: cmsIssuuCatalogBlocks {\n    id\n    publicationCode\n    accountName\n  }\n}";
// language=GraphQL
var SINGLE_ISSUU_CATALOG_BLOCK_QUERY = "query Query($id: ID!) {\n  issuuCatalogBlock: cmsIssuuCatalogBlock(id: $id) {\n    id\n    publicationCode\n    accountName\n  }\n}";
// language=GraphQL
var CREATE_ISSUU_CATALOG_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsIssuuCatalogBlockInput) {\n    issuuCatalogBlock: createCmsIssuuCatalogBlock(input: $input) {\n      id\n      publicationCode\n      accountName\n    }\n  }";
// language=GraphQL
var UPDATE_ISSUU_CATALOG_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsIssuuCatalogBlockInput) {\n    issuuCatalogBlock: updateCmsIssuuCatalogBlock(input: $input) {\n      id\n      publicationCode\n      accountName\n    }\n  }";
// language=GraphQL
var DELETE_ISSUU_CATALOG_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsIssuuCatalogBlockInput) {\n    deleteCmsIssuuCatalogBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_ISSUU_CATALOG_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsIssuuCatalogBlockInput) {\n    forceDeleteCmsIssuuCatalogBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsIssuuCatalogBlock/model.ts

var cmsIssuuCatalogBlockModel = {
    name: "issuuCatalogBlock",
    namePlural: "issuuCatalogBlocks",
    uniqueName: "cmsIssuuCatalogBlock",
    uniqueNamePlural: "cmsIssuuCatalogBlocks",
    path: "cms/blocks/issuu_catalog_block",
    baseUrl: "/cms/blocks/issuu_catalog_blocks",
    translationPrefix: "entities:cmsIssuuCatalogBlock.",
    getDisplayName: function(values) {
        return "Issuu Catalog Block";
    },
    gql: {
        getAll: ALL_ISSUU_CATALOG_BLOCKS_QUERY,
        getSingle: SINGLE_ISSUU_CATALOG_BLOCK_QUERY,
        create: CREATE_ISSUU_CATALOG_BLOCK_MUTATION,
        update: UPDATE_ISSUU_CATALOG_BLOCK_MUTATION,
        delete: DELETE_ISSUU_CATALOG_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_ISSUU_CATALOG_BLOCK_MUTATION
    },
    attributes: {
        publicationCode: {
            name: "publicationCode",
            label: "entities:cmsIssuuCatalogBlock.attributes.publicationCode.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^[a-z0-9_-]*$/
                }, 
            ]
        },
        accountName: {
            name: "accountName",
            label: "entities:cmsIssuuCatalogBlock.attributes.accountName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "regex",
                    pattern: /^[a-z0-9_]*$/
                }, 
            ]
        }
    }
};
/* harmony default export */ var cmsIssuuCatalogBlock_model = (cmsIssuuCatalogBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsIssuuCatalogBlock/repository.ts









var cmsIssuuCatalogBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsIssuuCatalogBlock_model, object);
    });
};
var cmsIssuuCatalogBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsIssuuCatalogBlock_model, object);
};
var cmsIssuuCatalogBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_ISSUU_CATALOG_BLOCK_QUERY, variables).then(function(data) {
                        return cmsIssuuCatalogBlock_repository_hydrateObject(data.issuuCatalogBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_ISSUU_CATALOG_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsIssuuCatalogBlock_repository_hydrateObjects(data.issuuCatalogBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_ISSUU_CATALOG_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsIssuuCatalogBlock_repository_hydrateObject(data.issuuCatalogBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_ISSUU_CATALOG_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsIssuuCatalogBlock_repository_hydrateObjects(data.issuuCatalogBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_ISSUU_CATALOG_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsIssuuCatalogBlock_repository_hydrateObject(data.issuuCatalogBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_ISSUU_CATALOG_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsIssuuCatalogBlock_repository_hydrateObject(data.issuuCatalogBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_ISSUU_CATALOG_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsIssuuCatalogBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_ISSUU_CATALOG_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsIssuuCatalogBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsIssuuCatalogBlock_repository = (cmsIssuuCatalogBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsIssuuCatalogBlock/entity.ts


var cmsIssuuCatalogBlockEntity = {
    model: cmsIssuuCatalogBlock_model,
    repository: cmsIssuuCatalogBlock_repository
};
/* harmony default export */ var cmsIssuuCatalogBlock_entity = ((/* unused pure expression or super */ null && (cmsIssuuCatalogBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsNewsletterRegisterBlock/graphql.ts
// language=GraphQL
var ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY = "query Query {\n  newsletterRegisterBlocks: cmsNewsletterRegisterBlocks {\n    id\n    fluid\n  }\n}";
// language=GraphQL
var SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY = "query Query($id: ID!) {\n  newsletterRegisterBlock: cmsNewsletterRegisterBlock(id: $id) {\n    id\n    fluid\n  }\n}";
// language=GraphQL
var CREATE_NEWSLETTER_REGISTER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsNewsletterRegisterBlockInput) {\n    newsletterRegisterBlock: createCmsNewsletterRegisterBlock(input: $input) {\n      id\n      fluid\n    }\n  }";
// language=GraphQL
var UPDATE_NEWSLETTER_REGISTER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsNewsletterRegisterBlockInput) {\n    newsletterRegisterBlock: updateCmsNewsletterRegisterBlock(input: $input) {\n      id\n      fluid\n    }\n  }";
// language=GraphQL
var DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsNewsletterRegisterBlockInput) {\n    deleteCmsNewsletterRegisterBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsNewsletterRegisterBlockInput) {\n    forceDeleteCmsNewsletterRegisterBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsNewsletterRegisterBlock/model.ts

var cmsNewsletterRegisterBlockModel = {
    name: "newsletterRegisterBlock",
    namePlural: "newsletterRegisterBlocks",
    uniqueName: "cmsNewsletterRegisterBlock",
    uniqueNamePlural: "cmsNewsletterRegisterBlocks",
    path: "cms/blocks/newsletter_register_block",
    baseUrl: "/cms/blocks/newsletter_register_blocks",
    translationPrefix: "entities:cmsNewsletterRegisterBlock.",
    getDisplayName: function(values) {
        return "CMS Newsletter Register Block";
    },
    gql: {
        getAll: ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY,
        getSingle: SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY,
        create: CREATE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
        update: UPDATE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
        delete: DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION
    },
    attributes: {
        fluid: {
            name: "fluid",
            label: "entities:cmsNewsletterRegisterBlock.attributes.fluid.label",
            type: "value",
            dataType: "boolean",
            defaultValue: true,
            defaultInput: false,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsNewsletterRegisterBlock_model = (cmsNewsletterRegisterBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsNewsletterRegisterBlock/repository.ts









var cmsNewsletterRegisterBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsNewsletterRegisterBlock_model, object);
    });
};
var cmsNewsletterRegisterBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsNewsletterRegisterBlock_model, object);
};
var cmsNewsletterRegisterBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsNewsletterRegisterBlock_repository_hydrateObject(data.newsletterRegisterBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsNewsletterRegisterBlock_repository_hydrateObjects(data.newsletterRegisterBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsNewsletterRegisterBlock_repository_hydrateObject(data.newsletterRegisterBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsNewsletterRegisterBlock_repository_hydrateObjects(data.newsletterRegisterBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_NEWSLETTER_REGISTER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsNewsletterRegisterBlock_repository_hydrateObject(data.newsletterRegisterBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_NEWSLETTER_REGISTER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsNewsletterRegisterBlock_repository_hydrateObject(data.newsletterRegisterBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsNewsletterRegisterBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsNewsletterRegisterBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsNewsletterRegisterBlock_repository = (cmsNewsletterRegisterBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsNewsletterRegisterBlock/entity.ts


var cmsNewsletterRegisterBlockEntity = {
    model: cmsNewsletterRegisterBlock_model,
    repository: cmsNewsletterRegisterBlock_repository
};
/* harmony default export */ var cmsNewsletterRegisterBlock_entity = ((/* unused pure expression or super */ null && (cmsNewsletterRegisterBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsFormBlock/graphql.ts
// language=GraphQL
var ALL_FORM_BLOCKS_QUERY = "query Query {\n  formBlocks: cmsFormBlocks {\n    id\n    formName\n  }\n}";
// language=GraphQL
var SINGLE_FORM_BLOCK_QUERY = "query Query($id: ID!) {\n  formBlock: cmsFormBlock(id: $id) {\n    id\n    formName\n  }\n}";
// language=GraphQL
var CREATE_FORM_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsFormBlockInput) {\n    formBlock: createCmsFormBlock(input: $input) {\n      id\n      formName\n    }\n  }";
// language=GraphQL
var UPDATE_FORM_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsFormBlockInput) {\n    formBlock: updateCmsFormBlock(input: $input) {\n      id\n      formName\n    }\n  }";
// language=GraphQL
var DELETE_FORM_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsFormBlockInput) {\n    deleteCmsFormBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FORM_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsFormBlockInput) {\n    forceDeleteCmsFormBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsFormBlock/model.ts

var cmsFormBlockModel = {
    name: "formBlock",
    namePlural: "formBlocks",
    uniqueName: "cmsFormBlock",
    uniqueNamePlural: "cmsFormBlocks",
    path: "cms/blocks/form_block",
    baseUrl: "/cms/blocks/form_blocks",
    translationPrefix: "entities:cmsFormBlock.",
    getDisplayName: function(values) {
        return "CMS Form Block";
    },
    gql: {
        getAll: ALL_FORM_BLOCKS_QUERY,
        getSingle: SINGLE_FORM_BLOCK_QUERY,
        create: CREATE_FORM_BLOCK_MUTATION,
        update: UPDATE_FORM_BLOCK_MUTATION,
        delete: DELETE_FORM_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_FORM_BLOCK_MUTATION
    },
    attributes: {
        formName: {
            name: "formName",
            label: "entities:cmsFormBlock.attributes.formName.label",
            type: "value",
            dataType: "string",
            defaultValue: "contact",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsFormBlock_model = (cmsFormBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsFormBlock/repository.ts









var cmsFormBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsFormBlock_model, object);
    });
};
var cmsFormBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsFormBlock_model, object);
};
var cmsFormBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FORM_BLOCK_QUERY, variables).then(function(data) {
                        return cmsFormBlock_repository_hydrateObject(data.formBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FORM_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsFormBlock_repository_hydrateObjects(data.formBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FORM_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsFormBlock_repository_hydrateObject(data.formBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FORM_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsFormBlock_repository_hydrateObjects(data.formBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FORM_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsFormBlock_repository_hydrateObject(data.formBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FORM_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsFormBlock_repository_hydrateObject(data.formBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FORM_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsFormBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FORM_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsFormBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsFormBlock_repository = (cmsFormBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsFormBlock/entity.ts


var cmsFormBlockEntity = {
    model: cmsFormBlock_model,
    repository: cmsFormBlock_repository
};
/* harmony default export */ var cmsFormBlock_entity = ((/* unused pure expression or super */ null && (cmsFormBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlock/graphql.ts
// language=GraphQL
var ALL_HEADER_SLIDER_BLOCKS_QUERY = "query Query($withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withSlides: Boolean = false, $withSlidesImage: Boolean = false, $withSlidesLink: Boolean = false, $withSlidesLinkPage: Boolean = false, $withSlidesLinkTravel: Boolean = false) {\n  headerSliderBlocks: cmsHeaderSliderBlocks {\n    id\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelsTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelsTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelsLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelsSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelsTenantSettings) {\n        id\n        tenant @include(if: $withTravelsTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelsHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelsPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelsPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelsTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelsTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelsTeams) {\n        id\n        name\n        members @include(if: $withTravelsTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelsAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelsAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelsDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelsTestimonials) {\n        id\n        contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelsMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelsMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelsGallery) {\n        id\n        images @include(if: $withTravelsGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelsTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelsTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelsTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelsItinerary) {\n        id\n        items @include(if: $withTravelsItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelsPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelsPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelsPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelsPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelsPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelsPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n    slides @include(if: $withSlides) {\n      id\n      image @include(if: $withSlidesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      title\n      text\n      link @include(if: $withSlidesLink) {\n        id\n        label\n        targetBlank\n        type\n        url\n        page @include(if: $withSlidesLinkPage) {\n          id\n          name\n          onlineStatus\n        }\n        travel @include(if: $withSlidesLinkTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_HEADER_SLIDER_BLOCK_QUERY = "query Query($id: ID!, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withSlides: Boolean = false, $withSlidesImage: Boolean = false, $withSlidesLink: Boolean = false, $withSlidesLinkPage: Boolean = false, $withSlidesLinkTravel: Boolean = false) {\n  headerSliderBlock: cmsHeaderSliderBlock(id: $id) {\n    id\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelsTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelsTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelsLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelsSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelsTenantSettings) {\n        id\n        tenant @include(if: $withTravelsTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelsHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelsPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelsPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelsTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelsTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelsTeams) {\n        id\n        name\n        members @include(if: $withTravelsTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelsAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelsAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelsDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelsTestimonials) {\n        id\n        contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelsMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelsMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelsGallery) {\n        id\n        images @include(if: $withTravelsGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelsTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelsTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelsTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelsItinerary) {\n        id\n        items @include(if: $withTravelsItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelsPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelsPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelsPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelsPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelsPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelsPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n    slides @include(if: $withSlides) {\n      id\n      image @include(if: $withSlidesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      title\n      text\n      link @include(if: $withSlidesLink) {\n        id\n        label\n        targetBlank\n        type\n        url\n        page @include(if: $withSlidesLinkPage) {\n          id\n          name\n          onlineStatus\n        }\n        travel @include(if: $withSlidesLinkTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_HEADER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsHeaderSliderBlockInput, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withSlides: Boolean = false, $withSlidesImage: Boolean = false, $withSlidesLink: Boolean = false, $withSlidesLinkPage: Boolean = false, $withSlidesLinkTravel: Boolean = false) {\n    headerSliderBlock: createCmsHeaderSliderBlock(input: $input) {\n      id\n      travels @include(if: $withTravels) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelsTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelsTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelsLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelsSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelsTenantSettings) {\n          id\n          tenant @include(if: $withTravelsTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelsHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelsPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelsPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelsTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelsTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelsTeams) {\n          id\n          name\n          members @include(if: $withTravelsTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelsAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelsAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelsDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelsTestimonials) {\n          id\n          contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelsMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelsMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelsGallery) {\n          id\n          images @include(if: $withTravelsGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelsTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelsTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelsTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelsItinerary) {\n          id\n          items @include(if: $withTravelsItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelsPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelsPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelsPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelsPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelsPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelsPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      slides @include(if: $withSlides) {\n        id\n        image @include(if: $withSlidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        title\n        text\n        link @include(if: $withSlidesLink) {\n          id\n          label\n          targetBlank\n          type\n          url\n          page @include(if: $withSlidesLinkPage) {\n            id\n            name\n            onlineStatus\n          }\n          travel @include(if: $withSlidesLinkTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_HEADER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsHeaderSliderBlockInput, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false, $withSlides: Boolean = false, $withSlidesImage: Boolean = false, $withSlidesLink: Boolean = false, $withSlidesLinkPage: Boolean = false, $withSlidesLinkTravel: Boolean = false) {\n    headerSliderBlock: updateCmsHeaderSliderBlock(input: $input) {\n      id\n      travels @include(if: $withTravels) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelsTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelsTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelsLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelsSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelsTenantSettings) {\n          id\n          tenant @include(if: $withTravelsTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelsHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelsPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelsPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelsTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelsTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelsTeams) {\n          id\n          name\n          members @include(if: $withTravelsTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelsAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelsAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelsDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelsTestimonials) {\n          id\n          contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelsMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelsMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelsGallery) {\n          id\n          images @include(if: $withTravelsGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelsTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelsTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelsTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelsItinerary) {\n          id\n          items @include(if: $withTravelsItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelsPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelsPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelsPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelsPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelsPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelsPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n      slides @include(if: $withSlides) {\n        id\n        image @include(if: $withSlidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        title\n        text\n        link @include(if: $withSlidesLink) {\n          id\n          label\n          targetBlank\n          type\n          url\n          page @include(if: $withSlidesLinkPage) {\n            id\n            name\n            onlineStatus\n          }\n          travel @include(if: $withSlidesLinkTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_HEADER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsHeaderSliderBlockInput) {\n    deleteCmsHeaderSliderBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_HEADER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsHeaderSliderBlockInput) {\n    forceDeleteCmsHeaderSliderBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: addCmsHeaderSliderBlockTravelsInput) {\n    addCmsHeaderSliderBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var REMOVE_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: removeCmsHeaderSliderBlockTravelsInput) {\n    removeCmsHeaderSliderBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var CREATE_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: createCmsHeaderSliderBlockTravelsInput) {\n    createCmsHeaderSliderBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var DELETE_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: deleteCmsHeaderSliderBlockTravelsInput) {\n    deleteCmsHeaderSliderBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var UPDATE_HEADER_SLIDER_BLOCK_TRAVELS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsHeaderSliderBlockTravelsOrderInput) {\n    updateCmsHeaderSliderBlockTravelsOrder(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var ADD_HEADER_SLIDER_BLOCK_SLIDES_MUTATION = "\n  mutation Mutation($input: addCmsHeaderSliderBlockSlidesInput) {\n    addCmsHeaderSliderBlockSlides(input: $input) {\n      id\n      slideIds\n    }\n  }";
// language=GraphQL
var REMOVE_HEADER_SLIDER_BLOCK_SLIDES_MUTATION = "\n  mutation Mutation($input: removeCmsHeaderSliderBlockSlidesInput) {\n    removeCmsHeaderSliderBlockSlides(input: $input) {\n      id\n      slideIds\n    }\n  }";
// language=GraphQL
var CREATE_HEADER_SLIDER_BLOCK_SLIDES_MUTATION = "\n  mutation Mutation($input: createCmsHeaderSliderBlockSlidesInput) {\n    createCmsHeaderSliderBlockSlides(input: $input) {\n      id\n      slideIds\n    }\n  }";
// language=GraphQL
var DELETE_HEADER_SLIDER_BLOCK_SLIDES_MUTATION = "\n  mutation Mutation($input: deleteCmsHeaderSliderBlockSlidesInput) {\n    deleteCmsHeaderSliderBlockSlides(input: $input) {\n      id\n      slideIds\n    }\n  }";
// language=GraphQL
var UPDATE_HEADER_SLIDER_BLOCK_SLIDES_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsHeaderSliderBlockSlidesOrderInput) {\n    updateCmsHeaderSliderBlockSlidesOrder(input: $input) {\n      id\n      slideIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlockSlide/graphql.ts
// language=GraphQL
var ALL_HEADER_SLIDER_BLOCK_SLIDES_QUERY = "query Query($withImage: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n  headerSliderBlockSlides: cmsHeaderSliderBlockSlides {\n    id\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    title\n    text\n    link @include(if: $withLink) {\n      id\n      label\n      targetBlank\n      type\n      url\n      page @include(if: $withLinkPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withLinkPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      travel @include(if: $withLinkTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withLinkTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withLinkTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withLinkTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withLinkTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withLinkTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withLinkTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withLinkTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withLinkTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withLinkTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withLinkTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withLinkTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withLinkTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withLinkTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withLinkTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withLinkTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withLinkTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_HEADER_SLIDER_BLOCK_SLIDE_QUERY = "query Query($id: ID!, $withImage: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n  headerSliderBlockSlide: cmsHeaderSliderBlockSlide(id: $id) {\n    id\n    image @include(if: $withImage) {\n      id\n      assetId\n      publicId\n      url\n      resourceType\n      format\n      width\n      height\n      caption\n      title\n      description\n    }\n    title\n    text\n    link @include(if: $withLink) {\n      id\n      label\n      targetBlank\n      type\n      url\n      page @include(if: $withLinkPage) {\n        id\n        name\n        onlineStatus\n        seoSettings @include(if: $withLinkPageSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n          id\n          type\n        }\n      }\n      travel @include(if: $withLinkTravel) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n        }\n        executionStatus\n        travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          phone\n        }\n        label @include(if: $withLinkTravelLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withLinkTravelSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n        }\n        tenantSettings @include(if: $withLinkTravelTenantSettings) {\n          id\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n        }\n        highlights @include(if: $withLinkTravelHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withLinkTravelPartners) {\n          id\n          name\n          url\n          logoWidth\n        }\n        travelGuides @include(if: $withLinkTravelTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n        }\n        teams @include(if: $withLinkTravelTeams) {\n          id\n          name\n        }\n        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n          id\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withLinkTravelAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        destinations @include(if: $withLinkTravelDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withLinkTravelTestimonials) {\n          id\n        }\n        mainImage @include(if: $withLinkTravelMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withLinkTravelMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withLinkTravelGallery) {\n          id\n        }\n        travelPdf @include(if: $withLinkTravelTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n          id\n          duration\n          name\n          description\n        }\n        programType\n        itinerary @include(if: $withLinkTravelItinerary) {\n          id\n        }\n        programText\n        pricing @include(if: $withLinkTravelPricing) {\n          id\n          isTravelDocumentationAvailable\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION = "\n  mutation Mutation($input: CreateCmsHeaderSliderBlockSlideInput, $withImage: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n    headerSliderBlockSlide: createCmsHeaderSliderBlockSlide(input: $input) {\n      id\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      title\n      text\n      link @include(if: $withLink) {\n        id\n        label\n        targetBlank\n        type\n        url\n        page @include(if: $withLinkPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withLinkPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        travel @include(if: $withLinkTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withLinkTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withLinkTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withLinkTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withLinkTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withLinkTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withLinkTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withLinkTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withLinkTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withLinkTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withLinkTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withLinkTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withLinkTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withLinkTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withLinkTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withLinkTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withLinkTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION = "\n  mutation Mutation($input: UpdateCmsHeaderSliderBlockSlideInput, $withImage: Boolean = false, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false) {\n    headerSliderBlockSlide: updateCmsHeaderSliderBlockSlide(input: $input) {\n      id\n      image @include(if: $withImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      title\n      text\n      link @include(if: $withLink) {\n        id\n        label\n        targetBlank\n        type\n        url\n        page @include(if: $withLinkPage) {\n          id\n          name\n          onlineStatus\n          seoSettings @include(if: $withLinkPageSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {\n            id\n            type\n          }\n        }\n        travel @include(if: $withLinkTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {\n            id\n            label\n            status\n            isDefaultStatus\n            isDefaultWaitlistFallback\n          }\n          executionStatus\n          travelConsultant @include(if: $withLinkTravelTravelConsultant) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          label @include(if: $withLinkTravelLabel) {\n            id\n            label\n          }\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          seoSettings @include(if: $withLinkTravelSeoSettings) {\n            id\n            urlSlug\n            metaTitle\n            metaDescription\n            ogTitle\n            ogDescription\n          }\n          tenantSettings @include(if: $withLinkTravelTenantSettings) {\n            id\n            onlineStatus\n            redirectToBooking\n            useTiming\n            startDate\n            endDate\n          }\n          highlights @include(if: $withLinkTravelHighlights) {\n            id\n            text\n          }\n          partners @include(if: $withLinkTravelPartners) {\n            id\n            name\n            url\n            logoWidth\n          }\n          travelGuides @include(if: $withLinkTravelTravelGuides) {\n            id\n            firstName\n            lastName\n            description\n          }\n          teams @include(if: $withLinkTravelTeams) {\n            id\n            name\n          }\n          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {\n            id\n            useCustomRoomTypeSelection\n          }\n          accommodations @include(if: $withLinkTravelAccommodations) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          destinations @include(if: $withLinkTravelDestinations) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          testimonials @include(if: $withLinkTravelTestimonials) {\n            id\n          }\n          mainImage @include(if: $withLinkTravelMainImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          mainVideo @include(if: $withLinkTravelMainVideo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          gallery @include(if: $withLinkTravelGallery) {\n            id\n          }\n          travelPdf @include(if: $withLinkTravelTravelPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          travelExtensions @include(if: $withLinkTravelTravelExtensions) {\n            id\n            duration\n            name\n            description\n          }\n          programType\n          itinerary @include(if: $withLinkTravelItinerary) {\n            id\n          }\n          programText\n          pricing @include(if: $withLinkTravelPricing) {\n            id\n            isTravelDocumentationAvailable\n          }\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION = "\n  mutation Mutation($input: DeleteCmsHeaderSliderBlockSlideInput) {\n    deleteCmsHeaderSliderBlockSlide(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION = "\n  mutation Mutation($input: DeleteCmsHeaderSliderBlockSlideInput) {\n    forceDeleteCmsHeaderSliderBlockSlide(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var HEADER_SLIDER_BLOCK_SLIDES_DEPENDENTS_QUERY = "query Query($id: ID!, $withCmsHeaderSliderBlocks: Boolean = false) {\n  groupedDependents: cmsHeaderSliderBlockSlideDependents(id: $id) {\n    cmsHeaderSliderBlocks @include(if: $withCmsHeaderSliderBlocks) {\n      id\n    }\n  }\n}";

// EXTERNAL MODULE: ./src/entities/link/entity.ts + 3 modules
var link_entity = __webpack_require__(90576);
;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlockSlide/model.ts



var cmsHeaderSliderBlockSlideModel = {
    name: "headerSliderBlockSlide",
    namePlural: "headerSliderBlockSlides",
    uniqueName: "cmsHeaderSliderBlockSlide",
    uniqueNamePlural: "cmsHeaderSliderBlockSlides",
    path: "cms/blocks/header_slider_block_slide",
    baseUrl: "/cms/blocks/header_slider_block_slides",
    translationPrefix: "entities:cmsHeaderSliderBlockSlide.",
    getDisplayName: function(values) {
        return values.title && values.title.length > 0 ? values.title : "Slide";
    },
    gql: {
        getAll: ALL_HEADER_SLIDER_BLOCK_SLIDES_QUERY,
        getSingle: SINGLE_HEADER_SLIDER_BLOCK_SLIDE_QUERY,
        create: CREATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
        update: UPDATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
        delete: DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION,
        forceDelete: FORCE_DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION
    },
    attributes: {
        image: {
            name: "image",
            label: "entities:cmsHeaderSliderBlockSlide.attributes.image.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return mediaFile_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        title: {
            name: "title",
            label: "entities:cmsHeaderSliderBlockSlide.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        text: {
            name: "text",
            label: "entities:cmsHeaderSliderBlockSlide.attributes.text.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        link: {
            name: "link",
            label: "entities:cmsHeaderSliderBlockSlide.attributes.link.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return link_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsHeaderSliderBlockSlide_model = (cmsHeaderSliderBlockSlideModel);

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlockSlide/repository.ts










var cmsHeaderSliderBlockSlide_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsHeaderSliderBlockSlide_model, object);
    });
};
var cmsHeaderSliderBlockSlide_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsHeaderSliderBlockSlide_model, object);
};
var cmsHeaderSliderBlockSlideRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_HEADER_SLIDER_BLOCK_SLIDE_QUERY, variables).then(function(data) {
                        return cmsHeaderSliderBlockSlide_repository_hydrateObject(data.headerSliderBlockSlide);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_HEADER_SLIDER_BLOCK_SLIDES_QUERY, includes).then(function(data) {
                    return cmsHeaderSliderBlockSlide_repository_hydrateObjects(data.headerSliderBlockSlides);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_HEADER_SLIDER_BLOCK_SLIDE_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsHeaderSliderBlockSlide_repository_hydrateObject(data.headerSliderBlockSlide),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_HEADER_SLIDER_BLOCK_SLIDES_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsHeaderSliderBlockSlide_repository_hydrateObjects(data.headerSliderBlockSlides),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(HEADER_SLIDER_BLOCK_SLIDES_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            HEADER_SLIDER_BLOCK_SLIDES_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION, variables).then(function(data) {
                        return cmsHeaderSliderBlockSlide_repository_hydrateObject(data.headerSliderBlockSlide);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION, variables).then(function(data) {
                        return cmsHeaderSliderBlockSlide_repository_hydrateObject(data.headerSliderBlockSlide);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION, variables).then(function(data) {
                        return data.deleteCmsHeaderSliderBlockSlide;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_HEADER_SLIDER_BLOCK_SLIDE_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsHeaderSliderBlockSlide;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsHeaderSliderBlockSlide_repository = (cmsHeaderSliderBlockSlideRepository);

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlockSlide/entity.ts


var cmsHeaderSliderBlockSlideEntity = {
    model: cmsHeaderSliderBlockSlide_model,
    repository: cmsHeaderSliderBlockSlide_repository
};
/* harmony default export */ var cmsHeaderSliderBlockSlide_entity = (cmsHeaderSliderBlockSlideEntity);

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlock/model.ts



var cmsHeaderSliderBlockModel = {
    name: "headerSliderBlock",
    namePlural: "headerSliderBlocks",
    uniqueName: "cmsHeaderSliderBlock",
    uniqueNamePlural: "cmsHeaderSliderBlocks",
    path: "cms/blocks/header_slider_block",
    baseUrl: "/cms/blocks/header_slider_blocks",
    translationPrefix: "entities:cmsHeaderSliderBlock.",
    getDisplayName: function(values) {
        return "Header Slider Block";
    },
    gql: {
        getAll: ALL_HEADER_SLIDER_BLOCKS_QUERY,
        getSingle: SINGLE_HEADER_SLIDER_BLOCK_QUERY,
        create: CREATE_HEADER_SLIDER_BLOCK_MUTATION,
        update: UPDATE_HEADER_SLIDER_BLOCK_MUTATION,
        delete: DELETE_HEADER_SLIDER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_HEADER_SLIDER_BLOCK_MUTATION
    },
    attributes: {
        travels: {
            name: "travels",
            label: "entities:cmsHeaderSliderBlock.attributes.travels.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        slides: {
            name: "slides",
            label: "entities:cmsHeaderSliderBlock.attributes.slides.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsHeaderSliderBlockSlide_entity;
            },
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsHeaderSliderBlock_model = (cmsHeaderSliderBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlock/repository.ts









var cmsHeaderSliderBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsHeaderSliderBlock_model, object);
    });
};
var cmsHeaderSliderBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsHeaderSliderBlock_model, object);
};
var cmsHeaderSliderBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_HEADER_SLIDER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsHeaderSliderBlock_repository_hydrateObject(data.headerSliderBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_HEADER_SLIDER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsHeaderSliderBlock_repository_hydrateObjects(data.headerSliderBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_HEADER_SLIDER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsHeaderSliderBlock_repository_hydrateObject(data.headerSliderBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_HEADER_SLIDER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsHeaderSliderBlock_repository_hydrateObjects(data.headerSliderBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_HEADER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsHeaderSliderBlock_repository_hydrateObject(data.headerSliderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_HEADER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsHeaderSliderBlock_repository_hydrateObject(data.headerSliderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_HEADER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsHeaderSliderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_HEADER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsHeaderSliderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travels: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_HEADER_SLIDER_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_HEADER_SLIDER_BLOCK_TRAVELS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignSlides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        slideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_HEADER_SLIDER_BLOCK_SLIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignSlides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        slideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_HEADER_SLIDER_BLOCK_SLIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createSlides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        slides: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_HEADER_SLIDER_BLOCK_SLIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteSlides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        slideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_HEADER_SLIDER_BLOCK_SLIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateSlidesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        slideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_HEADER_SLIDER_BLOCK_SLIDES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsHeaderSliderBlock_repository = (cmsHeaderSliderBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsHeaderSliderBlock/entity.ts


var cmsHeaderSliderBlockEntity = {
    model: cmsHeaderSliderBlock_model,
    repository: cmsHeaderSliderBlock_repository
};
/* harmony default export */ var cmsHeaderSliderBlock_entity = ((/* unused pure expression or super */ null && (cmsHeaderSliderBlockEntity)));

// EXTERNAL MODULE: ./src/entities/travelType/entity.ts + 3 modules
var travelType_entity = __webpack_require__(31250);
;// CONCATENATED MODULE: ./src/entities/cmsTravelTypesBlock/graphql.ts
// language=GraphQL
var ALL_TRAVEL_TYPES_BLOCKS_QUERY = "query Query {\n  travelTypesBlocks: cmsTravelTypesBlocks {\n    id\n    layout\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_TYPES_BLOCK_QUERY = "query Query($id: ID!) {\n  travelTypesBlock: cmsTravelTypesBlock(id: $id) {\n    id\n    layout\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_TYPES_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsTravelTypesBlockInput) {\n    travelTypesBlock: createCmsTravelTypesBlock(input: $input) {\n      id\n      layout\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_TYPES_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsTravelTypesBlockInput) {\n    travelTypesBlock: updateCmsTravelTypesBlock(input: $input) {\n      id\n      layout\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_TYPES_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTravelTypesBlockInput) {\n    deleteCmsTravelTypesBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_TYPES_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTravelTypesBlockInput) {\n    forceDeleteCmsTravelTypesBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsTravelTypesBlock/model.ts

var cmsTravelTypesBlockModel = {
    name: "travelTypesBlock",
    namePlural: "travelTypesBlocks",
    uniqueName: "cmsTravelTypesBlock",
    uniqueNamePlural: "cmsTravelTypesBlocks",
    path: "cms/blocks/travel_types_block",
    baseUrl: "/cms/blocks/travel_types_blocks",
    translationPrefix: "entities:cmsTravelTypesBlock.",
    getDisplayName: function(values) {
        return "Travel Types Block";
    },
    gql: {
        getAll: ALL_TRAVEL_TYPES_BLOCKS_QUERY,
        getSingle: SINGLE_TRAVEL_TYPES_BLOCK_QUERY,
        create: CREATE_TRAVEL_TYPES_BLOCK_MUTATION,
        update: UPDATE_TRAVEL_TYPES_BLOCK_MUTATION,
        delete: DELETE_TRAVEL_TYPES_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_TYPES_BLOCK_MUTATION
    },
    attributes: {
        layout: {
            name: "layout",
            label: "entities:cmsTravelTypesBlock.attributes.layout.label",
            type: "value",
            dataType: "string",
            defaultValue: "default",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsTravelTypesBlock_model = (cmsTravelTypesBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsTravelTypesBlock/repository.ts









var cmsTravelTypesBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsTravelTypesBlock_model, object);
    });
};
var cmsTravelTypesBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsTravelTypesBlock_model, object);
};
var cmsTravelTypesBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_TYPES_BLOCK_QUERY, variables).then(function(data) {
                        return cmsTravelTypesBlock_repository_hydrateObject(data.travelTypesBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_TYPES_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsTravelTypesBlock_repository_hydrateObjects(data.travelTypesBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_TYPES_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsTravelTypesBlock_repository_hydrateObject(data.travelTypesBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_TYPES_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsTravelTypesBlock_repository_hydrateObjects(data.travelTypesBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_TYPES_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTravelTypesBlock_repository_hydrateObject(data.travelTypesBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_TYPES_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTravelTypesBlock_repository_hydrateObject(data.travelTypesBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_TYPES_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsTravelTypesBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_TYPES_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsTravelTypesBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsTravelTypesBlock_repository = (cmsTravelTypesBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsTravelTypesBlock/entity.ts


var cmsTravelTypesBlockEntity = {
    model: cmsTravelTypesBlock_model,
    repository: cmsTravelTypesBlock_repository
};
/* harmony default export */ var cmsTravelTypesBlock_entity = ((/* unused pure expression or super */ null && (cmsTravelTypesBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsFilterLeadBlock/graphql.ts
// language=GraphQL
var ALL_FILTER_LEAD_BLOCKS_QUERY = "query Query {\n  filterLeadBlocks: cmsFilterLeadBlocks {\n    id\n    layout\n  }\n}";
// language=GraphQL
var SINGLE_FILTER_LEAD_BLOCK_QUERY = "query Query($id: ID!) {\n  filterLeadBlock: cmsFilterLeadBlock(id: $id) {\n    id\n    layout\n  }\n}";
// language=GraphQL
var CREATE_FILTER_LEAD_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsFilterLeadBlockInput) {\n    filterLeadBlock: createCmsFilterLeadBlock(input: $input) {\n      id\n      layout\n    }\n  }";
// language=GraphQL
var UPDATE_FILTER_LEAD_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsFilterLeadBlockInput) {\n    filterLeadBlock: updateCmsFilterLeadBlock(input: $input) {\n      id\n      layout\n    }\n  }";
// language=GraphQL
var DELETE_FILTER_LEAD_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsFilterLeadBlockInput) {\n    deleteCmsFilterLeadBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_FILTER_LEAD_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsFilterLeadBlockInput) {\n    forceDeleteCmsFilterLeadBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsFilterLeadBlock/model.ts

var cmsFilterLeadBlockModel = {
    name: "filterLeadBlock",
    namePlural: "filterLeadBlocks",
    uniqueName: "cmsFilterLeadBlock",
    uniqueNamePlural: "cmsFilterLeadBlocks",
    path: "cms/blocks/filter_lead_block",
    baseUrl: "/cms/blocks/filter_lead_blocks",
    translationPrefix: "entities:cmsFilterLeadBlock.",
    getDisplayName: function(values) {
        return "Filter Lead Block";
    },
    gql: {
        getAll: ALL_FILTER_LEAD_BLOCKS_QUERY,
        getSingle: SINGLE_FILTER_LEAD_BLOCK_QUERY,
        create: CREATE_FILTER_LEAD_BLOCK_MUTATION,
        update: UPDATE_FILTER_LEAD_BLOCK_MUTATION,
        delete: DELETE_FILTER_LEAD_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_FILTER_LEAD_BLOCK_MUTATION
    },
    attributes: {
        layout: {
            name: "layout",
            label: "entities:cmsFilterLeadBlock.attributes.layout.label",
            type: "value",
            dataType: "string",
            defaultValue: "default",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsFilterLeadBlock_model = (cmsFilterLeadBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsFilterLeadBlock/repository.ts









var cmsFilterLeadBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsFilterLeadBlock_model, object);
    });
};
var cmsFilterLeadBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsFilterLeadBlock_model, object);
};
var cmsFilterLeadBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_FILTER_LEAD_BLOCK_QUERY, variables).then(function(data) {
                        return cmsFilterLeadBlock_repository_hydrateObject(data.filterLeadBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_FILTER_LEAD_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsFilterLeadBlock_repository_hydrateObjects(data.filterLeadBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_FILTER_LEAD_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsFilterLeadBlock_repository_hydrateObject(data.filterLeadBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_FILTER_LEAD_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsFilterLeadBlock_repository_hydrateObjects(data.filterLeadBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_FILTER_LEAD_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsFilterLeadBlock_repository_hydrateObject(data.filterLeadBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_FILTER_LEAD_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsFilterLeadBlock_repository_hydrateObject(data.filterLeadBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_FILTER_LEAD_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsFilterLeadBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_FILTER_LEAD_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsFilterLeadBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsFilterLeadBlock_repository = (cmsFilterLeadBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsFilterLeadBlock/entity.ts


var cmsFilterLeadBlockEntity = {
    model: cmsFilterLeadBlock_model,
    repository: cmsFilterLeadBlock_repository
};
/* harmony default export */ var cmsFilterLeadBlock_entity = ((/* unused pure expression or super */ null && (cmsFilterLeadBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsBestsellerSliderBlock/graphql.ts
// language=GraphQL
var ALL_BESTSELLER_SLIDER_BLOCKS_QUERY = "query Query {\n  bestsellerSliderBlocks: cmsBestsellerSliderBlocks {\n    id\n    fluid\n  }\n}";
// language=GraphQL
var SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY = "query Query($id: ID!) {\n  bestsellerSliderBlock: cmsBestsellerSliderBlock(id: $id) {\n    id\n    fluid\n  }\n}";
// language=GraphQL
var CREATE_BESTSELLER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsBestsellerSliderBlockInput) {\n    bestsellerSliderBlock: createCmsBestsellerSliderBlock(input: $input) {\n      id\n      fluid\n    }\n  }";
// language=GraphQL
var UPDATE_BESTSELLER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsBestsellerSliderBlockInput) {\n    bestsellerSliderBlock: updateCmsBestsellerSliderBlock(input: $input) {\n      id\n      fluid\n    }\n  }";
// language=GraphQL
var DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsBestsellerSliderBlockInput) {\n    deleteCmsBestsellerSliderBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsBestsellerSliderBlockInput) {\n    forceDeleteCmsBestsellerSliderBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsBestsellerSliderBlock/model.ts

var cmsBestsellerSliderBlockModel = {
    name: "bestsellerSliderBlock",
    namePlural: "bestsellerSliderBlocks",
    uniqueName: "cmsBestsellerSliderBlock",
    uniqueNamePlural: "cmsBestsellerSliderBlocks",
    path: "cms/blocks/bestseller_slider_block",
    baseUrl: "/cms/blocks/bestseller_slider_blocks",
    translationPrefix: "entities:cmsBestsellerSliderBlock.",
    getDisplayName: function(values) {
        return "Bestseller Slider Block";
    },
    gql: {
        getAll: ALL_BESTSELLER_SLIDER_BLOCKS_QUERY,
        getSingle: SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY,
        create: CREATE_BESTSELLER_SLIDER_BLOCK_MUTATION,
        update: UPDATE_BESTSELLER_SLIDER_BLOCK_MUTATION,
        delete: DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION
    },
    attributes: {
        fluid: {
            name: "fluid",
            label: "entities:cmsBestsellerSliderBlock.attributes.fluid.label",
            type: "value",
            dataType: "boolean",
            defaultInput: false,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsBestsellerSliderBlock_model = (cmsBestsellerSliderBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsBestsellerSliderBlock/repository.ts









var cmsBestsellerSliderBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsBestsellerSliderBlock_model, object);
    });
};
var cmsBestsellerSliderBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsBestsellerSliderBlock_model, object);
};
var cmsBestsellerSliderBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsBestsellerSliderBlock_repository_hydrateObject(data.bestsellerSliderBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BESTSELLER_SLIDER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsBestsellerSliderBlock_repository_hydrateObjects(data.bestsellerSliderBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BESTSELLER_SLIDER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsBestsellerSliderBlock_repository_hydrateObject(data.bestsellerSliderBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BESTSELLER_SLIDER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsBestsellerSliderBlock_repository_hydrateObjects(data.bestsellerSliderBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BESTSELLER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsBestsellerSliderBlock_repository_hydrateObject(data.bestsellerSliderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BESTSELLER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsBestsellerSliderBlock_repository_hydrateObject(data.bestsellerSliderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsBestsellerSliderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BESTSELLER_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsBestsellerSliderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsBestsellerSliderBlock_repository = (cmsBestsellerSliderBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsBestsellerSliderBlock/entity.ts


var cmsBestsellerSliderBlockEntity = {
    model: cmsBestsellerSliderBlock_model,
    repository: cmsBestsellerSliderBlock_repository
};
/* harmony default export */ var cmsBestsellerSliderBlock_entity = ((/* unused pure expression or super */ null && (cmsBestsellerSliderBlockEntity)));

// EXTERNAL MODULE: ./src/entities/travelObjectTenantSettings/entity.ts + 3 modules
var travelObjectTenantSettings_entity = __webpack_require__(91687);
;// CONCATENATED MODULE: ./src/entities/cmsPrefilteredTravelsBlock/graphql.ts
// language=GraphQL
var ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY = "query Query($withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n  prefilteredTravelsBlocks: cmsPrefilteredTravelsBlocks {\n    id\n    destinations @include(if: $withDestinations) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n      image @include(if: $withTravelTypesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    maxResults\n  }\n}";
// language=GraphQL
var SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY = "query Query($id: ID!, $withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n  prefilteredTravelsBlock: cmsPrefilteredTravelsBlock(id: $id) {\n    id\n    destinations @include(if: $withDestinations) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n    travelTypes @include(if: $withTravelTypes) {\n      id\n      name\n      description\n      image @include(if: $withTravelTypesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    maxResults\n  }\n}";
// language=GraphQL
var CREATE_PREFILTERED_TRAVELS_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsPrefilteredTravelsBlockInput, $withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n    prefilteredTravelsBlock: createCmsPrefilteredTravelsBlock(input: $input) {\n      id\n      destinations @include(if: $withDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      travelTypes @include(if: $withTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      maxResults\n    }\n  }";
// language=GraphQL
var UPDATE_PREFILTERED_TRAVELS_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsPrefilteredTravelsBlockInput, $withDestinations: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {\n    prefilteredTravelsBlock: updateCmsPrefilteredTravelsBlock(input: $input) {\n      id\n      destinations @include(if: $withDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      travelTypes @include(if: $withTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      maxResults\n    }\n  }";
// language=GraphQL
var DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsPrefilteredTravelsBlockInput) {\n    deleteCmsPrefilteredTravelsBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsPrefilteredTravelsBlockInput) {\n    forceDeleteCmsPrefilteredTravelsBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: addCmsPrefilteredTravelsBlockDestinationsInput) {\n    addCmsPrefilteredTravelsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var REMOVE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: removeCmsPrefilteredTravelsBlockDestinationsInput) {\n    removeCmsPrefilteredTravelsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var CREATE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: createCmsPrefilteredTravelsBlockDestinationsInput) {\n    createCmsPrefilteredTravelsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var DELETE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: deleteCmsPrefilteredTravelsBlockDestinationsInput) {\n    deleteCmsPrefilteredTravelsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var UPDATE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsPrefilteredTravelsBlockDestinationsOrderInput) {\n    updateCmsPrefilteredTravelsBlockDestinationsOrder(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var ADD_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: addCmsPrefilteredTravelsBlockTravelTypesInput) {\n    addCmsPrefilteredTravelsBlockTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var REMOVE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: removeCmsPrefilteredTravelsBlockTravelTypesInput) {\n    removeCmsPrefilteredTravelsBlockTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var CREATE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: createCmsPrefilteredTravelsBlockTravelTypesInput) {\n    createCmsPrefilteredTravelsBlockTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var DELETE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION = "\n  mutation Mutation($input: deleteCmsPrefilteredTravelsBlockTravelTypesInput) {\n    deleteCmsPrefilteredTravelsBlockTravelTypes(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";
// language=GraphQL
var UPDATE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsPrefilteredTravelsBlockTravelTypesOrderInput) {\n    updateCmsPrefilteredTravelsBlockTravelTypesOrder(input: $input) {\n      id\n      travelTypeIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsPrefilteredTravelsBlock/model.ts



var cmsPrefilteredTravelsBlockModel = {
    name: "prefilteredTravelsBlock",
    namePlural: "prefilteredTravelsBlocks",
    uniqueName: "cmsPrefilteredTravelsBlock",
    uniqueNamePlural: "cmsPrefilteredTravelsBlocks",
    path: "cms/blocks/prefiltered_travels_block",
    baseUrl: "/cms/blocks/prefiltered_travels_blocks",
    translationPrefix: "entities:cmsPrefilteredTravelsBlock.",
    getDisplayName: function(values) {
        return "Prefiltered Travels Block";
    },
    gql: {
        getAll: ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY,
        getSingle: SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY,
        create: CREATE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
        update: UPDATE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
        delete: DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION
    },
    attributes: {
        destinations: {
            name: "destinations",
            label: "entities:cmsPrefilteredTravelsBlock.attributes.destinations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelDestination_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        travelTypes: {
            name: "travelTypes",
            label: "entities:cmsPrefilteredTravelsBlock.attributes.travelTypes.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelType_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        maxResults: {
            name: "maxResults",
            label: "entities:cmsPrefilteredTravelsBlock.attributes.maxResults.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.0.label",
                    value: "0"
                },
                {
                    label: "entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.4.label",
                    value: "4"
                },
                {
                    label: "entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.8.label",
                    value: "8"
                },
                {
                    label: "entities:cmsPrefilteredTravelsBlock.attributes.maxResults.selectOptions.12.label",
                    value: "12"
                }, 
            ],
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsPrefilteredTravelsBlock_model = (cmsPrefilteredTravelsBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsPrefilteredTravelsBlock/repository.ts









var cmsPrefilteredTravelsBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsPrefilteredTravelsBlock_model, object);
    });
};
var cmsPrefilteredTravelsBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsPrefilteredTravelsBlock_model, object);
};
var cmsPrefilteredTravelsBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY, variables).then(function(data) {
                        return cmsPrefilteredTravelsBlock_repository_hydrateObject(data.prefilteredTravelsBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsPrefilteredTravelsBlock_repository_hydrateObjects(data.prefilteredTravelsBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_PREFILTERED_TRAVELS_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsPrefilteredTravelsBlock_repository_hydrateObject(data.prefilteredTravelsBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_PREFILTERED_TRAVELS_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsPrefilteredTravelsBlock_repository_hydrateObjects(data.prefilteredTravelsBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PREFILTERED_TRAVELS_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsPrefilteredTravelsBlock_repository_hydrateObject(data.prefilteredTravelsBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PREFILTERED_TRAVELS_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsPrefilteredTravelsBlock_repository_hydrateObject(data.prefilteredTravelsBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsPrefilteredTravelsBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_PREFILTERED_TRAVELS_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsPrefilteredTravelsBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateDestinationsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PREFILTERED_TRAVELS_BLOCK_DESTINATIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypes: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelTypes: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelTypesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelTypeIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_PREFILTERED_TRAVELS_BLOCK_TRAVEL_TYPES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsPrefilteredTravelsBlock_repository = (cmsPrefilteredTravelsBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsPrefilteredTravelsBlock/entity.ts


var cmsPrefilteredTravelsBlockEntity = {
    model: cmsPrefilteredTravelsBlock_model,
    repository: cmsPrefilteredTravelsBlock_repository
};
/* harmony default export */ var cmsPrefilteredTravelsBlock_entity = ((/* unused pure expression or super */ null && (cmsPrefilteredTravelsBlockEntity)));

// EXTERNAL MODULE: ./src/entities/redirect/entity.ts + 3 modules
var redirect_entity = __webpack_require__(79070);
;// CONCATENATED MODULE: ./src/entities/cmsTravelSelectionBlock/graphql.ts
// language=GraphQL
var ALL_TRAVEL_SELECTION_BLOCKS_QUERY = "query Query($withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false) {\n  travelSelectionBlocks: cmsTravelSelectionBlocks {\n    id\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelsTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelsTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelsLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelsSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelsTenantSettings) {\n        id\n        tenant @include(if: $withTravelsTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelsHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelsPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelsPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelsTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelsTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelsTeams) {\n        id\n        name\n        members @include(if: $withTravelsTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelsAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelsAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelsDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelsTestimonials) {\n        id\n        contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelsMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelsMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelsGallery) {\n        id\n        images @include(if: $withTravelsGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelsTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelsTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelsTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelsItinerary) {\n        id\n        items @include(if: $withTravelsItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelsPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelsPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelsPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelsPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelsPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelsPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_SELECTION_BLOCK_QUERY = "query Query($id: ID!, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false) {\n  travelSelectionBlock: cmsTravelSelectionBlock(id: $id) {\n    id\n    travels @include(if: $withTravels) {\n      id\n      name\n      isBestseller\n      startDate\n      endDate\n      availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n        id\n        label\n        status\n        isDefaultStatus\n        isDefaultWaitlistFallback\n        tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n          id\n          label\n          info\n          switchToStatusInfo\n          submitButtonLabel\n        }\n      }\n      executionStatus\n      travelConsultant @include(if: $withTravelsTravelConsultant) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTravelsTravelConsultantImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      label @include(if: $withTravelsLabel) {\n        id\n        label\n      }\n      title\n      description\n      includedServices\n      excludedServices\n      pricingTable\n      priceCalculationInfo\n      seoSettings @include(if: $withTravelsSeoSettings) {\n        id\n        urlSlug\n        metaTitle\n        metaDescription\n        ogTitle\n        ogDescription\n        ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      tenantSettings @include(if: $withTravelsTenantSettings) {\n        id\n        tenant @include(if: $withTravelsTenantSettingsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        onlineStatus\n        redirectToBooking\n        useTiming\n        startDate\n        endDate\n        travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n          id\n          name\n          description\n        }\n      }\n      highlights @include(if: $withTravelsHighlights) {\n        id\n        text\n      }\n      partners @include(if: $withTravelsPartners) {\n        id\n        name\n        url\n        logo @include(if: $withTravelsPartnersLogo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        logoWidth\n        gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelGuides @include(if: $withTravelsTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelsTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      teams @include(if: $withTravelsTeams) {\n        id\n        name\n        members @include(if: $withTravelsTeamsMembers) {\n          id\n          firstName\n          lastName\n          description\n        }\n      }\n      accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n        id\n        accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n          id\n          label\n          name\n          stars\n          description\n        }\n        roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n          id\n          name\n          description\n        }\n        useCustomRoomTypeSelection\n      }\n      accommodations @include(if: $withTravelsAccommodations) {\n        id\n        label\n        name\n        stars\n        description\n        roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n          id\n          name\n          description\n        }\n        availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n          id\n          name\n          description\n        }\n        gallery @include(if: $withTravelsAccommodationsGallery) {\n          id\n        }\n      }\n      destinations @include(if: $withTravelsDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n      testimonials @include(if: $withTravelsTestimonials) {\n        id\n        contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n          id\n          title\n          text\n          imagePosition\n        }\n      }\n      mainImage @include(if: $withTravelsMainImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      mainVideo @include(if: $withTravelsMainVideo) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      gallery @include(if: $withTravelsGallery) {\n        id\n        images @include(if: $withTravelsGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      travelPdf @include(if: $withTravelsTravelPdf) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n      travelExtensions @include(if: $withTravelsTravelExtensions) {\n        id\n        duration\n        name\n        description\n        highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n          id\n          text\n        }\n        image @include(if: $withTravelsTravelExtensionsImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      programType\n      itinerary @include(if: $withTravelsItinerary) {\n        id\n        items @include(if: $withTravelsItineraryItems) {\n          id\n          duration\n          title\n          text\n        }\n      }\n      programText\n      pricing @include(if: $withTravelsPricing) {\n        id\n        ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n          id\n          freeUntilAge\n        }\n        isTravelDocumentationAvailable\n        customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n          id\n          useTravellerForm\n          useBookingForm\n        }\n        travels @include(if: $withTravelsPricingTravels) {\n          id\n          catalogCode\n          travelCode\n          destination\n          name\n          transportType\n          transportTypeLabel\n          importDateTime\n          importStatus\n        }\n        webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n          id\n          enabled\n          url\n        }\n        branding @include(if: $withTravelsPricingBranding) {\n          id\n          logoWidth\n        }\n        bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n          id\n          active\n          untilDaysBeforeStart\n        }\n        esimSettings @include(if: $withTravelsPricingEsimSettings) {\n          id\n          enabled\n        }\n        passportConfig @include(if: $withTravelsPricingPassportConfig) {\n          id\n          passportOnly\n        }\n        tourOperator @include(if: $withTravelsPricingTourOperator) {\n          id\n          name\n          url\n          logoWidth\n        }\n      }\n      minPrice\n      minPriceManualOverride\n      currency\n    }\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_SELECTION_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsTravelSelectionBlockInput, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false) {\n    travelSelectionBlock: createCmsTravelSelectionBlock(input: $input) {\n      id\n      travels @include(if: $withTravels) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelsTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelsTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelsLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelsSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelsTenantSettings) {\n          id\n          tenant @include(if: $withTravelsTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelsHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelsPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelsPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelsTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelsTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelsTeams) {\n          id\n          name\n          members @include(if: $withTravelsTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelsAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelsAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelsDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelsTestimonials) {\n          id\n          contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelsMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelsMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelsGallery) {\n          id\n          images @include(if: $withTravelsGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelsTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelsTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelsTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelsItinerary) {\n          id\n          items @include(if: $withTravelsItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelsPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelsPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelsPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelsPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelsPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelsPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_SELECTION_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsTravelSelectionBlockInput, $withTravels: Boolean = false, $withTravelsAvailabilityStatus: Boolean = false, $withTravelsAvailabilityStatusTenantSettings: Boolean = false, $withTravelsTravelConsultant: Boolean = false, $withTravelsTravelConsultantImage: Boolean = false, $withTravelsLabel: Boolean = false, $withTravelsSeoSettings: Boolean = false, $withTravelsSeoSettingsOgImage: Boolean = false, $withTravelsTenantSettings: Boolean = false, $withTravelsTenantSettingsTenant: Boolean = false, $withTravelsTenantSettingsTravelTypes: Boolean = false, $withTravelsHighlights: Boolean = false, $withTravelsPartners: Boolean = false, $withTravelsPartnersLogo: Boolean = false, $withTravelsPartnersGtcPdf: Boolean = false, $withTravelsTravelGuides: Boolean = false, $withTravelsTravelGuidesImage: Boolean = false, $withTravelsTeams: Boolean = false, $withTravelsTeamsMembers: Boolean = false, $withTravelsAccommodationAssignments: Boolean = false, $withTravelsAccommodationAssignmentsAccommodation: Boolean = false, $withTravelsAccommodationAssignmentsRoomTypes: Boolean = false, $withTravelsAccommodations: Boolean = false, $withTravelsAccommodationsRoomTypes: Boolean = false, $withTravelsAccommodationsAvailableAddons: Boolean = false, $withTravelsAccommodationsGallery: Boolean = false, $withTravelsDestinations: Boolean = false, $withTravelsTestimonials: Boolean = false, $withTravelsTestimonialsContentBlock: Boolean = false, $withTravelsMainImage: Boolean = false, $withTravelsMainVideo: Boolean = false, $withTravelsGallery: Boolean = false, $withTravelsGalleryImages: Boolean = false, $withTravelsTravelPdf: Boolean = false, $withTravelsTravelExtensions: Boolean = false, $withTravelsTravelExtensionsHighlights: Boolean = false, $withTravelsTravelExtensionsImage: Boolean = false, $withTravelsItinerary: Boolean = false, $withTravelsItineraryItems: Boolean = false, $withTravelsPricing: Boolean = false, $withTravelsPricingAgeGroupSettings: Boolean = false, $withTravelsPricingCustomDataConfig: Boolean = false, $withTravelsPricingTravels: Boolean = false, $withTravelsPricingWebhookConfig: Boolean = false, $withTravelsPricingBranding: Boolean = false, $withTravelsPricingBargainSettings: Boolean = false, $withTravelsPricingEsimSettings: Boolean = false, $withTravelsPricingPassportConfig: Boolean = false, $withTravelsPricingTourOperator: Boolean = false) {\n    travelSelectionBlock: updateCmsTravelSelectionBlock(input: $input) {\n      id\n      travels @include(if: $withTravels) {\n        id\n        name\n        isBestseller\n        startDate\n        endDate\n        availabilityStatus @include(if: $withTravelsAvailabilityStatus) {\n          id\n          label\n          status\n          isDefaultStatus\n          isDefaultWaitlistFallback\n          tenantSettings @include(if: $withTravelsAvailabilityStatusTenantSettings) {\n            id\n            label\n            info\n            switchToStatusInfo\n            submitButtonLabel\n          }\n        }\n        executionStatus\n        travelConsultant @include(if: $withTravelsTravelConsultant) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTravelsTravelConsultantImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        label @include(if: $withTravelsLabel) {\n          id\n          label\n        }\n        title\n        description\n        includedServices\n        excludedServices\n        pricingTable\n        priceCalculationInfo\n        seoSettings @include(if: $withTravelsSeoSettings) {\n          id\n          urlSlug\n          metaTitle\n          metaDescription\n          ogTitle\n          ogDescription\n          ogImage @include(if: $withTravelsSeoSettingsOgImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        tenantSettings @include(if: $withTravelsTenantSettings) {\n          id\n          tenant @include(if: $withTravelsTenantSettingsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          onlineStatus\n          redirectToBooking\n          useTiming\n          startDate\n          endDate\n          travelTypes @include(if: $withTravelsTenantSettingsTravelTypes) {\n            id\n            name\n            description\n          }\n        }\n        highlights @include(if: $withTravelsHighlights) {\n          id\n          text\n        }\n        partners @include(if: $withTravelsPartners) {\n          id\n          name\n          url\n          logo @include(if: $withTravelsPartnersLogo) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          logoWidth\n          gtcPdf @include(if: $withTravelsPartnersGtcPdf) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelGuides @include(if: $withTravelsTravelGuides) {\n          id\n          firstName\n          lastName\n          description\n          image @include(if: $withTravelsTravelGuidesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        teams @include(if: $withTravelsTeams) {\n          id\n          name\n          members @include(if: $withTravelsTeamsMembers) {\n            id\n            firstName\n            lastName\n            description\n          }\n        }\n        accommodationAssignments @include(if: $withTravelsAccommodationAssignments) {\n          id\n          accommodation @include(if: $withTravelsAccommodationAssignmentsAccommodation) {\n            id\n            label\n            name\n            stars\n            description\n          }\n          roomTypes @include(if: $withTravelsAccommodationAssignmentsRoomTypes) {\n            id\n            name\n            description\n          }\n          useCustomRoomTypeSelection\n        }\n        accommodations @include(if: $withTravelsAccommodations) {\n          id\n          label\n          name\n          stars\n          description\n          roomTypes @include(if: $withTravelsAccommodationsRoomTypes) {\n            id\n            name\n            description\n          }\n          availableAddons @include(if: $withTravelsAccommodationsAvailableAddons) {\n            id\n            name\n            description\n          }\n          gallery @include(if: $withTravelsAccommodationsGallery) {\n            id\n          }\n        }\n        destinations @include(if: $withTravelsDestinations) {\n          id\n          name\n          entryRequirements\n          medicalInformation\n          language\n          timeShift\n          climate\n          currency\n        }\n        testimonials @include(if: $withTravelsTestimonials) {\n          id\n          contentBlock @include(if: $withTravelsTestimonialsContentBlock) {\n            id\n            title\n            text\n            imagePosition\n          }\n        }\n        mainImage @include(if: $withTravelsMainImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        mainVideo @include(if: $withTravelsMainVideo) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        gallery @include(if: $withTravelsGallery) {\n          id\n          images @include(if: $withTravelsGalleryImages) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        travelPdf @include(if: $withTravelsTravelPdf) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        travelExtensions @include(if: $withTravelsTravelExtensions) {\n          id\n          duration\n          name\n          description\n          highlights @include(if: $withTravelsTravelExtensionsHighlights) {\n            id\n            text\n          }\n          image @include(if: $withTravelsTravelExtensionsImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        programType\n        itinerary @include(if: $withTravelsItinerary) {\n          id\n          items @include(if: $withTravelsItineraryItems) {\n            id\n            duration\n            title\n            text\n          }\n        }\n        programText\n        pricing @include(if: $withTravelsPricing) {\n          id\n          ageGroupSettings @include(if: $withTravelsPricingAgeGroupSettings) {\n            id\n            freeUntilAge\n          }\n          isTravelDocumentationAvailable\n          customDataConfig @include(if: $withTravelsPricingCustomDataConfig) {\n            id\n            useTravellerForm\n            useBookingForm\n          }\n          travels @include(if: $withTravelsPricingTravels) {\n            id\n            catalogCode\n            travelCode\n            destination\n            name\n            transportType\n            transportTypeLabel\n            importDateTime\n            importStatus\n          }\n          webhookConfig @include(if: $withTravelsPricingWebhookConfig) {\n            id\n            enabled\n            url\n          }\n          branding @include(if: $withTravelsPricingBranding) {\n            id\n            logoWidth\n          }\n          bargainSettings @include(if: $withTravelsPricingBargainSettings) {\n            id\n            active\n            untilDaysBeforeStart\n          }\n          esimSettings @include(if: $withTravelsPricingEsimSettings) {\n            id\n            enabled\n          }\n          passportConfig @include(if: $withTravelsPricingPassportConfig) {\n            id\n            passportOnly\n          }\n          tourOperator @include(if: $withTravelsPricingTourOperator) {\n            id\n            name\n            url\n            logoWidth\n          }\n        }\n        minPrice\n        minPriceManualOverride\n        currency\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_SELECTION_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTravelSelectionBlockInput) {\n    deleteCmsTravelSelectionBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_SELECTION_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTravelSelectionBlockInput) {\n    forceDeleteCmsTravelSelectionBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: addCmsTravelSelectionBlockTravelsInput) {\n    addCmsTravelSelectionBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: removeCmsTravelSelectionBlockTravelsInput) {\n    removeCmsTravelSelectionBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: createCmsTravelSelectionBlockTravelsInput) {\n    createCmsTravelSelectionBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION = "\n  mutation Mutation($input: deleteCmsTravelSelectionBlockTravelsInput) {\n    deleteCmsTravelSelectionBlockTravels(input: $input) {\n      id\n      travelIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_SELECTION_BLOCK_TRAVELS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsTravelSelectionBlockTravelsOrderInput) {\n    updateCmsTravelSelectionBlockTravelsOrder(input: $input) {\n      id\n      travelIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsTravelSelectionBlock/model.ts


var cmsTravelSelectionBlockModel = {
    name: "travelSelectionBlock",
    namePlural: "travelSelectionBlocks",
    uniqueName: "cmsTravelSelectionBlock",
    uniqueNamePlural: "cmsTravelSelectionBlocks",
    path: "cms/blocks/travel_selection_block",
    baseUrl: "/cms/blocks/travel_selection_blocks",
    translationPrefix: "entities:cmsTravelSelectionBlock.",
    getDisplayName: function(values) {
        return "Travel Selection Block";
    },
    gql: {
        getAll: ALL_TRAVEL_SELECTION_BLOCKS_QUERY,
        getSingle: SINGLE_TRAVEL_SELECTION_BLOCK_QUERY,
        create: CREATE_TRAVEL_SELECTION_BLOCK_MUTATION,
        update: UPDATE_TRAVEL_SELECTION_BLOCK_MUTATION,
        delete: DELETE_TRAVEL_SELECTION_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_SELECTION_BLOCK_MUTATION
    },
    attributes: {
        travels: {
            name: "travels",
            label: "entities:cmsTravelSelectionBlock.attributes.travels.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travel_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsTravelSelectionBlock_model = (cmsTravelSelectionBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsTravelSelectionBlock/repository.ts









var cmsTravelSelectionBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsTravelSelectionBlock_model, object);
    });
};
var cmsTravelSelectionBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsTravelSelectionBlock_model, object);
};
var cmsTravelSelectionBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_SELECTION_BLOCK_QUERY, variables).then(function(data) {
                        return cmsTravelSelectionBlock_repository_hydrateObject(data.travelSelectionBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_SELECTION_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsTravelSelectionBlock_repository_hydrateObjects(data.travelSelectionBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_SELECTION_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsTravelSelectionBlock_repository_hydrateObject(data.travelSelectionBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_SELECTION_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsTravelSelectionBlock_repository_hydrateObjects(data.travelSelectionBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_SELECTION_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTravelSelectionBlock_repository_hydrateObject(data.travelSelectionBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_SELECTION_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTravelSelectionBlock_repository_hydrateObject(data.travelSelectionBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_SELECTION_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsTravelSelectionBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_SELECTION_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsTravelSelectionBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travels: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravels: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_SELECTION_BLOCK_TRAVELS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_SELECTION_BLOCK_TRAVELS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsTravelSelectionBlock_repository = (cmsTravelSelectionBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsTravelSelectionBlock/entity.ts


var cmsTravelSelectionBlockEntity = {
    model: cmsTravelSelectionBlock_model,
    repository: cmsTravelSelectionBlock_repository
};
/* harmony default export */ var cmsTravelSelectionBlock_entity = ((/* unused pure expression or super */ null && (cmsTravelSelectionBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsDividerBlock/graphql.ts
// language=GraphQL
var ALL_DIVIDER_BLOCKS_QUERY = "query Query {\n  dividerBlocks: cmsDividerBlocks {\n    id\n    fluid\n  }\n}";
// language=GraphQL
var SINGLE_DIVIDER_BLOCK_QUERY = "query Query($id: ID!) {\n  dividerBlock: cmsDividerBlock(id: $id) {\n    id\n    fluid\n  }\n}";
// language=GraphQL
var CREATE_DIVIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsDividerBlockInput) {\n    dividerBlock: createCmsDividerBlock(input: $input) {\n      id\n      fluid\n    }\n  }";
// language=GraphQL
var UPDATE_DIVIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsDividerBlockInput) {\n    dividerBlock: updateCmsDividerBlock(input: $input) {\n      id\n      fluid\n    }\n  }";
// language=GraphQL
var DELETE_DIVIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsDividerBlockInput) {\n    deleteCmsDividerBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_DIVIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsDividerBlockInput) {\n    forceDeleteCmsDividerBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsDividerBlock/model.ts

var cmsDividerBlockModel = {
    name: "dividerBlock",
    namePlural: "dividerBlocks",
    uniqueName: "cmsDividerBlock",
    uniqueNamePlural: "cmsDividerBlocks",
    path: "cms/blocks/divider_block",
    baseUrl: "/cms/blocks/divider_blocks",
    translationPrefix: "entities:cmsDividerBlock.",
    getDisplayName: function(values) {
        return "Divider Block";
    },
    gql: {
        getAll: ALL_DIVIDER_BLOCKS_QUERY,
        getSingle: SINGLE_DIVIDER_BLOCK_QUERY,
        create: CREATE_DIVIDER_BLOCK_MUTATION,
        update: UPDATE_DIVIDER_BLOCK_MUTATION,
        delete: DELETE_DIVIDER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_DIVIDER_BLOCK_MUTATION
    },
    attributes: {
        fluid: {
            name: "fluid",
            label: "entities:cmsDividerBlock.attributes.fluid.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsDividerBlock_model = (cmsDividerBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsDividerBlock/repository.ts









var cmsDividerBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsDividerBlock_model, object);
    });
};
var cmsDividerBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsDividerBlock_model, object);
};
var cmsDividerBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_DIVIDER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsDividerBlock_repository_hydrateObject(data.dividerBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_DIVIDER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsDividerBlock_repository_hydrateObjects(data.dividerBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_DIVIDER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsDividerBlock_repository_hydrateObject(data.dividerBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_DIVIDER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsDividerBlock_repository_hydrateObjects(data.dividerBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DIVIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsDividerBlock_repository_hydrateObject(data.dividerBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DIVIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsDividerBlock_repository_hydrateObject(data.dividerBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DIVIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsDividerBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_DIVIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsDividerBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsDividerBlock_repository = (cmsDividerBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsDividerBlock/entity.ts


var cmsDividerBlockEntity = {
    model: cmsDividerBlock_model,
    repository: cmsDividerBlock_repository
};
/* harmony default export */ var cmsDividerBlock_entity = ((/* unused pure expression or super */ null && (cmsDividerBlockEntity)));

// EXTERNAL MODULE: ./src/entities/cmsSocialMediaSettings/entity.ts + 3 modules
var cmsSocialMediaSettings_entity = __webpack_require__(75780);
;// CONCATENATED MODULE: ./src/entities/cmsIframeBlock/graphql.ts
// language=GraphQL
var ALL_IFRAME_BLOCKS_QUERY = "query Query {\n  iframeBlocks: cmsIframeBlocks {\n    id\n    url\n    minHeight\n  }\n}";
// language=GraphQL
var SINGLE_IFRAME_BLOCK_QUERY = "query Query($id: ID!) {\n  iframeBlock: cmsIframeBlock(id: $id) {\n    id\n    url\n    minHeight\n  }\n}";
// language=GraphQL
var CREATE_IFRAME_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsIframeBlockInput) {\n    iframeBlock: createCmsIframeBlock(input: $input) {\n      id\n      url\n      minHeight\n    }\n  }";
// language=GraphQL
var UPDATE_IFRAME_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsIframeBlockInput) {\n    iframeBlock: updateCmsIframeBlock(input: $input) {\n      id\n      url\n      minHeight\n    }\n  }";
// language=GraphQL
var DELETE_IFRAME_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsIframeBlockInput) {\n    deleteCmsIframeBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_IFRAME_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsIframeBlockInput) {\n    forceDeleteCmsIframeBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsIframeBlock/model.ts

var cmsIframeBlockModel = {
    name: "iframeBlock",
    namePlural: "iframeBlocks",
    uniqueName: "cmsIframeBlock",
    uniqueNamePlural: "cmsIframeBlocks",
    path: "cms/blocks/iframe_block",
    baseUrl: "/cms/blocks/iframe_blocks",
    translationPrefix: "entities:cmsIframeBlock.",
    getDisplayName: function(values) {
        return "iFrame Block";
    },
    gql: {
        getAll: ALL_IFRAME_BLOCKS_QUERY,
        getSingle: SINGLE_IFRAME_BLOCK_QUERY,
        create: CREATE_IFRAME_BLOCK_MUTATION,
        update: UPDATE_IFRAME_BLOCK_MUTATION,
        delete: DELETE_IFRAME_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_IFRAME_BLOCK_MUTATION
    },
    attributes: {
        url: {
            name: "url",
            label: "entities:cmsIframeBlock.attributes.url.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                },
                {
                    type: "url"
                }, 
            ]
        },
        minHeight: {
            name: "minHeight",
            label: "entities:cmsIframeBlock.attributes.minHeight.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "number"
                }, 
            ]
        }
    }
};
/* harmony default export */ var cmsIframeBlock_model = (cmsIframeBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsIframeBlock/repository.ts









var cmsIframeBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsIframeBlock_model, object);
    });
};
var cmsIframeBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsIframeBlock_model, object);
};
var cmsIframeBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_IFRAME_BLOCK_QUERY, variables).then(function(data) {
                        return cmsIframeBlock_repository_hydrateObject(data.iframeBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_IFRAME_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsIframeBlock_repository_hydrateObjects(data.iframeBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_IFRAME_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsIframeBlock_repository_hydrateObject(data.iframeBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_IFRAME_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsIframeBlock_repository_hydrateObjects(data.iframeBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_IFRAME_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsIframeBlock_repository_hydrateObject(data.iframeBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_IFRAME_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsIframeBlock_repository_hydrateObject(data.iframeBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_IFRAME_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsIframeBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_IFRAME_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsIframeBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsIframeBlock_repository = (cmsIframeBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsIframeBlock/entity.ts


var cmsIframeBlockEntity = {
    model: cmsIframeBlock_model,
    repository: cmsIframeBlock_repository
};
/* harmony default export */ var cmsIframeBlock_entity = ((/* unused pure expression or super */ null && (cmsIframeBlockEntity)));

// EXTERNAL MODULE: ./src/entities/availabilityStatusTenantSettings/entity.ts + 3 modules
var availabilityStatusTenantSettings_entity = __webpack_require__(18334);
// EXTERNAL MODULE: ./src/entities/passportData/entity.ts + 3 modules
var passportData_entity = __webpack_require__(41953);
// EXTERNAL MODULE: ./src/entities/customBookingForm/entity.ts + 3 modules
var customBookingForm_entity = __webpack_require__(26584);
// EXTERNAL MODULE: ./src/entities/customBookingFormField/entity.ts + 3 modules
var customBookingFormField_entity = __webpack_require__(42195);
// EXTERNAL MODULE: ./src/entities/customBookingFormFieldOption/entity.ts + 3 modules
var customBookingFormFieldOption_entity = __webpack_require__(55150);
// EXTERNAL MODULE: ./src/entities/travelPricingCustomDataConfig/entity.ts + 3 modules
var travelPricingCustomDataConfig_entity = __webpack_require__(43347);
// EXTERNAL MODULE: ./src/entities/newsletterProvider/entity.ts + 3 modules
var newsletterProvider_entity = __webpack_require__(5433);
// EXTERNAL MODULE: ./src/entities/mailchimpConfig/entity.ts + 3 modules
var mailchimpConfig_entity = __webpack_require__(26729);
;// CONCATENATED MODULE: ./src/entities/cmsSliderBlock/graphql.ts
// language=GraphQL
var ALL_SLIDER_BLOCKS_QUERY = "query Query($withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n  sliderBlocks: cmsSliderBlocks {\n    id\n    fluid\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    size\n    showDots\n    showArrows\n    showLightbox\n    autoplay\n  }\n}";
// language=GraphQL
var SINGLE_SLIDER_BLOCK_QUERY = "query Query($id: ID!, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n  sliderBlock: cmsSliderBlock(id: $id) {\n    id\n    fluid\n    gallery @include(if: $withGallery) {\n      id\n      images @include(if: $withGalleryImages) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n    size\n    showDots\n    showArrows\n    showLightbox\n    autoplay\n  }\n}";
// language=GraphQL
var CREATE_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsSliderBlockInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n    sliderBlock: createCmsSliderBlock(input: $input) {\n      id\n      fluid\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      size\n      showDots\n      showArrows\n      showLightbox\n      autoplay\n    }\n  }";
// language=GraphQL
var UPDATE_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsSliderBlockInput, $withGallery: Boolean = false, $withGalleryImages: Boolean = false) {\n    sliderBlock: updateCmsSliderBlock(input: $input) {\n      id\n      fluid\n      gallery @include(if: $withGallery) {\n        id\n        images @include(if: $withGalleryImages) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      size\n      showDots\n      showArrows\n      showLightbox\n      autoplay\n    }\n  }";
// language=GraphQL
var DELETE_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsSliderBlockInput) {\n    deleteCmsSliderBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_SLIDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsSliderBlockInput) {\n    forceDeleteCmsSliderBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsSliderBlock/model.ts


var cmsSliderBlockModel = {
    name: "sliderBlock",
    namePlural: "sliderBlocks",
    uniqueName: "cmsSliderBlock",
    uniqueNamePlural: "cmsSliderBlocks",
    path: "cms/blocks/slider_block",
    baseUrl: "/cms/blocks/slider_blocks",
    translationPrefix: "entities:cmsSliderBlock.",
    getDisplayName: function(values) {
        return "Slider Block";
    },
    gql: {
        getAll: ALL_SLIDER_BLOCKS_QUERY,
        getSingle: SINGLE_SLIDER_BLOCK_QUERY,
        create: CREATE_SLIDER_BLOCK_MUTATION,
        update: UPDATE_SLIDER_BLOCK_MUTATION,
        delete: DELETE_SLIDER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_SLIDER_BLOCK_MUTATION
    },
    attributes: {
        fluid: {
            name: "fluid",
            label: "entities:cmsSliderBlock.attributes.fluid.label",
            type: "value",
            dataType: "boolean",
            defaultInput: false,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        gallery: {
            name: "gallery",
            label: "entities:cmsSliderBlock.attributes.gallery.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return imageGallery_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "select",
            validationType: "string",
            validations: []
        },
        size: {
            name: "size",
            label: "entities:cmsSliderBlock.attributes.size.label",
            type: "value",
            dataType: "string",
            defaultValue: "default",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsSliderBlock.attributes.size.selectOptions.default.label",
                    value: "default"
                },
                {
                    label: "entities:cmsSliderBlock.attributes.size.selectOptions.small.label",
                    value: "small"
                }, 
            ],
            validationType: "string",
            validations: []
        },
        showDots: {
            name: "showDots",
            label: "entities:cmsSliderBlock.attributes.showDots.label",
            type: "value",
            dataType: "boolean",
            defaultValue: true,
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        showArrows: {
            name: "showArrows",
            label: "entities:cmsSliderBlock.attributes.showArrows.label",
            type: "value",
            dataType: "boolean",
            defaultValue: true,
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        showLightbox: {
            name: "showLightbox",
            label: "entities:cmsSliderBlock.attributes.showLightbox.label",
            type: "value",
            dataType: "boolean",
            defaultValue: true,
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        },
        autoplay: {
            name: "autoplay",
            label: "entities:cmsSliderBlock.attributes.autoplay.label",
            type: "value",
            dataType: "boolean",
            defaultInput: true,
            inputType: "switch",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsSliderBlock_model = (cmsSliderBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsSliderBlock/repository.ts









var cmsSliderBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsSliderBlock_model, object);
    });
};
var cmsSliderBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsSliderBlock_model, object);
};
var cmsSliderBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_SLIDER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsSliderBlock_repository_hydrateObject(data.sliderBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_SLIDER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsSliderBlock_repository_hydrateObjects(data.sliderBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_SLIDER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsSliderBlock_repository_hydrateObject(data.sliderBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_SLIDER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsSliderBlock_repository_hydrateObjects(data.sliderBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsSliderBlock_repository_hydrateObject(data.sliderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsSliderBlock_repository_hydrateObject(data.sliderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsSliderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_SLIDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsSliderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsSliderBlock_repository = (cmsSliderBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsSliderBlock/entity.ts


var cmsSliderBlockEntity = {
    model: cmsSliderBlock_model,
    repository: cmsSliderBlock_repository
};
/* harmony default export */ var cmsSliderBlock_entity = ((/* unused pure expression or super */ null && (cmsSliderBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsDestinationsBlock/graphql.ts
// language=GraphQL
var ALL_DESTINATIONS_BLOCKS_QUERY = "query Query($withDestinations: Boolean = false) {\n  destinationsBlocks: cmsDestinationsBlocks {\n    id\n    destinations @include(if: $withDestinations) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n  }\n}";
// language=GraphQL
var SINGLE_DESTINATIONS_BLOCK_QUERY = "query Query($id: ID!, $withDestinations: Boolean = false) {\n  destinationsBlock: cmsDestinationsBlock(id: $id) {\n    id\n    destinations @include(if: $withDestinations) {\n      id\n      name\n      entryRequirements\n      medicalInformation\n      language\n      timeShift\n      climate\n      currency\n    }\n  }\n}";
// language=GraphQL
var CREATE_DESTINATIONS_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsDestinationsBlockInput, $withDestinations: Boolean = false) {\n    destinationsBlock: createCmsDestinationsBlock(input: $input) {\n      id\n      destinations @include(if: $withDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_DESTINATIONS_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsDestinationsBlockInput, $withDestinations: Boolean = false) {\n    destinationsBlock: updateCmsDestinationsBlock(input: $input) {\n      id\n      destinations @include(if: $withDestinations) {\n        id\n        name\n        entryRequirements\n        medicalInformation\n        language\n        timeShift\n        climate\n        currency\n      }\n    }\n  }";
// language=GraphQL
var DELETE_DESTINATIONS_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsDestinationsBlockInput) {\n    deleteCmsDestinationsBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_DESTINATIONS_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsDestinationsBlockInput) {\n    forceDeleteCmsDestinationsBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: addCmsDestinationsBlockDestinationsInput) {\n    addCmsDestinationsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var REMOVE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: removeCmsDestinationsBlockDestinationsInput) {\n    removeCmsDestinationsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var CREATE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: createCmsDestinationsBlockDestinationsInput) {\n    createCmsDestinationsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var DELETE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION = "\n  mutation Mutation($input: deleteCmsDestinationsBlockDestinationsInput) {\n    deleteCmsDestinationsBlockDestinations(input: $input) {\n      id\n      destinationIds\n    }\n  }";
// language=GraphQL
var UPDATE_DESTINATIONS_BLOCK_DESTINATIONS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsDestinationsBlockDestinationsOrderInput) {\n    updateCmsDestinationsBlockDestinationsOrder(input: $input) {\n      id\n      destinationIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsDestinationsBlock/model.ts


var cmsDestinationsBlockModel = {
    name: "destinationsBlock",
    namePlural: "destinationsBlocks",
    uniqueName: "cmsDestinationsBlock",
    uniqueNamePlural: "cmsDestinationsBlocks",
    path: "cms/blocks/destinations_block",
    baseUrl: "/cms/blocks/destinations_blocks",
    translationPrefix: "entities:cmsDestinationsBlock.",
    getDisplayName: function(values) {
        return "Destinations Block";
    },
    gql: {
        getAll: ALL_DESTINATIONS_BLOCKS_QUERY,
        getSingle: SINGLE_DESTINATIONS_BLOCK_QUERY,
        create: CREATE_DESTINATIONS_BLOCK_MUTATION,
        update: UPDATE_DESTINATIONS_BLOCK_MUTATION,
        delete: DELETE_DESTINATIONS_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_DESTINATIONS_BLOCK_MUTATION
    },
    attributes: {
        destinations: {
            name: "destinations",
            label: "entities:cmsDestinationsBlock.attributes.destinations.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelDestination_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsDestinationsBlock_model = (cmsDestinationsBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsDestinationsBlock/repository.ts









var cmsDestinationsBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsDestinationsBlock_model, object);
    });
};
var cmsDestinationsBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsDestinationsBlock_model, object);
};
var cmsDestinationsBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_DESTINATIONS_BLOCK_QUERY, variables).then(function(data) {
                        return cmsDestinationsBlock_repository_hydrateObject(data.destinationsBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_DESTINATIONS_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsDestinationsBlock_repository_hydrateObjects(data.destinationsBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_DESTINATIONS_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsDestinationsBlock_repository_hydrateObject(data.destinationsBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_DESTINATIONS_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsDestinationsBlock_repository_hydrateObjects(data.destinationsBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DESTINATIONS_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsDestinationsBlock_repository_hydrateObject(data.destinationsBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DESTINATIONS_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsDestinationsBlock_repository_hydrateObject(data.destinationsBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DESTINATIONS_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsDestinationsBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_DESTINATIONS_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsDestinationsBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinations: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteDestinations: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_DESTINATIONS_BLOCK_DESTINATIONS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateDestinationsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        destinationIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_DESTINATIONS_BLOCK_DESTINATIONS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsDestinationsBlock_repository = (cmsDestinationsBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsDestinationsBlock/entity.ts


var cmsDestinationsBlockEntity = {
    model: cmsDestinationsBlock_model,
    repository: cmsDestinationsBlock_repository
};
/* harmony default export */ var cmsDestinationsBlock_entity = ((/* unused pure expression or super */ null && (cmsDestinationsBlockEntity)));

// EXTERNAL MODULE: ./src/entities/travelWebhookConfig/entity.ts + 3 modules
var travelWebhookConfig_entity = __webpack_require__(39393);
// EXTERNAL MODULE: ./src/entities/travelBargainSettings/entity.ts + 3 modules
var travelBargainSettings_entity = __webpack_require__(58824);
// EXTERNAL MODULE: ./src/entities/travelPricingBranding/entity.ts + 3 modules
var travelPricingBranding_entity = __webpack_require__(12978);
;// CONCATENATED MODULE: ./src/entities/webhookLog/graphql.ts
// language=GraphQL
var ALL_WEBHOOK_LOGS_QUERY = "query Query($withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {\n  webhookLogs: webhookLogs {\n    id\n    type\n    status\n    url\n    payload\n    statusCode\n    response\n    executionTime\n    retryCount\n    original @include(if: $withOriginal) {\n      id\n      type\n      status\n      url\n      payload\n      statusCode\n      response\n      executionTime\n      retryCount\n      original @include(if: $withOriginalOriginal) {\n        id\n        type\n        status\n        url\n        payload\n        statusCode\n        response\n        executionTime\n        retryCount\n        original @include(if: $withOriginalOriginalOriginal) {\n          id\n          type\n          status\n          url\n          payload\n          statusCode\n          response\n          executionTime\n          retryCount\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_WEBHOOK_LOG_QUERY = "query Query($id: ID!, $withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {\n  webhookLog: webhookLog(id: $id) {\n    id\n    type\n    status\n    url\n    payload\n    statusCode\n    response\n    executionTime\n    retryCount\n    original @include(if: $withOriginal) {\n      id\n      type\n      status\n      url\n      payload\n      statusCode\n      response\n      executionTime\n      retryCount\n      original @include(if: $withOriginalOriginal) {\n        id\n        type\n        status\n        url\n        payload\n        statusCode\n        response\n        executionTime\n        retryCount\n        original @include(if: $withOriginalOriginalOriginal) {\n          id\n          type\n          status\n          url\n          payload\n          statusCode\n          response\n          executionTime\n          retryCount\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_WEBHOOK_LOG_MUTATION = "\n  mutation Mutation($input: CreateWebhookLogInput, $withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {\n    webhookLog: createWebhookLog(input: $input) {\n      id\n      type\n      status\n      url\n      payload\n      statusCode\n      response\n      executionTime\n      retryCount\n      original @include(if: $withOriginal) {\n        id\n        type\n        status\n        url\n        payload\n        statusCode\n        response\n        executionTime\n        retryCount\n        original @include(if: $withOriginalOriginal) {\n          id\n          type\n          status\n          url\n          payload\n          statusCode\n          response\n          executionTime\n          retryCount\n          original @include(if: $withOriginalOriginalOriginal) {\n            id\n            type\n            status\n            url\n            payload\n            statusCode\n            response\n            executionTime\n            retryCount\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_WEBHOOK_LOG_MUTATION = "\n  mutation Mutation($input: UpdateWebhookLogInput, $withOriginal: Boolean = false, $withOriginalOriginal: Boolean = false, $withOriginalOriginalOriginal: Boolean = false) {\n    webhookLog: updateWebhookLog(input: $input) {\n      id\n      type\n      status\n      url\n      payload\n      statusCode\n      response\n      executionTime\n      retryCount\n      original @include(if: $withOriginal) {\n        id\n        type\n        status\n        url\n        payload\n        statusCode\n        response\n        executionTime\n        retryCount\n        original @include(if: $withOriginalOriginal) {\n          id\n          type\n          status\n          url\n          payload\n          statusCode\n          response\n          executionTime\n          retryCount\n          original @include(if: $withOriginalOriginalOriginal) {\n            id\n            type\n            status\n            url\n            payload\n            statusCode\n            response\n            executionTime\n            retryCount\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_WEBHOOK_LOG_MUTATION = "\n  mutation Mutation($input: DeleteWebhookLogInput) {\n    deleteWebhookLog(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_WEBHOOK_LOG_MUTATION = "\n  mutation Mutation($input: DeleteWebhookLogInput) {\n    forceDeleteWebhookLog(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var WEBHOOK_LOGS_DEPENDENTS_QUERY = "query Query($id: ID!, $withWebhookLogs: Boolean = false) {\n  groupedDependents: webhookLogDependents(id: $id) {\n    webhookLogs @include(if: $withWebhookLogs) {\n      id\n      type\n      status\n      url\n      payload\n      statusCode\n      response\n      executionTime\n      retryCount\n    }\n  }\n}";

;// CONCATENATED MODULE: ./src/entities/webhookLog/model.ts


var webhookLogModel = {
    name: "webhookLog",
    namePlural: "webhookLogs",
    uniqueName: "webhookLog",
    uniqueNamePlural: "webhookLogs",
    path: "webhooks/webhook_log",
    baseUrl: "/webhooks/webhook_logs",
    translationPrefix: "entities:webhookLog.",
    getDisplayName: function(values) {
        return "WEBHOOK LOG";
    },
    gql: {
        getAll: ALL_WEBHOOK_LOGS_QUERY,
        getSingle: SINGLE_WEBHOOK_LOG_QUERY,
        create: CREATE_WEBHOOK_LOG_MUTATION,
        update: UPDATE_WEBHOOK_LOG_MUTATION,
        delete: DELETE_WEBHOOK_LOG_MUTATION,
        forceDelete: FORCE_DELETE_WEBHOOK_LOG_MUTATION
    },
    attributes: {
        type: {
            name: "type",
            label: "entities:webhookLog.attributes.type.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        status: {
            name: "status",
            label: "entities:webhookLog.attributes.status.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        url: {
            name: "url",
            label: "entities:webhookLog.attributes.url.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        payload: {
            name: "payload",
            label: "entities:webhookLog.attributes.payload.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        statusCode: {
            name: "statusCode",
            label: "entities:webhookLog.attributes.statusCode.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        response: {
            name: "response",
            label: "entities:webhookLog.attributes.response.label",
            type: "value",
            dataType: "{ [x: string]: any }",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        executionTime: {
            name: "executionTime",
            label: "entities:webhookLog.attributes.executionTime.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        retryCount: {
            name: "retryCount",
            label: "entities:webhookLog.attributes.retryCount.label",
            type: "value",
            dataType: "number",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        original: {
            name: "original",
            label: "entities:webhookLog.attributes.original.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return webhookLog_entity;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var webhookLog_model = (webhookLogModel);

;// CONCATENATED MODULE: ./src/entities/webhookLog/repository.ts










var webhookLog_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(webhookLog_model, object);
    });
};
var webhookLog_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(webhookLog_model, object);
};
var webhookLogRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_WEBHOOK_LOG_QUERY, variables).then(function(data) {
                        return webhookLog_repository_hydrateObject(data.webhookLog);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_WEBHOOK_LOGS_QUERY, includes).then(function(data) {
                    return webhookLog_repository_hydrateObjects(data.webhookLogs);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_WEBHOOK_LOG_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : webhookLog_repository_hydrateObject(data.webhookLog),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_WEBHOOK_LOGS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : webhookLog_repository_hydrateObjects(data.webhookLogs),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    getDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        var variables = (0,_object_spread/* default */.Z)({
            id: id
        }, includeVars);
        return graphQLClient/* default.request */.Z.request(WEBHOOK_LOGS_DEPENDENTS_QUERY, variables).then(function(data) {
            return data.groupedDependents;
        });
    },
    useDependents: function(id, includes) {
        var includeVars = {};
        includes.forEach(function(include) {
            includeVars["with".concat((0,helpers/* uppercaseFirst */.AB)(include))] = true;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includeVars);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            WEBHOOK_LOGS_DEPENDENTS_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            data: !data ? data : data.groupedDependents,
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_WEBHOOK_LOG_MUTATION, variables).then(function(data) {
                        return webhookLog_repository_hydrateObject(data.webhookLog);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_WEBHOOK_LOG_MUTATION, variables).then(function(data) {
                        return webhookLog_repository_hydrateObject(data.webhookLog);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_WEBHOOK_LOG_MUTATION, variables).then(function(data) {
                        return data.deleteWebhookLog;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_WEBHOOK_LOG_MUTATION, variables).then(function(data) {
                        return data.forceDeleteWebhookLog;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var webhookLog_repository = (webhookLogRepository);

;// CONCATENATED MODULE: ./src/entities/webhookLog/entity.ts


var webhookLogEntity = {
    model: webhookLog_model,
    repository: webhookLog_repository
};
/* harmony default export */ var webhookLog_entity = (webhookLogEntity);

// EXTERNAL MODULE: ./src/entities/tenantOnlinePaymentConfig/entity.ts + 3 modules
var tenantOnlinePaymentConfig_entity = __webpack_require__(33076);
;// CONCATENATED MODULE: ./src/entities/cmsTravelGuidesBlock/graphql.ts
// language=GraphQL
var ALL_TRAVEL_GUIDES_BLOCKS_QUERY = "query Query($withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {\n  travelGuidesBlocks: cmsTravelGuidesBlocks {\n    id\n    travelGuides @include(if: $withTravelGuides) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withTravelGuidesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_TRAVEL_GUIDES_BLOCK_QUERY = "query Query($id: ID!, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {\n  travelGuidesBlock: cmsTravelGuidesBlock(id: $id) {\n    id\n    travelGuides @include(if: $withTravelGuides) {\n      id\n      firstName\n      lastName\n      description\n      image @include(if: $withTravelGuidesImage) {\n        id\n        assetId\n        publicId\n        url\n        resourceType\n        format\n        width\n        height\n        caption\n        title\n        description\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_TRAVEL_GUIDES_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsTravelGuidesBlockInput, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {\n    travelGuidesBlock: createCmsTravelGuidesBlock(input: $input) {\n      id\n      travelGuides @include(if: $withTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_GUIDES_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsTravelGuidesBlockInput, $withTravelGuides: Boolean = false, $withTravelGuidesImage: Boolean = false) {\n    travelGuidesBlock: updateCmsTravelGuidesBlock(input: $input) {\n      id\n      travelGuides @include(if: $withTravelGuides) {\n        id\n        firstName\n        lastName\n        description\n        image @include(if: $withTravelGuidesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_GUIDES_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTravelGuidesBlockInput) {\n    deleteCmsTravelGuidesBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_TRAVEL_GUIDES_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsTravelGuidesBlockInput) {\n    forceDeleteCmsTravelGuidesBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: addCmsTravelGuidesBlockTravelGuidesInput) {\n    addCmsTravelGuidesBlockTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var REMOVE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: removeCmsTravelGuidesBlockTravelGuidesInput) {\n    removeCmsTravelGuidesBlockTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var CREATE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: createCmsTravelGuidesBlockTravelGuidesInput) {\n    createCmsTravelGuidesBlockTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var DELETE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION = "\n  mutation Mutation($input: deleteCmsTravelGuidesBlockTravelGuidesInput) {\n    deleteCmsTravelGuidesBlockTravelGuides(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";
// language=GraphQL
var UPDATE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsTravelGuidesBlockTravelGuidesOrderInput) {\n    updateCmsTravelGuidesBlockTravelGuidesOrder(input: $input) {\n      id\n      travelGuideIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsTravelGuidesBlock/model.ts


var cmsTravelGuidesBlockModel = {
    name: "travelGuidesBlock",
    namePlural: "travelGuidesBlocks",
    uniqueName: "cmsTravelGuidesBlock",
    uniqueNamePlural: "cmsTravelGuidesBlocks",
    path: "cms/blocks/travel_guides_block",
    baseUrl: "/cms/blocks/travel_guides_blocks",
    translationPrefix: "entities:cmsTravelGuidesBlock.",
    getDisplayName: function(values) {
        return "TRAVEL GUIDES BLOCK";
    },
    gql: {
        getAll: ALL_TRAVEL_GUIDES_BLOCKS_QUERY,
        getSingle: SINGLE_TRAVEL_GUIDES_BLOCK_QUERY,
        create: CREATE_TRAVEL_GUIDES_BLOCK_MUTATION,
        update: UPDATE_TRAVEL_GUIDES_BLOCK_MUTATION,
        delete: DELETE_TRAVEL_GUIDES_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_TRAVEL_GUIDES_BLOCK_MUTATION
    },
    attributes: {
        travelGuides: {
            name: "travelGuides",
            label: "entities:cmsTravelGuidesBlock.attributes.travelGuides.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return travelGuide_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsTravelGuidesBlock_model = (cmsTravelGuidesBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsTravelGuidesBlock/repository.ts









var cmsTravelGuidesBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsTravelGuidesBlock_model, object);
    });
};
var cmsTravelGuidesBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsTravelGuidesBlock_model, object);
};
var cmsTravelGuidesBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_TRAVEL_GUIDES_BLOCK_QUERY, variables).then(function(data) {
                        return cmsTravelGuidesBlock_repository_hydrateObject(data.travelGuidesBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_TRAVEL_GUIDES_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsTravelGuidesBlock_repository_hydrateObjects(data.travelGuidesBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_TRAVEL_GUIDES_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsTravelGuidesBlock_repository_hydrateObject(data.travelGuidesBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_TRAVEL_GUIDES_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsTravelGuidesBlock_repository_hydrateObjects(data.travelGuidesBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_GUIDES_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTravelGuidesBlock_repository_hydrateObject(data.travelGuidesBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_GUIDES_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsTravelGuidesBlock_repository_hydrateObject(data.travelGuidesBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_GUIDES_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsTravelGuidesBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_TRAVEL_GUIDES_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsTravelGuidesBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuides: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteTravelGuides: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateTravelGuidesOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        travelGuideIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_TRAVEL_GUIDES_BLOCK_TRAVEL_GUIDES_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsTravelGuidesBlock_repository = (cmsTravelGuidesBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsTravelGuidesBlock/entity.ts


var cmsTravelGuidesBlockEntity = {
    model: cmsTravelGuidesBlock_model,
    repository: cmsTravelGuidesBlock_repository
};
/* harmony default export */ var cmsTravelGuidesBlock_entity = ((/* unused pure expression or super */ null && (cmsTravelGuidesBlockEntity)));

// EXTERNAL MODULE: ./src/entities/travelTestimonial/entity.ts + 3 modules
var travelTestimonial_entity = __webpack_require__(48716);
// EXTERNAL MODULE: ./src/entities/travelEsimSettings/entity.ts + 3 modules
var travelEsimSettings_entity = __webpack_require__(80447);
;// CONCATENATED MODULE: ./src/entities/apiKey/graphql.ts
// language=GraphQL
var ALL_API_KEYS_QUERY = "query Query($withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n  apiKeys: apiKeys {\n    id\n    name\n    key\n    role @include(if: $withRole) {\n      id\n      name\n      description\n      permissions @include(if: $withRolePermissions) {\n        id\n        path\n        module\n        name\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_API_KEY_QUERY = "query Query($id: ID!, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n  apiKey: apiKey(id: $id) {\n    id\n    name\n    key\n    role @include(if: $withRole) {\n      id\n      name\n      description\n      permissions @include(if: $withRolePermissions) {\n        id\n        path\n        module\n        name\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_API_KEY_MUTATION = "\n  mutation Mutation($input: CreateApiKeyInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n    apiKey: createApiKey(input: $input) {\n      id\n      name\n      key\n      role @include(if: $withRole) {\n        id\n        name\n        description\n        permissions @include(if: $withRolePermissions) {\n          id\n          path\n          module\n          name\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_API_KEY_MUTATION = "\n  mutation Mutation($input: UpdateApiKeyInput, $withRole: Boolean = false, $withRolePermissions: Boolean = false) {\n    apiKey: updateApiKey(input: $input) {\n      id\n      name\n      key\n      role @include(if: $withRole) {\n        id\n        name\n        description\n        permissions @include(if: $withRolePermissions) {\n          id\n          path\n          module\n          name\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_API_KEY_MUTATION = "\n  mutation Mutation($input: DeleteApiKeyInput) {\n    deleteApiKey(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_API_KEY_MUTATION = "\n  mutation Mutation($input: DeleteApiKeyInput) {\n    forceDeleteApiKey(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/apiKey/model.ts


var apiKeyModel = {
    name: "apiKey",
    namePlural: "apiKeys",
    uniqueName: "apiKey",
    uniqueNamePlural: "apiKeys",
    path: "iam/api_key",
    baseUrl: "/iam/api_keys",
    translationPrefix: "entities:apiKey.",
    getDisplayName: function(values) {
        return "API_KEY";
    },
    gql: {
        getAll: ALL_API_KEYS_QUERY,
        getSingle: SINGLE_API_KEY_QUERY,
        create: CREATE_API_KEY_MUTATION,
        update: UPDATE_API_KEY_MUTATION,
        delete: DELETE_API_KEY_MUTATION,
        forceDelete: FORCE_DELETE_API_KEY_MUTATION
    },
    attributes: {
        name: {
            name: "name",
            label: "entities:apiKey.attributes.name.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        key: {
            name: "key",
            label: "entities:apiKey.attributes.key.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "password",
            validationType: "string",
            validations: []
        },
        role: {
            name: "role",
            label: "entities:apiKey.attributes.role.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return rbacRole_entity;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var apiKey_model = (apiKeyModel);

;// CONCATENATED MODULE: ./src/entities/apiKey/repository.ts









var apiKey_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(apiKey_model, object);
    });
};
var apiKey_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(apiKey_model, object);
};
var apiKeyRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_API_KEY_QUERY, variables).then(function(data) {
                        return apiKey_repository_hydrateObject(data.apiKey);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_API_KEYS_QUERY, includes).then(function(data) {
                    return apiKey_repository_hydrateObjects(data.apiKeys);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_API_KEY_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : apiKey_repository_hydrateObject(data.apiKey),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_API_KEYS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : apiKey_repository_hydrateObjects(data.apiKeys),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_API_KEY_MUTATION, variables).then(function(data) {
                        return apiKey_repository_hydrateObject(data.apiKey);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_API_KEY_MUTATION, variables).then(function(data) {
                        return apiKey_repository_hydrateObject(data.apiKey);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_API_KEY_MUTATION, variables).then(function(data) {
                        return data.deleteApiKey;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_API_KEY_MUTATION, variables).then(function(data) {
                        return data.forceDeleteApiKey;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var apiKey_repository = (apiKeyRepository);

;// CONCATENATED MODULE: ./src/entities/apiKey/entity.ts


var apiKeyEntity = {
    model: apiKey_model,
    repository: apiKey_repository
};
/* harmony default export */ var apiKey_entity = ((/* unused pure expression or super */ null && (apiKeyEntity)));

;// CONCATENATED MODULE: ./src/entities/cmsBusfinderBlock/graphql.ts
// language=GraphQL
var ALL_BUSFINDER_BLOCKS_QUERY = "query Query {\n  busfinderBlocks: cmsBusfinderBlocks {\n    id\n    title\n  }\n}";
// language=GraphQL
var SINGLE_BUSFINDER_BLOCK_QUERY = "query Query($id: ID!) {\n  busfinderBlock: cmsBusfinderBlock(id: $id) {\n    id\n    title\n  }\n}";
// language=GraphQL
var CREATE_BUSFINDER_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsBusfinderBlockInput) {\n    busfinderBlock: createCmsBusfinderBlock(input: $input) {\n      id\n      title\n    }\n  }";
// language=GraphQL
var UPDATE_BUSFINDER_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsBusfinderBlockInput) {\n    busfinderBlock: updateCmsBusfinderBlock(input: $input) {\n      id\n      title\n    }\n  }";
// language=GraphQL
var DELETE_BUSFINDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsBusfinderBlockInput) {\n    deleteCmsBusfinderBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BUSFINDER_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsBusfinderBlockInput) {\n    forceDeleteCmsBusfinderBlock(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsBusfinderBlock/model.ts

var cmsBusfinderBlockModel = {
    name: "busfinderBlock",
    namePlural: "busfinderBlocks",
    uniqueName: "cmsBusfinderBlock",
    uniqueNamePlural: "cmsBusfinderBlocks",
    path: "cms/blocks/busfinder_block",
    baseUrl: "/cms/blocks/busfinder_blocks",
    translationPrefix: "entities:cmsBusfinderBlock.",
    getDisplayName: function(values) {
        return "BUSFINDER BLOCK";
    },
    gql: {
        getAll: ALL_BUSFINDER_BLOCKS_QUERY,
        getSingle: SINGLE_BUSFINDER_BLOCK_QUERY,
        create: CREATE_BUSFINDER_BLOCK_MUTATION,
        update: UPDATE_BUSFINDER_BLOCK_MUTATION,
        delete: DELETE_BUSFINDER_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_BUSFINDER_BLOCK_MUTATION
    },
    attributes: {
        title: {
            name: "title",
            label: "entities:cmsBusfinderBlock.attributes.title.label",
            type: "value",
            dataType: "string",
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsBusfinderBlock_model = (cmsBusfinderBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsBusfinderBlock/repository.ts









var cmsBusfinderBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsBusfinderBlock_model, object);
    });
};
var cmsBusfinderBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsBusfinderBlock_model, object);
};
var cmsBusfinderBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BUSFINDER_BLOCK_QUERY, variables).then(function(data) {
                        return cmsBusfinderBlock_repository_hydrateObject(data.busfinderBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BUSFINDER_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsBusfinderBlock_repository_hydrateObjects(data.busfinderBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BUSFINDER_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsBusfinderBlock_repository_hydrateObject(data.busfinderBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BUSFINDER_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsBusfinderBlock_repository_hydrateObjects(data.busfinderBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BUSFINDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsBusfinderBlock_repository_hydrateObject(data.busfinderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BUSFINDER_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsBusfinderBlock_repository_hydrateObject(data.busfinderBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BUSFINDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsBusfinderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BUSFINDER_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsBusfinderBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsBusfinderBlock_repository = (cmsBusfinderBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsBusfinderBlock/entity.ts


var cmsBusfinderBlockEntity = {
    model: cmsBusfinderBlock_model,
    repository: cmsBusfinderBlock_repository
};
/* harmony default export */ var cmsBusfinderBlock_entity = ((/* unused pure expression or super */ null && (cmsBusfinderBlockEntity)));

;// CONCATENATED MODULE: ./src/entities/customerEsim/graphql.ts
// language=GraphQL
var ALL_CUSTOMER_ESIMS_QUERY = "query Query {\n  customerEsims: customerEsims {\n    id\n    referenceNo\n    serviceName\n    label\n    purchaseId\n    iccid\n    startDate\n    endDate\n  }\n}";
// language=GraphQL
var SINGLE_CUSTOMER_ESIM_QUERY = "query Query($id: ID!) {\n  customerEsim: customerEsim(id: $id) {\n    id\n    referenceNo\n    serviceName\n    label\n    purchaseId\n    iccid\n    startDate\n    endDate\n  }\n}";
// language=GraphQL
var CREATE_CUSTOMER_ESIM_MUTATION = "\n  mutation Mutation($input: CreateCustomerEsimInput) {\n    customerEsim: createCustomerEsim(input: $input) {\n      id\n      referenceNo\n      serviceName\n      label\n      purchaseId\n      iccid\n      startDate\n      endDate\n    }\n  }";
// language=GraphQL
var UPDATE_CUSTOMER_ESIM_MUTATION = "\n  mutation Mutation($input: UpdateCustomerEsimInput) {\n    customerEsim: updateCustomerEsim(input: $input) {\n      id\n      referenceNo\n      serviceName\n      label\n      purchaseId\n      iccid\n      startDate\n      endDate\n    }\n  }";
// language=GraphQL
var DELETE_CUSTOMER_ESIM_MUTATION = "\n  mutation Mutation($input: DeleteCustomerEsimInput) {\n    deleteCustomerEsim(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CUSTOMER_ESIM_MUTATION = "\n  mutation Mutation($input: DeleteCustomerEsimInput) {\n    forceDeleteCustomerEsim(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/customerEsim/model.ts

var customerEsimModel = {
    name: "customerEsim",
    namePlural: "customerEsims",
    uniqueName: "customerEsim",
    uniqueNamePlural: "customerEsims",
    path: "travel/booking/customer_esim",
    baseUrl: "/travel/booking/customer_esims",
    translationPrefix: "entities:customerEsim.",
    getDisplayName: function(values) {
        return values.referenceNo;
    },
    gql: {
        getAll: ALL_CUSTOMER_ESIMS_QUERY,
        getSingle: SINGLE_CUSTOMER_ESIM_QUERY,
        create: CREATE_CUSTOMER_ESIM_MUTATION,
        update: UPDATE_CUSTOMER_ESIM_MUTATION,
        delete: DELETE_CUSTOMER_ESIM_MUTATION,
        forceDelete: FORCE_DELETE_CUSTOMER_ESIM_MUTATION
    },
    attributes: {
        referenceNo: {
            name: "referenceNo",
            label: "entities:customerEsim.attributes.referenceNo.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        serviceName: {
            name: "serviceName",
            label: "entities:customerEsim.attributes.serviceName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        label: {
            name: "label",
            label: "entities:customerEsim.attributes.label.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        purchaseId: {
            name: "purchaseId",
            label: "entities:customerEsim.attributes.purchaseId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        iccid: {
            name: "iccid",
            label: "entities:customerEsim.attributes.iccid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        startDate: {
            name: "startDate",
            label: "entities:customerEsim.attributes.startDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "text",
            isStartDate: true,
            endDateAttribute: "",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        endDate: {
            name: "endDate",
            label: "entities:customerEsim.attributes.endDate.label",
            type: "value",
            dataType: "Date",
            defaultInput: true,
            inputType: "text",
            isEndDate: true,
            startDateAttribute: "",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var customerEsim_model = (customerEsimModel);

;// CONCATENATED MODULE: ./src/entities/customerEsim/repository.ts









var customerEsim_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(customerEsim_model, object);
    });
};
var customerEsim_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(customerEsim_model, object);
};
var customerEsimRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CUSTOMER_ESIM_QUERY, variables).then(function(data) {
                        return customerEsim_repository_hydrateObject(data.customerEsim);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CUSTOMER_ESIMS_QUERY, includes).then(function(data) {
                    return customerEsim_repository_hydrateObjects(data.customerEsims);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CUSTOMER_ESIM_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : customerEsim_repository_hydrateObject(data.customerEsim),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CUSTOMER_ESIMS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : customerEsim_repository_hydrateObjects(data.customerEsims),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CUSTOMER_ESIM_MUTATION, variables).then(function(data) {
                        return customerEsim_repository_hydrateObject(data.customerEsim);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CUSTOMER_ESIM_MUTATION, variables).then(function(data) {
                        return customerEsim_repository_hydrateObject(data.customerEsim);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CUSTOMER_ESIM_MUTATION, variables).then(function(data) {
                        return data.deleteCustomerEsim;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CUSTOMER_ESIM_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCustomerEsim;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var customerEsim_repository = (customerEsimRepository);

;// CONCATENATED MODULE: ./src/entities/customerEsim/entity.ts


var customerEsimEntity = {
    model: customerEsim_model,
    repository: customerEsim_repository
};
/* harmony default export */ var customerEsim_entity = ((/* unused pure expression or super */ null && (customerEsimEntity)));

// EXTERNAL MODULE: ./src/entities/travelAccommodationAssignment/entity.ts + 3 modules
var travelAccommodationAssignment_entity = __webpack_require__(88939);
// EXTERNAL MODULE: ./src/entities/travelPricingPassportConfig/entity.ts + 3 modules
var travelPricingPassportConfig_entity = __webpack_require__(38339);
// EXTERNAL MODULE: ./src/entities/customBookingFormFieldVisibilityConfig/entity.ts + 3 modules
var customBookingFormFieldVisibilityConfig_entity = __webpack_require__(73734);
// EXTERNAL MODULE: ./src/entities/tenantRatioConfig/entity.ts + 3 modules
var tenantRatioConfig_entity = __webpack_require__(1871);
;// CONCATENATED MODULE: ./src/entities/cmsBackgroundBlock/graphql.ts
// language=GraphQL
var ALL_BACKGROUND_BLOCKS_QUERY = "query Query($withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n  backgroundBlocks: cmsBackgroundBlocks {\n    id\n    backgroundVariant\n    contentBlockAssignments @include(if: $withContentBlockAssignments) {\n      id\n      type\n      block @include(if: $withContentBlockAssignmentsBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          link @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            text\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            description\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            type\n          }\n\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_BACKGROUND_BLOCK_QUERY = "query Query($id: ID!, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n  backgroundBlock: cmsBackgroundBlock(id: $id) {\n    id\n    backgroundVariant\n    contentBlockAssignments @include(if: $withContentBlockAssignments) {\n      id\n      type\n      block @include(if: $withContentBlockAssignmentsBlock) {\n        __typename\n        ... on CmsTextBlock {\n          id\n          text\n\n        }\n        ... on CmsTextWithImageBlock {\n          id\n          title\n          subtitle\n          text\n          imagePosition\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imageFixedAspectRatio\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          link @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            label\n            targetBlank\n            type\n            url\n          }\n\n        }\n        ... on CmsPageHeaderBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n\n        }\n        ... on CmsWysiwygBlock {\n          id\n          html\n\n        }\n        ... on CmsHeadingBlock {\n          id\n          importance\n          heading\n          addon\n          decoration\n\n        }\n        ... on CmsTextWithIconBlock {\n          id\n          title\n          text\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          imagePosition\n\n        }\n        ... on CmsAccordionBlock {\n          id\n          items @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            content\n          }\n\n        }\n        ... on CmsGridBlock {\n          id\n          columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n\n        }\n        ... on CmsImageBlock {\n          id\n          image @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          text\n          fluid\n\n        }\n        ... on CmsEmployeesBlock {\n          id\n          employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n\n        }\n        ... on CmsContactBannerBlock {\n          id\n          employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            jobTitle\n            description\n            email\n            phone\n          }\n          phone\n          email\n\n        }\n        ... on CmsNewsletterRegisterBlock {\n          id\n          fluid\n\n        }\n        ... on CmsIssuuCatalogBlock {\n          id\n          publicationCode\n          accountName\n\n        }\n        ... on CmsFormBlock {\n          id\n          formName\n\n        }\n        ... on CmsHeaderSliderBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            title\n            text\n          }\n\n        }\n        ... on CmsBestsellerSliderBlock {\n          id\n          fluid\n\n        }\n        ... on CmsFilterLeadBlock {\n          id\n          layout\n\n        }\n        ... on CmsTravelTypesBlock {\n          id\n          layout\n\n        }\n        ... on CmsPrefilteredTravelsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n          travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            description\n          }\n          maxResults\n\n        }\n        ... on CmsDividerBlock {\n          id\n          fluid\n\n        }\n        ... on CmsTravelSelectionBlock {\n          id\n          travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n\n        }\n        ... on CmsIframeBlock {\n          id\n          url\n          minHeight\n\n        }\n        ... on CmsSliderBlock {\n          id\n          fluid\n          gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n          }\n          size\n          showDots\n          showArrows\n          showLightbox\n          autoplay\n\n        }\n        ... on CmsDestinationsBlock {\n          id\n          destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            name\n            entryRequirements\n            medicalInformation\n            language\n            timeShift\n            climate\n            currency\n          }\n\n        }\n        ... on CmsTravelGuidesBlock {\n          id\n          travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            firstName\n            lastName\n            description\n          }\n\n        }\n        ... on CmsBusfinderBlock {\n          id\n          title\n\n        }\n        ... on CmsBackgroundBlock {\n          id\n          backgroundVariant\n          contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n            id\n            type\n          }\n\n        }\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_BACKGROUND_BLOCK_MUTATION = "\n  mutation Mutation($input: CreateCmsBackgroundBlockInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n    backgroundBlock: createCmsBackgroundBlock(input: $input) {\n      id\n      backgroundVariant\n      contentBlockAssignments @include(if: $withContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imageFixedAspectRatio\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            link @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n            items @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              content\n            }\n\n          }\n          ... on CmsGridBlock {\n            id\n            columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n\n          }\n          ... on CmsImageBlock {\n            id\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n            employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n            slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              text\n            }\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              description\n            }\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              description\n            }\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              type\n            }\n\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_BACKGROUND_BLOCK_MUTATION = "\n  mutation Mutation($input: UpdateCmsBackgroundBlockInput, $withContentBlockAssignments: Boolean = false, $withContentBlockAssignmentsBlock: Boolean = false, $withContentBlockAssignmentsBlockDeep: Boolean = false) {\n    backgroundBlock: updateCmsBackgroundBlock(input: $input) {\n      id\n      backgroundVariant\n      contentBlockAssignments @include(if: $withContentBlockAssignments) {\n        id\n        type\n        block @include(if: $withContentBlockAssignmentsBlock) {\n          __typename\n          ... on CmsTextBlock {\n            id\n            text\n\n          }\n          ... on CmsTextWithImageBlock {\n            id\n            title\n            subtitle\n            text\n            imagePosition\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imageFixedAspectRatio\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            link @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              label\n              targetBlank\n              type\n              url\n            }\n\n          }\n          ... on CmsPageHeaderBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n\n          }\n          ... on CmsWysiwygBlock {\n            id\n            html\n\n          }\n          ... on CmsHeadingBlock {\n            id\n            importance\n            heading\n            addon\n            decoration\n\n          }\n          ... on CmsTextWithIconBlock {\n            id\n            title\n            text\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            imagePosition\n\n          }\n          ... on CmsAccordionBlock {\n            id\n            items @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              content\n            }\n\n          }\n          ... on CmsGridBlock {\n            id\n            columns @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n\n          }\n          ... on CmsImageBlock {\n            id\n            image @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              assetId\n              publicId\n              url\n              resourceType\n              format\n              width\n              height\n              caption\n              title\n              description\n            }\n            text\n            fluid\n\n          }\n          ... on CmsEmployeesBlock {\n            id\n            employees @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n\n          }\n          ... on CmsContactBannerBlock {\n            id\n            employee @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              jobTitle\n              description\n              email\n              phone\n            }\n            phone\n            email\n\n          }\n          ... on CmsNewsletterRegisterBlock {\n            id\n            fluid\n\n          }\n          ... on CmsIssuuCatalogBlock {\n            id\n            publicationCode\n            accountName\n\n          }\n          ... on CmsFormBlock {\n            id\n            formName\n\n          }\n          ... on CmsHeaderSliderBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n            slides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              title\n              text\n            }\n\n          }\n          ... on CmsBestsellerSliderBlock {\n            id\n            fluid\n\n          }\n          ... on CmsFilterLeadBlock {\n            id\n            layout\n\n          }\n          ... on CmsTravelTypesBlock {\n            id\n            layout\n\n          }\n          ... on CmsPrefilteredTravelsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n            travelTypes @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              description\n            }\n            maxResults\n\n          }\n          ... on CmsDividerBlock {\n            id\n            fluid\n\n          }\n          ... on CmsTravelSelectionBlock {\n            id\n            travels @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              isBestseller\n              startDate\n              endDate\n              executionStatus\n              title\n              description\n              includedServices\n              excludedServices\n              pricingTable\n              priceCalculationInfo\n              programType\n              programText\n              minPrice\n              minPriceManualOverride\n              currency\n            }\n\n          }\n          ... on CmsIframeBlock {\n            id\n            url\n            minHeight\n\n          }\n          ... on CmsSliderBlock {\n            id\n            fluid\n            gallery @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n            }\n            size\n            showDots\n            showArrows\n            showLightbox\n            autoplay\n\n          }\n          ... on CmsDestinationsBlock {\n            id\n            destinations @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              name\n              entryRequirements\n              medicalInformation\n              language\n              timeShift\n              climate\n              currency\n            }\n\n          }\n          ... on CmsTravelGuidesBlock {\n            id\n            travelGuides @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              firstName\n              lastName\n              description\n            }\n\n          }\n          ... on CmsBusfinderBlock {\n            id\n            title\n\n          }\n          ... on CmsBackgroundBlock {\n            id\n            backgroundVariant\n            contentBlockAssignments @include(if: $withContentBlockAssignmentsBlockDeep) {\n              id\n              type\n            }\n\n          }\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_BACKGROUND_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsBackgroundBlockInput) {\n    deleteCmsBackgroundBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_BACKGROUND_BLOCK_MUTATION = "\n  mutation Mutation($input: DeleteCmsBackgroundBlockInput) {\n    forceDeleteCmsBackgroundBlock(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var ADD_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: addCmsBackgroundBlockContentBlockAssignmentsInput) {\n    addCmsBackgroundBlockContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var REMOVE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: removeCmsBackgroundBlockContentBlockAssignmentsInput) {\n    removeCmsBackgroundBlockContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var CREATE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: createCmsBackgroundBlockContentBlockAssignmentsInput) {\n    createCmsBackgroundBlockContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var DELETE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION = "\n  mutation Mutation($input: deleteCmsBackgroundBlockContentBlockAssignmentsInput) {\n    deleteCmsBackgroundBlockContentBlockAssignments(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";
// language=GraphQL
var UPDATE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION = "\n  mutation Mutation($input: updateCmsBackgroundBlockContentBlockAssignmentsOrderInput) {\n    updateCmsBackgroundBlockContentBlockAssignmentsOrder(input: $input) {\n      id\n      contentBlockAssignmentIds\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/cmsBackgroundBlock/model.ts


var cmsBackgroundBlockModel = {
    name: "backgroundBlock",
    namePlural: "backgroundBlocks",
    uniqueName: "cmsBackgroundBlock",
    uniqueNamePlural: "cmsBackgroundBlocks",
    path: "cms/blocks/background_block",
    baseUrl: "/cms/blocks/background_blocks",
    translationPrefix: "entities:cmsBackgroundBlock.",
    getDisplayName: function(values) {
        return "Background Block";
    },
    gql: {
        getAll: ALL_BACKGROUND_BLOCKS_QUERY,
        getSingle: SINGLE_BACKGROUND_BLOCK_QUERY,
        create: CREATE_BACKGROUND_BLOCK_MUTATION,
        update: UPDATE_BACKGROUND_BLOCK_MUTATION,
        delete: DELETE_BACKGROUND_BLOCK_MUTATION,
        forceDelete: FORCE_DELETE_BACKGROUND_BLOCK_MUTATION
    },
    attributes: {
        backgroundVariant: {
            name: "backgroundVariant",
            label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.label",
            type: "value",
            dataType: "string",
            defaultValue: "primary",
            defaultInput: true,
            inputType: "select",
            selectOptions: [
                {
                    label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.primary.label",
                    value: "primary"
                },
                {
                    label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.secondary.label",
                    value: "secondary"
                },
                {
                    label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.tertiary.label",
                    value: "tertiary"
                },
                {
                    label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.quaternary.label",
                    value: "quaternary"
                },
                {
                    label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.signal.label",
                    value: "signal"
                },
                {
                    label: "entities:cmsBackgroundBlock.attributes.backgroundVariant.selectOptions.theme.label",
                    value: "theme"
                }, 
            ],
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        },
        contentBlockAssignments: {
            name: "contentBlockAssignments",
            label: "entities:cmsBackgroundBlock.attributes.contentBlockAssignments.label",
            type: "entityCollection",
            dataType: "[any]",
            getEntity: function() {
                return cmsContentBlockAssignment_entity/* default */.Z;
            },
            defaultInput: false,
            inputType: "text",
            validationType: "string",
            validations: []
        }
    }
};
/* harmony default export */ var cmsBackgroundBlock_model = (cmsBackgroundBlockModel);

;// CONCATENATED MODULE: ./src/entities/cmsBackgroundBlock/repository.ts









var cmsBackgroundBlock_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(cmsBackgroundBlock_model, object);
    });
};
var cmsBackgroundBlock_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(cmsBackgroundBlock_model, object);
};
var cmsBackgroundBlockRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_BACKGROUND_BLOCK_QUERY, variables).then(function(data) {
                        return cmsBackgroundBlock_repository_hydrateObject(data.backgroundBlock);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_BACKGROUND_BLOCKS_QUERY, includes).then(function(data) {
                    return cmsBackgroundBlock_repository_hydrateObjects(data.backgroundBlocks);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_BACKGROUND_BLOCK_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : cmsBackgroundBlock_repository_hydrateObject(data.backgroundBlock),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_BACKGROUND_BLOCKS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : cmsBackgroundBlock_repository_hydrateObjects(data.backgroundBlocks),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BACKGROUND_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsBackgroundBlock_repository_hydrateObject(data.backgroundBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BACKGROUND_BLOCK_MUTATION, variables).then(function(data) {
                        return cmsBackgroundBlock_repository_hydrateObject(data.backgroundBlock);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BACKGROUND_BLOCK_MUTATION, variables).then(function(data) {
                        return data.deleteCmsBackgroundBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_BACKGROUND_BLOCK_MUTATION, variables).then(function(data) {
                        return data.forceDeleteCmsBackgroundBlock;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    assignContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(ADD_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    unassignContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(REMOVE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    createContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, items) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignments: items
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, items) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteContentBlockAssignments: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateContentBlockAssignmentsOrder: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id, itemIds) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id,
                        contentBlockAssignmentIds: itemIds
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_BACKGROUND_BLOCK_CONTENT_BLOCK_ASSIGNMENTS_ORDER_MUTATION, variables)
                ];
            });
        });
        return function(id, itemIds) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var cmsBackgroundBlock_repository = (cmsBackgroundBlockRepository);

;// CONCATENATED MODULE: ./src/entities/cmsBackgroundBlock/entity.ts


var cmsBackgroundBlockEntity = {
    model: cmsBackgroundBlock_model,
    repository: cmsBackgroundBlock_repository
};
/* harmony default export */ var cmsBackgroundBlock_entity = ((/* unused pure expression or super */ null && (cmsBackgroundBlockEntity)));

// EXTERNAL MODULE: ./src/entities/tenantContent/entity.ts + 3 modules
var tenantContent_entity = __webpack_require__(61559);
;// CONCATENATED MODULE: ./src/entities/trackingConversion/graphql.ts
// language=GraphQL
var ALL_CONVERSIONS_QUERY = "query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  conversions: trackingConversions {\n    id\n    sessionId\n    conversionName\n    conversionTime\n    conversionValue\n    conversionCurrency\n    tourName\n    tourId\n    bookingId\n    landingPageUrl\n    source\n    medium\n    utmSource\n    utmMedium\n    utmCampaign\n    utmTerm\n    utmContent\n    gclid\n    gbraid\n    msclkid\n    fbclid\n    ttclid\n    scclid\n    liFatId\n    acquisitionTimestamp\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n  }\n}";
// language=GraphQL
var SINGLE_CONVERSION_QUERY = "query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n  conversion: trackingConversion(id: $id) {\n    id\n    sessionId\n    conversionName\n    conversionTime\n    conversionValue\n    conversionCurrency\n    tourName\n    tourId\n    bookingId\n    landingPageUrl\n    source\n    medium\n    utmSource\n    utmMedium\n    utmCampaign\n    utmTerm\n    utmContent\n    gclid\n    gbraid\n    msclkid\n    fbclid\n    ttclid\n    scclid\n    liFatId\n    acquisitionTimestamp\n    tenant @include(if: $withTenant) {\n      id\n      name\n      slug\n      domain\n      externalReference\n      cms @include(if: $withTenantCms) {\n        id\n        homepage @include(if: $withTenantCmsHomepage) {\n          id\n          name\n          onlineStatus\n        }\n        categories @include(if: $withTenantCmsCategories) {\n          id\n          name\n        }\n        pages @include(if: $withTenantCmsPages) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage404 @include(if: $withTenantCmsErrorPage404) {\n          id\n          name\n          onlineStatus\n        }\n        errorPage500 @include(if: $withTenantCmsErrorPage500) {\n          id\n          name\n          onlineStatus\n        }\n        config @include(if: $withTenantCmsConfig) {\n          id\n        }\n      }\n      travelTypes @include(if: $withTenantTravelTypes) {\n        id\n        name\n        description\n        image @include(if: $withTenantTravelTypesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n      }\n      employees @include(if: $withTenantEmployees) {\n        id\n        firstName\n        lastName\n        jobTitle\n        description\n        email\n        image @include(if: $withTenantEmployeesImage) {\n          id\n          assetId\n          publicId\n          url\n          resourceType\n          format\n          width\n          height\n          caption\n          title\n          description\n        }\n        phone\n      }\n      emailConfig @include(if: $withTenantEmailConfig) {\n        id\n        defaultInternalRecipientEmail\n        internalBookingRecipientEmails\n        bookingConfirmationTemplateId\n        bookingConfirmationInternalTemplateId\n        bookingRequestConfirmationTemplateId\n        bookingWaitlistConfirmationTemplateId\n        bookingWaitlistContingentCheckConfirmationTemplateId\n        bookingCustomRequestTemplateId\n        bookingPassportDataReminderTemplateId\n        contactFormTemplateId\n        esimInstallationInfoTemplateId\n      }\n      newsletterProvider @include(if: $withTenantNewsletterProvider) {\n        id\n        provider\n        config @include(if: $withTenantNewsletterProviderConfig) {\n          __typename\n          ... on MailchimpConfig {\n            id\n            apiKey\n            serverPrefix\n            listId\n\n          }\n        }\n      }\n      redirects @include(if: $withTenantRedirects) {\n        id\n        fromType\n        fromUrl\n        fromPage @include(if: $withTenantRedirectsFromPage) {\n          id\n          name\n          onlineStatus\n        }\n        fromTravel @include(if: $withTenantRedirectsFromTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n        toType\n        toUrl\n        toPage @include(if: $withTenantRedirectsToPage) {\n          id\n          name\n          onlineStatus\n        }\n        toTravel @include(if: $withTenantRedirectsToTravel) {\n          id\n          name\n          isBestseller\n          startDate\n          endDate\n          executionStatus\n          title\n          description\n          includedServices\n          excludedServices\n          pricingTable\n          priceCalculationInfo\n          programType\n          programText\n          minPrice\n          minPriceManualOverride\n          currency\n        }\n      }\n      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n        id\n        enabled\n        ratioFibuAccountNo\n        infoText\n        datatransThemeConfig\n      }\n      ratioConfig @include(if: $withTenantRatioConfig) {\n        id\n        adressgruppe\n      }\n      content @include(if: $withTenantContent) {\n        id\n        bookingInsuranceInfo\n      }\n      partnerTenants @include(if: $withTenantPartnerTenants) {\n        id\n        tenant @include(if: $withTenantPartnerTenantsTenant) {\n          id\n          name\n          slug\n          domain\n          externalReference\n        }\n        filterCrossLinking\n      }\n    }\n  }\n}";
// language=GraphQL
var CREATE_CONVERSION_MUTATION = "\n  mutation Mutation($input: CreateTrackingConversionInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    conversion: createTrackingConversion(input: $input) {\n      id\n      sessionId\n      conversionName\n      conversionTime\n      conversionValue\n      conversionCurrency\n      tourName\n      tourId\n      bookingId\n      landingPageUrl\n      source\n      medium\n      utmSource\n      utmMedium\n      utmCampaign\n      utmTerm\n      utmContent\n      gclid\n      gbraid\n      msclkid\n      fbclid\n      ttclid\n      scclid\n      liFatId\n      acquisitionTimestamp\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n    }\n  }";
// language=GraphQL
var UPDATE_CONVERSION_MUTATION = "\n  mutation Mutation($input: UpdateTrackingConversionInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false) {\n    conversion: updateTrackingConversion(input: $input) {\n      id\n      sessionId\n      conversionName\n      conversionTime\n      conversionValue\n      conversionCurrency\n      tourName\n      tourId\n      bookingId\n      landingPageUrl\n      source\n      medium\n      utmSource\n      utmMedium\n      utmCampaign\n      utmTerm\n      utmContent\n      gclid\n      gbraid\n      msclkid\n      fbclid\n      ttclid\n      scclid\n      liFatId\n      acquisitionTimestamp\n      tenant @include(if: $withTenant) {\n        id\n        name\n        slug\n        domain\n        externalReference\n        cms @include(if: $withTenantCms) {\n          id\n          homepage @include(if: $withTenantCmsHomepage) {\n            id\n            name\n            onlineStatus\n          }\n          categories @include(if: $withTenantCmsCategories) {\n            id\n            name\n          }\n          pages @include(if: $withTenantCmsPages) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage404 @include(if: $withTenantCmsErrorPage404) {\n            id\n            name\n            onlineStatus\n          }\n          errorPage500 @include(if: $withTenantCmsErrorPage500) {\n            id\n            name\n            onlineStatus\n          }\n          config @include(if: $withTenantCmsConfig) {\n            id\n          }\n        }\n        travelTypes @include(if: $withTenantTravelTypes) {\n          id\n          name\n          description\n          image @include(if: $withTenantTravelTypesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n        }\n        employees @include(if: $withTenantEmployees) {\n          id\n          firstName\n          lastName\n          jobTitle\n          description\n          email\n          image @include(if: $withTenantEmployeesImage) {\n            id\n            assetId\n            publicId\n            url\n            resourceType\n            format\n            width\n            height\n            caption\n            title\n            description\n          }\n          phone\n        }\n        emailConfig @include(if: $withTenantEmailConfig) {\n          id\n          defaultInternalRecipientEmail\n          internalBookingRecipientEmails\n          bookingConfirmationTemplateId\n          bookingConfirmationInternalTemplateId\n          bookingRequestConfirmationTemplateId\n          bookingWaitlistConfirmationTemplateId\n          bookingWaitlistContingentCheckConfirmationTemplateId\n          bookingCustomRequestTemplateId\n          bookingPassportDataReminderTemplateId\n          contactFormTemplateId\n          esimInstallationInfoTemplateId\n        }\n        newsletterProvider @include(if: $withTenantNewsletterProvider) {\n          id\n          provider\n          config @include(if: $withTenantNewsletterProviderConfig) {\n            __typename\n            ... on MailchimpConfig {\n              id\n              apiKey\n              serverPrefix\n              listId\n\n            }\n          }\n        }\n        redirects @include(if: $withTenantRedirects) {\n          id\n          fromType\n          fromUrl\n          fromPage @include(if: $withTenantRedirectsFromPage) {\n            id\n            name\n            onlineStatus\n          }\n          fromTravel @include(if: $withTenantRedirectsFromTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n          toType\n          toUrl\n          toPage @include(if: $withTenantRedirectsToPage) {\n            id\n            name\n            onlineStatus\n          }\n          toTravel @include(if: $withTenantRedirectsToTravel) {\n            id\n            name\n            isBestseller\n            startDate\n            endDate\n            executionStatus\n            title\n            description\n            includedServices\n            excludedServices\n            pricingTable\n            priceCalculationInfo\n            programType\n            programText\n            minPrice\n            minPriceManualOverride\n            currency\n          }\n        }\n        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {\n          id\n          enabled\n          ratioFibuAccountNo\n          infoText\n          datatransThemeConfig\n        }\n        ratioConfig @include(if: $withTenantRatioConfig) {\n          id\n          adressgruppe\n        }\n        content @include(if: $withTenantContent) {\n          id\n          bookingInsuranceInfo\n        }\n        partnerTenants @include(if: $withTenantPartnerTenants) {\n          id\n          tenant @include(if: $withTenantPartnerTenantsTenant) {\n            id\n            name\n            slug\n            domain\n            externalReference\n          }\n          filterCrossLinking\n        }\n      }\n    }\n  }";
// language=GraphQL
var DELETE_CONVERSION_MUTATION = "\n  mutation Mutation($input: DeleteTrackingConversionInput) {\n    deleteTrackingConversion(input: $input) {\n      success\n    }\n  }";
// language=GraphQL
var FORCE_DELETE_CONVERSION_MUTATION = "\n  mutation Mutation($input: DeleteTrackingConversionInput) {\n    forceDeleteTrackingConversion(input: $input) {\n      success\n    }\n  }";

;// CONCATENATED MODULE: ./src/entities/trackingConversion/model.ts


var trackingConversionModel = {
    name: "conversion",
    namePlural: "conversions",
    uniqueName: "trackingConversion",
    uniqueNamePlural: "trackingConversions",
    path: "tracking/conversion",
    baseUrl: "/tracking/conversions",
    translationPrefix: "entities:trackingConversion.",
    getDisplayName: function(values) {
        return "";
    },
    gql: {
        getAll: ALL_CONVERSIONS_QUERY,
        getSingle: SINGLE_CONVERSION_QUERY,
        create: CREATE_CONVERSION_MUTATION,
        update: UPDATE_CONVERSION_MUTATION,
        delete: DELETE_CONVERSION_MUTATION,
        forceDelete: FORCE_DELETE_CONVERSION_MUTATION
    },
    attributes: {
        sessionId: {
            name: "sessionId",
            label: "entities:trackingConversion.attributes.sessionId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        conversionName: {
            name: "conversionName",
            label: "entities:trackingConversion.attributes.conversionName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        conversionTime: {
            name: "conversionTime",
            label: "entities:trackingConversion.attributes.conversionTime.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        conversionValue: {
            name: "conversionValue",
            label: "entities:trackingConversion.attributes.conversionValue.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        conversionCurrency: {
            name: "conversionCurrency",
            label: "entities:trackingConversion.attributes.conversionCurrency.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        tourName: {
            name: "tourName",
            label: "entities:trackingConversion.attributes.tourName.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        tourId: {
            name: "tourId",
            label: "entities:trackingConversion.attributes.tourId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        bookingId: {
            name: "bookingId",
            label: "entities:trackingConversion.attributes.bookingId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        landingPageUrl: {
            name: "landingPageUrl",
            label: "entities:trackingConversion.attributes.landingPageUrl.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        source: {
            name: "source",
            label: "entities:trackingConversion.attributes.source.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        medium: {
            name: "medium",
            label: "entities:trackingConversion.attributes.medium.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        utmSource: {
            name: "utmSource",
            label: "entities:trackingConversion.attributes.utmSource.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        utmMedium: {
            name: "utmMedium",
            label: "entities:trackingConversion.attributes.utmMedium.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        utmCampaign: {
            name: "utmCampaign",
            label: "entities:trackingConversion.attributes.utmCampaign.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        utmTerm: {
            name: "utmTerm",
            label: "entities:trackingConversion.attributes.utmTerm.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        utmContent: {
            name: "utmContent",
            label: "entities:trackingConversion.attributes.utmContent.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        gclid: {
            name: "gclid",
            label: "entities:trackingConversion.attributes.gclid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        gbraid: {
            name: "gbraid",
            label: "entities:trackingConversion.attributes.gbraid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        msclkid: {
            name: "msclkid",
            label: "entities:trackingConversion.attributes.msclkid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        fbclid: {
            name: "fbclid",
            label: "entities:trackingConversion.attributes.fbclid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        ttclid: {
            name: "ttclid",
            label: "entities:trackingConversion.attributes.ttclid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        scclid: {
            name: "scclid",
            label: "entities:trackingConversion.attributes.scclid.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        liFatId: {
            name: "liFatId",
            label: "entities:trackingConversion.attributes.liFatId.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        acquisitionTimestamp: {
            name: "acquisitionTimestamp",
            label: "entities:trackingConversion.attributes.acquisitionTimestamp.label",
            type: "value",
            dataType: "string",
            defaultInput: true,
            inputType: "text",
            validationType: "string",
            validations: []
        },
        tenant: {
            name: "tenant",
            label: "entities:trackingConversion.attributes.tenant.label",
            type: "entityObject",
            dataType: "any",
            getEntity: function() {
                return tenant_entity/* default */.Z;
            },
            defaultInput: true,
            inputType: "select",
            validationType: "string",
            validations: [
                {
                    type: "required"
                }, 
            ]
        }
    }
};
/* harmony default export */ var trackingConversion_model = (trackingConversionModel);

;// CONCATENATED MODULE: ./src/entities/trackingConversion/repository.ts









var trackingConversion_repository_hydrateObjects = function(objects) {
    return objects.map(function(object) {
        return (0,lib/* hydrateEntityObject */.b)(trackingConversion_model, object);
    });
};
var trackingConversion_repository_hydrateObject = function(object) {
    return (0,lib/* hydrateEntityObject */.b)(trackingConversion_model, object);
};
var trackingConversionRepository = {
    getObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    id: id
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(SINGLE_CONVERSION_QUERY, variables).then(function(data) {
                        return trackingConversion_repository_hydrateObject(data.conversion);
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    getObjects: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var includes;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            includes = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            return [
                2,
                graphQLClient/* default.request */.Z.request(ALL_CONVERSIONS_QUERY, includes).then(function(data) {
                    return trackingConversion_repository_hydrateObjects(data.conversions);
                })
            ];
        });
    }),
    useObject: function(id) {
        var includes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return (0,_object_spread/* default */.Z)({
                id: id
            }, includes);
        }, [
            id
        ]);
        var ref = (0,dist/* default */.ZP)([
            SINGLE_CONVERSION_QUERY,
            variables
        ], {
            revalidateOnFocus: false
        }), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            object: !data ? data : trackingConversion_repository_hydrateObject(data.conversion),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    useObjects: function() {
        var includes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
        var variables = (0,react.useMemo)(function() {
            return includes;
        }, []);
        var ref = (0,dist/* default */.ZP)([
            ALL_CONVERSIONS_QUERY,
            variables
        ]), data = ref.data, error = ref.error, mutate = ref.mutate;
        return {
            objects: !data ? data : trackingConversion_repository_hydrateObjects(data.conversions),
            isLoading: !error && !data,
            isError: error,
            mutate: mutate
        };
    },
    createObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(CREATE_CONVERSION_MUTATION, variables).then(function(data) {
                        return trackingConversion_repository_hydrateObject(data.conversion);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
            var includes, variables;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                includes = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
                variables = (0,_object_spread/* default */.Z)({
                    input: data
                }, includes);
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(UPDATE_CONVERSION_MUTATION, variables).then(function(data) {
                        return trackingConversion_repository_hydrateObject(data.conversion);
                    })
                ];
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(),
    deleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(DELETE_CONVERSION_MUTATION, variables).then(function(data) {
                        return data.deleteTrackingConversion;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(),
    forceDeleteObject: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
            var variables;
            return (0,tslib_es6.__generator)(this, function(_state) {
                variables = {
                    input: {
                        id: id
                    }
                };
                return [
                    2,
                    graphQLClient/* default.request */.Z.request(FORCE_DELETE_CONVERSION_MUTATION, variables).then(function(data) {
                        return data.forceDeleteTrackingConversion;
                    })
                ];
            });
        });
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }()
};
/* harmony default export */ var trackingConversion_repository = (trackingConversionRepository);

;// CONCATENATED MODULE: ./src/entities/trackingConversion/entity.ts


var trackingConversionEntity = {
    model: trackingConversion_model,
    repository: trackingConversion_repository
};
/* harmony default export */ var trackingConversion_entity = ((/* unused pure expression or super */ null && (trackingConversionEntity)));

// EXTERNAL MODULE: ./src/entities/partnerTenant/entity.ts + 3 modules
var partnerTenant_entity = __webpack_require__(67566);
;// CONCATENATED MODULE: ./src/entities/index.ts































































































































// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterPartnerHint/TravelFilterPartnerHint.tsx








var TravelFilterPartnerHint = function(param) {
    var trackingStringPrefix = param.trackingStringPrefix;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), crossLinkingPartnerTenants = ref[0], setCrossLinkingPartnerTenants = ref[1];
    (0,react.useEffect)(function() {
        var fetchTenant = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ownTenantId, data, ref, filteredPartners;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ownTenantId = "1";
                            return [
                                4,
                                tenant_entity/* default.repository.getObject */.Z.repository.getObject(ownTenantId, {
                                    withPartnerTenants: true,
                                    withPartnerTenantsTenant: true
                                })
                            ];
                        case 1:
                            data = _state.sent();
                            filteredPartners = ((ref = data === null || data === void 0 ? void 0 : data.partnerTenants) !== null && ref !== void 0 ? ref : []).filter(function(partner) {
                                var ref;
                                return (partner === null || partner === void 0 ? void 0 : partner.filterCrossLinking) && String(partner === null || partner === void 0 ? void 0 : (ref = partner.tenant) === null || ref === void 0 ? void 0 : ref.id) !== String(ownTenantId);
                            }).map(function(partner) {
                                var ref, ref1;
                                return {
                                    name: (ref = partner.tenant) === null || ref === void 0 ? void 0 : ref.name,
                                    domain: (ref1 = partner.tenant) === null || ref1 === void 0 ? void 0 : ref1.domain
                                };
                            }).filter(function(p) {
                                return p.name && p.domain;
                            });
                            setCrossLinkingPartnerTenants(filteredPartners);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchTenant() {
                return _ref.apply(this, arguments);
            };
        }();
        void fetchTenant();
    }, []);
    var buildUrl = function(domain) {
        var baseUrl = "https://".concat(domain, "/de/tours");
        var months = router.query.months;
        var params = new URLSearchParams();
        if (months) {
            params.set("months", months);
            // params.set('resetOnEmpty', '1')
            return "".concat(baseUrl, "?").concat(params.toString());
        } else {
            return baseUrl;
        }
    };
    var linkList = crossLinkingPartnerTenants.map(function(param) {
        var name = param.name, domain = param.domain;
        return '<a data-tr-click="'.concat(trackingStringPrefix, ':travel_partner:click" href="').concat(buildUrl(domain), '" target="_blank" rel="noopener noreferrer">').concat(name, "</a>");
    });
    var linkString = linkList.length === 1 ? linkList[0] : linkList.slice(0, -1).join(", ") + " oder " + linkList[linkList.length - 1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: crossLinkingPartnerTenants.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            dangerouslySetInnerHTML: {
                __html: t("travel.filter.crossLinkingHint", {
                    tenants: linkString
                })
            }
        })
    });
};
/* harmony default export */ var TravelFilterPartnerHint_TravelFilterPartnerHint = (TravelFilterPartnerHint);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterPartnerHint/index.ts


;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/TravelFilterResultList.tsx







var TravelFilterResultList = function(param) {
    var initialTravels = param.travels, _immutable = param.immutable, immutable = _immutable === void 0 ? false : _immutable, _className = param.className, className = _className === void 0 ? "" : _className, trackingStringPrefix = param.trackingStringPrefix;
    var filterState = (0,hooks/* useAppSelector */.C)(travelFilter/* selectTravelFilter */.$C);
    var ref = (0,react.useState)(initialTravels ? initialTravels : filterState.travels), travels = ref[0], setTravels = ref[1];
    (0,react.useEffect)(function() {
        if (!immutable) {
            setTravels(filterState.travels);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterState.travels
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: travels.map(function(travel, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        md: 6,
                        lg: 4,
                        xxl: 3,
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelResultItemTile_TravelResultItemTile, {
                            travel: travel,
                            trackingStringPrefix: trackingStringPrefix
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelFilterPartnerHint_TravelFilterPartnerHint, {
                trackingStringPrefix: trackingStringPrefix
            })
        ]
    });
};
/* harmony default export */ var TravelFilterResultList_TravelFilterResultList = (TravelFilterResultList);

;// CONCATENATED MODULE: ./src/components/models/travel/filter/TravelFilterResultList/index.tsx



/***/ }),

/***/ 32322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JS": function() { return /* reexport */ actions/* applyTravelFilterUrlQuery */.JS; },
  "Iv": function() { return /* reexport */ actions/* executeTravelFilterRequest */.Iv; },
  "zK": function() { return /* reexport */ actions/* initializeTravelFilter */.zK; },
  "t": function() { return /* reexport */ actions/* resetTravelFilter */.t; },
  "$C": function() { return /* reexport */ selectTravelFilter; },
  "Qw": function() { return /* reexport */ actions/* setInitialTravelFilterResponse */.Qw; },
  "fo": function() { return /* reexport */ actions/* setTravelFilterQuery */.fo; },
  "rL": function() { return /* reexport */ actions/* setTravelFilterSelection */.rL; }
});

// UNUSED EXPORTS: travelFilterReducer, travelFilterSelector

// EXTERNAL MODULE: ./src/features/travelFilter/actions.ts
var actions = __webpack_require__(40135);
// EXTERNAL MODULE: ./src/features/travelFilter/reducer.ts
var reducer = __webpack_require__(16052);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/features/travelFilter/selectors.ts

var selectTravelFilter = function(state) {
    return state.travelFilter;
};
var travelFilterSelector = (0,es/* createSelector */.P1)(selectTravelFilter, function(state) {
    return state;
});

;// CONCATENATED MODULE: ./src/features/travelFilter/index.ts





/***/ }),

/***/ 33825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TeaserFlag_root__wOidx"};

/***/ }),

/***/ 56157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelFilterForm_root__QRzQE","inputSelectedCountBadge":"TravelFilterForm_inputSelectedCountBadge__SZch_","input":"TravelFilterForm_input__EneeE"};

/***/ }),

/***/ 989:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"TravelFilterInfoAndReset_resetBtn__cWS_B"};

/***/ }),

/***/ 30465:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fakeSelect":"FilterInput_fakeSelect__D29si","active":"FilterInput_active__Eui_K","filterOptionsWrap":"FilterInput_filterOptionsWrap__GxkTA"};

/***/ }),

/***/ 20794:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TravelResultItemTile_wrap__26jem","card":"TravelResultItemTile_card__WG1Rb","body":"TravelResultItemTile_body__SDr77","title":"TravelResultItemTile_title__yRv6X","date":"TravelResultItemTile_date__V0ysb","price":"TravelResultItemTile_price__1NIZT"};

/***/ })

}]);